




// // import React, { useState, useEffect, useRef } from 'react';
// // import axios from 'axios';
// // import Modal from 'react-modal';
// // import { FaPlus, FaMinus, FaTrash, FaPrint, FaDownload, FaCheck, FaTimes } from "react-icons/fa"; import { useNavigate } from 'react-router-dom';
// // import jsPDF from 'jspdf';
// // import html2canvas from 'html2canvas';
// // import "./MenuCartSidebar.css";

// // Modal.setAppElement('#root');

// // const MenuCartSidebar = () => {
// //     const navigate = useNavigate();
// //     const [cartData, setCartData] = useState({ cartItems: [] });
// //     const [quantities, setQuantities] = useState({});
// //     const [grandTotal, setGrandTotal] = useState(0);
// //     const [refresh, setRefresh] = useState(0);
// //     const [isModalOpen, setIsModalOpen] = useState(false);
// //     const [isHovered, setIsHovered] = useState(false);
// //     const [itemToRemove, setItemToRemove] = useState(null);
// //     const [showRemoveConfirm, setShowRemoveConfirm] = useState(false);
// //     const [userId, setUserId] = useState(localStorage.getItem("userId") || 3);
// //     const [loading, setLoading] = useState(false);
// //     const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
// //     const [savedDetails, setSavedDetails] = useState(null);
// //     const [vendorDetails, setVendorDetails] = useState({
// //         name: "",
// //         email: "",
// //         phone: ""
// //     });
// //     const vendorDetailsRef = useRef({
// //         name: "",
// //         email: "",
// //         phone: ""
// //     });
// //     const [showCashPopup, setShowCashPopup] = useState(false);
// //     const [notesCount, setNotesCount] = useState({});
// //     const [paidAmount, setPaidAmount] = useState('');
// //     const [screenWidth, setScreenWidth] = useState(window.innerWidth);
// //     const [showReceipt, setShowReceipt] = useState(false);
// //     const [orderData, setOrderData] = useState({});
// //     const [bannerData, setBannerData] = useState(null);
// //     const [isProcessingBack, setIsProcessingBack] = useState(false);
// //     const [isPrinting, setIsPrinting] = useState(false);
// //     const [isSubmittingCash, setIsSubmittingCash] = useState(false);
// //     const printRef = useRef();
// //     const receiptRef = useRef();
// //     // Add this with other useState declarations
// //     const [serviceChargeStatus, setServiceChargeStatus] = useState("NOT_APPLICABLE");
// //     const [isUpdatingServiceCharge, setIsUpdatingServiceCharge] = useState(false);

// //     // Add effect for screen resize
// //     useEffect(() => {
// //         const handleResize = () => setScreenWidth(window.innerWidth);
// //         window.addEventListener("resize", handleResize);
// //         return () => window.removeEventListener("resize", handleResize);
// //     }, []);
// //     // Add this function in your component
// //     const toggleServiceCharge = async () => {
// //         const token = localStorage.getItem("authToken");
// //         const cartId = localStorage.getItem("cartId");

// //         if (!token || !cartId) {
// //             alert("Unable to update service charge. Missing required data.");
// //             return;
// //         }

// //         const newStatus = serviceChargeStatus === "APPLICABLE" ? "NOT_APPLICABLE" : "APPLICABLE";

// //         setIsUpdatingServiceCharge(true);

// //         try {
// //             const response = await axios.put(
// //                 `https://backend.maamaas.com/food/api/cart/coupon/${cartId}`,
// //                 {
// //                     serviceCharge: newStatus
// //                 },
// //                 {
// //                     headers: {
// //                         Authorization: `Bearer ${token}`,
// //                         "Content-Type": "application/json"
// //                     }
// //                 }
// //             );

// //             if (response.status === 200) {
// //                 setServiceChargeStatus(newStatus);
// //                 // Refresh cart data to update charges
// //                 fetchCartData();
// //                 alert(`Service charge ${newStatus === "APPLICABLE" ? "applied" : "removed"} successfully`);
// //             }
// //         } catch (error) {
// //             console.error("Error updating service charge:", error);
// //             alert("Failed to update service charge. Please try again.");
// //         } finally {
// //             setIsUpdatingServiceCharge(false);
// //         }
// //     };

// //     useEffect(() => {
// //         // When order type changes to TAKEAWAY, automatically remove service charges
// //         if (cartData.orderType === 'TAKEAWAY' && serviceChargeStatus === "APPLICABLE") {
// //             const removeServiceChargesForTakeaway = async () => {
// //                 const token = localStorage.getItem("authToken");
// //                 const cartId = localStorage.getItem("cartId");

// //                 if (!token || !cartId) return;

// //                 setIsUpdatingServiceCharge(true);

// //                 try {
// //                     await axios.put(
// //                         `https://backend.maamaas.com/food/api/cart/coupon/${cartId}`,
// //                         {
// //                             serviceCharge: "NOT_APPLICABLE"
// //                         },
// //                         {
// //                             headers: {
// //                                 Authorization: `Bearer ${token}`,
// //                                 "Content-Type": "application/json"
// //                             }
// //                         }
// //                     );

// //                     setServiceChargeStatus("NOT_APPLICABLE");
// //                     await fetchCartData(); // Refresh cart to update totals
// //                     console.log("✅ Service charges removed for Takeaway order");
// //                 } catch (error) {
// //                     console.error("Failed to remove service charges for Takeaway:", error);
// //                 } finally {
// //                     setIsUpdatingServiceCharge(false);
// //                 }
// //             };

// //             removeServiceChargesForTakeaway();
// //         }
// //     }, [cartData.orderType, serviceChargeStatus]);
// //     // Fetch vendor details
// //     const fetchVendorDetails = async () => {
// //         const vendorId = localStorage.getItem("vendorId");
// //         const token = localStorage.getItem("authToken");

// //         if (!vendorId || !token) return;

// //         try {
// //             // ✅ USE THE SAME ENDPOINT AS MANAGEMENT5
// //             const response = await axios.get(
// //                 `https://backend.maamaas.com/food/api/vendors/${vendorId}`,
// //                 {
// //                     headers: { Authorization: `Bearer ${token}` }
// //                 }
// //             );

// //             if (response.data) {
// //                 const vendorData = response.data;

// //                 // ✅ EXACT SAME LOGIC AS MANAGEMENT5
// //                 const vendorMobile =
// //                     vendorData?.mobileNumber && vendorData.mobileNumber.toString().trim() !== ""
// //                         ? vendorData.mobileNumber.toString()
// //                         : "9999999999";

// //                 const vendorName =
// //                     vendorData?.ownerName && vendorData.ownerName.trim() !== ""
// //                         ? vendorData.ownerName
// //                         : "Vendor";

// //                 const vendorEmail =
// //                     vendorData?.email && vendorData.email.trim() !== ""
// //                         ? vendorData.email
// //                         : "vendor@example.com";

// //                 setVendorDetails({
// //                     name: vendorName,
// //                     email: vendorEmail,
// //                     phone: vendorMobile  // ✅ This will be used in payment
// //                 });

// //                 console.log("✅ Vendor details fetched:", { vendorMobile, vendorName, vendorEmail });
// //             }
// //         } catch (error) {
// //             console.error("❌ Error fetching vendor details:", error);

// //             // ✅ Use same fallback as Management5
// //             setVendorDetails({
// //                 name: "Vendor",
// //                 email: "vendor@example.com",
// //                 phone: "9999999999"  // Same fallback number
// //             });
// //         }

// //         console.log("Vendor phone for payment:", vendorDetails.phone);
// //     };


// //     useEffect(() => {
// //         fetchCartData();
// //         fetchVendorDetails();  // ✅ ADD THIS LINE
// //         fetchBannerData();
// //     }, [refresh]);

// //     const loadRazorpayScript = () => {
// //         return new Promise((resolve) => {
// //             const script = document.createElement('script');
// //             script.src = "https://checkout.razorpay.com/v1/checkout.js";
// //             script.onload = () => resolve(true);
// //             script.onerror = () => resolve(false);
// //             document.body.appendChild(script);
// //         });
// //     };

// //     const fetchOrderDetails = async (orderId) => {
// //         try {
// //             const authToken = localStorage.getItem("authToken");
// //             if (!authToken) {
// //                 console.error("❌ No auth token found in localStorage");
// //                 return;
// //             }

// //             const response = await axios.get(
// //                 `https://backend.maamaas.com/food/api/orders/order/${orderId}`,
// //                 {
// //                     headers: {
// //                         "Authorization": `Bearer ${authToken}`,
// //                         "Content-Type": "application/json",
// //                     },
// //                 }
// //             );

// //             if (response.status === 200) {
// //                 setOrderData(response.data);
// //                 return response.data;
// //             }
// //         } catch (error) {
// //             console.error("❌ Failed to fetch order details:", error.response?.data || error.message);
// //         }
// //     };

// //     const fetchBannerData = async () => {
// //         const vendorId = localStorage.getItem("vendorId");
// //         if (!vendorId) return;

// //         try {
// //             const token = localStorage.getItem("authToken");
// //             const response = await axios.get(
// //                 `https://backend.maamaas.com/food/banner/vendor/${vendorId}`,
// //                 {
// //                     headers: { Authorization: `Bearer ${token}` }
// //                 }
// //             );

// //             setBannerData({
// //                 ...response.data,
// //                 companyName: response.data.companyName || "MAAMAAS HOUSE",
// //             });
// //         } catch (err) {
// //             console.error("Error fetching banner data:", err);
// //         }
// //     };
// //     // const triggerFullRefresh = () => {
// //     //     // Trigger refresh for all components
// //     //     setRefresh(prev => prev + 1);

// //     //     // Dispatch a custom event for other components to listen to
// //     //     const event = new CustomEvent('fullRefresh');
// //     //     window.dispatchEvent(event);

// //     //     // Also force fetch cart data
// //     //     fetchCartData();
// //     // };
// //     useEffect(() => {
// //         fetchVendorDetails();
// //     }, []);

// //     const handlePlaceOrder = async (paymentMethodParam = null) => {
// //         const vendorId = localStorage.getItem("vendorId");
// //         const token = localStorage.getItem("authToken");
// //         const cartId = localStorage.getItem("cartId");

// //         if (!userId) {
// //             alert("User ID not found. Please log in again.");
// //             return;
// //         }

// //         const paymentMethod = paymentMethodParam || selectedPaymentMethod;

// //         if (!paymentMethod) {
// //             alert("Please select a payment method");
// //             return;
// //         }

// //         try {
// //             localStorage.removeItem("orderId");

// //             if (paymentMethod === "Online_Payment") {
// //                 try {
// //                     const isRazorpayLoaded = await loadRazorpayScript();
// //                     if (!isRazorpayLoaded) {
// //                         alert("❌ Razorpay SDK failed to load.");
// //                         setLoading(false);
// //                         return;
// //                     }

// //                     const amountInPaise = Math.round(grandTotal * 100);
// //                     const displayAmount = amountInPaise / 100;

// //                     const orderResponse = await fetch(
// //                         "https://backend.maamaas.com/food/api/payments/create-order",
// //                         {
// //                             method: "POST",
// //                             headers: {
// //                                 "Content-Type": "application/json",
// //                                 Authorization: `Bearer ${token}`,
// //                             },
// //                             body: JSON.stringify({
// //                                 amount: displayAmount,
// //                                 phoneNumber: vendorDetails.phone,
// //                                 currency: "INR",
// //                                 receipt: `order_${Date.now()}`,
// //                                 notes: {
// //                                     customer_name: vendorDetails.name,
// //                                     order_reference: `WEB_ORDER_${Math.floor(Math.random() * 10000)}`,
// //                                 },
// //                             }),
// //                         }
// //                     );

// //                     if (!orderResponse.ok) throw new Error("❌ Failed to create Razorpay order");
// //                     const orderData = await orderResponse.json();

// //                     const options = {
// //                         key: "rzp_live_RU5whSMu9rPV7s",
// //                         amount: amountInPaise,
// //                         currency: "INR",
// //                         order_id: orderData.orderId,
// //                         name: "Maamaa's House",
// //                         description: "Order Payment",
// //                         // In the Razorpay options:
// //                         prefill: {
// //                             name: vendorDetails.name,
// //                             email: vendorDetails.email,
// //                             contact: vendorDetails.phone,  // ✅ This now has the vendor's mobile
// //                         },
// //                         theme: { color: "#3399cc" },

// //                         handler: async function (response) {
// //                             try {
// //                                 const capturePayload = {
// //                                     paymentId: response.razorpay_payment_id,
// //                                     amount: amountInPaise / 100,
// //                                     currency: "INR",
// //                                     receipt: `receipt_${Date.now()}`,
// //                                 };


// //                                 const captureRes = await fetch(
// //                                     "https://backend.maamaas.com/food/api/payments/capture",
// //                                     {
// //                                         method: "POST",
// //                                         headers: {
// //                                             "Content-Type": "application/json",
// //                                             Authorization: `Bearer ${token}`,
// //                                         },
// //                                         body: JSON.stringify(capturePayload),
// //                                     }
// //                                 );

// //                                 const captureData = await captureRes.json();

// //                                 if (!captureRes.ok || captureData.status !== "captured") {
// //                                     alert("❌ Payment capture failed!");
// //                                     return;
// //                                 }

// //                                 const backendOrderParams = {
// //                                     vendorId: vendorId,
// //                                     paymentMethod: "Online_Payment",
// //                                     razorpayPaymentId: response.razorpay_payment_id,
// //                                     razorpayOrderId: 1,
// //                                     phoneNumber: vendorDetails.phone,  // ✅ Use the fetched vendor phone
// //                                 };

// //                                 const responseOrder = await axios.post(
// //                                     `https://backend.maamaas.com/food/api/orders/orders/vendor/create/${cartId}`,
// //                                     "",
// //                                     {
// //                                         params: backendOrderParams,
// //                                         headers: { Authorization: `Bearer ${token}` },
// //                                         validateStatus: false,
// //                                     }
// //                                 );

// //                                 if (responseOrder.status === 200 || responseOrder.status === 201) {
// //                                     const orderId = responseOrder.data.orderId;
// //                                     localStorage.setItem("orderId", orderId);

// //                                     const orderDetails = await fetchOrderDetails(orderId);
// //                                     if (orderDetails) {
// //                                         // Set payment method to Online_Payment for auto-print
// //                                         orderDetails.paymentMethod = "Online_Payment";
// //                                         setOrderData(orderDetails);
// //                                         setShowReceipt(true);
// //                                         fetchBannerData();

// //                                         // Clear cart data
// //                                         setCartData({ cartItems: [] });
// //                                         setQuantities({});
// //                                         setGrandTotal(0);
// //                                         setSelectedPaymentMethod("");

// //                                         // ✅ AUTO-REFRESH: Trigger full page refresh after 2 seconds
// //                                         setTimeout(() => {
// //                                             window.location.reload();
// //                                         }, 20000);

// //                                         // ✅ Trigger cart refresh for other components
// //                                         triggerCartRefresh();
// //                                         triggerFullRefresh();
// //                                     }
// //                                 } else {
// //                                     alert("❌ Order creation failed after payment!");
// //                                 }

// //                             } catch (err) {
// //                                 alert("❌ Something went wrong after payment.");
// //                             }
// //                         },
// //                     };

// //                     const paymentObject = new window.Razorpay(options);
// //                     paymentObject.open();
// //                     return;
// //                 } catch (err) {
// //                     alert("❌ Razorpay flow failed.");
// //                     setLoading(false);
// //                     return;
// //                 }
// //             }

// //             // Cash Payment Flow - Modified to stay in sidebar

// //             const cashParams = {
// //                 vendorId,
// //                 paymentMethod: "Cash"
// //             };

// //             const cashRes = await axios.post(
// //                 `https://backend.maamaas.com/food/api/orders/orders/vendor/create/${cartId}`,
// //                 "",
// //                 {
// //                     params: cashParams,
// //                     headers: { Authorization: `Bearer ${token}` }
// //                 }
// //             );

// //             if (cashRes.data.orderId) {
// //                 const orderId = cashRes.data.orderId;
// //                 localStorage.setItem("orderId", orderId);

// //                 // Don't navigate, just show cash popup
// //                 setShowCashPopup(true);
// //                 setPaidAmount(grandTotal.toFixed(2));

// //                 alert("Order created! Please enter cash payment details.");

// //             } else {
// //                 alert("⚠️ Cash Order creation failed");
// //             }

// //         } catch (error) {
// //             console.error("🚨 Checkout Error:", error);
// //             alert("Failed to proceed to checkout.");
// //         }
// //     };






// //     useEffect(() => {
// //         const handleFullRefresh = () => {
// //             fetchCartData();
// //             setRefresh(prev => prev + 1);
// //         };

// //         window.addEventListener('fullRefresh', handleFullRefresh);

// //         return () => {
// //             window.removeEventListener('fullRefresh', handleFullRefresh);
// //         };
// //     }, []);
// //     // Check for pending receipt on mount
// //     useEffect(() => {
// //         const checkPendingReceipt = async () => {
// //             const showReceiptFlag = localStorage.getItem("showReceipt");
// //             const receiptOrderId = localStorage.getItem("receiptOrderId");
// //             const receiptTimestamp = localStorage.getItem("receiptTimestamp");
// //             const currentTime = Date.now();

// //             if (showReceiptFlag === "true" && receiptOrderId) {
// //                 // Check if receipt is recent (less than 5 minutes old)
// //                 if (!receiptTimestamp || (currentTime - parseInt(receiptTimestamp)) < 5 * 60 * 1000) {
// //                     try {
// //                         const orderDetails = await fetchOrderDetails(receiptOrderId);
// //                         if (orderDetails) {
// //                             setOrderData(orderDetails);
// //                             setShowReceipt(true);
// //                             await fetchBannerData();
// //                         }
// //                     } catch (err) {
// //                         console.error("Error showing pending receipt:", err);
// //                     }
// //                 } else {
// //                     // Clear old receipt data
// //                     localStorage.removeItem("showReceipt");
// //                     localStorage.removeItem("receiptOrderId");
// //                     localStorage.removeItem("receiptOrderData");
// //                     localStorage.removeItem("receiptTimestamp");
// //                 }
// //             }
// //         };

// //         checkPendingReceipt();
// //     }, []);

// //     const handlePaymentMethodChange = async (method) => {
// //         setSelectedPaymentMethod(method);

// //         if (method === "Online_Payment") {
// //             await handlePlaceOrder(method);
// //         }

// //         if (method === "Cash") {
// //             // Show cash popup immediately for cash payment
// //             setShowCashPopup(true);
// //             setPaidAmount(grandTotal.toFixed(2));
// //         }
// //     };

// //     const handleNotesChange = (denomination, count) => {
// //         if (count === '' || /^[0-9\b]+$/.test(count)) {
// //             setNotesCount((prev) => {
// //                 const newNotesCount = {
// //                     ...prev,
// //                     [denomination]: count,
// //                 };

// //                 let totalFromDenominations = 0;
// //                 Object.keys(newNotesCount).forEach(denom => {
// //                     const noteCount = parseInt(newNotesCount[denom]) || 0;
// //                     totalFromDenominations += noteCount * parseInt(denom);
// //                 });

// //                 if (totalFromDenominations > 0) {
// //                     setPaidAmount(totalFromDenominations.toFixed(2));
// //                 }

// //                 return newNotesCount;
// //             });
// //         }
// //     };

// //     const handleCashPaymentSubmit = async () => {
// //         const token = localStorage.getItem("authToken");
// //         const vendorId = localStorage.getItem("vendorId");
// //         const cartId = localStorage.getItem("cartId");

// //         if (!token || !vendorId || !cartId) {
// //             alert("Authentication error. Please try again.");
// //             return;
// //         }

// //         const paid = parseFloat(paidAmount);
// //         if (isNaN(paid) || paid <= 0) {
// //             alert("Please enter a valid paid amount.");
// //             return;
// //         }

// //         if (paid < grandTotal) {
// //             alert(`Paid amount (₹${paid.toFixed(2)}) is less than the grand total (₹${grandTotal.toFixed(2)}).`);
// //             return;
// //         }

// //         setIsSubmittingCash(true);

// //         const returnMoney = parseFloat((paid - grandTotal).toFixed(2));

// //         // Get current date in YYYY-MM-DD format
// //         const currentDate = new Date().toISOString().split('T')[0];

// //         const cashPaymentData = {
// //             id: 0,
// //             orderId: 0,
// //             oneRupee: parseInt(notesCount[1] || 0),
// //             twoRupee: parseInt(notesCount[2] || 0),
// //             fiveRupee: parseInt(notesCount[5] || 0),
// //             tenRupee: parseInt(notesCount[10] || 0),
// //             twentyRupee: parseInt(notesCount[20] || 0),
// //             fiftyRupee: parseInt(notesCount[50] || 0),
// //             hundredRupee: parseInt(notesCount[100] || 0),
// //             twoHundredRupee: parseInt(notesCount[200] || 0),
// //             fiveHundredRupee: parseInt(notesCount[500] || 0),
// //             twoThousandRupee: 0,
// //             grandTotal: grandTotal,
// //             paid: paid,
// //             returnMoney: returnMoney,
// //             date: currentDate, // Just add this line - date in YYYY-MM-DD format
// //         };

// //         try {
// //             // First create the order
// //             const orderResponse = await axios.post(
// //                 `https://backend.maamaas.com/food/api/orders/orders/vendor/create/${cartId}`,
// //                 "",
// //                 {
// //                     params: {
// //                         vendorId,
// //                         paymentMethod: "Cash"
// //                     },
// //                     headers: { Authorization: `Bearer ${token}` }
// //                 }
// //             );

// //             if (orderResponse.data.orderId) {
// //                 const orderId = orderResponse.data.orderId;
// //                 cashPaymentData.orderId = orderId;

// //                 // Submit cash payment details
// //                 await axios.post(
// //                     `https://backend.maamaas.com/food/api/cash-billing/addCash/${orderId}`,
// //                     cashPaymentData,
// //                     {
// //                         headers: {
// //                             Authorization: `Bearer ${token}`,
// //                             "Content-Type": "application/json",
// //                         },
// //                     }
// //                 );

// //                 // ✅ NEW: Update payment status to PAID
// //                 try {
// //                     // Assuming the API endpoint is like this (you might need to adjust the endpoint)
// //                     await axios.put(
// //                         `https://backend.maamaas.com/food/api/payments/update-status/${orderId}`,
// //                         { paymentStatus: "PAID" }, // or just "PAID" as string if that's what the API expects
// //                         {
// //                             headers: {
// //                                 Authorization: `Bearer ${token}`,
// //                                 "Content-Type": "application/json",
// //                             },
// //                         }
// //                     );
// //                 } catch (statusError) {
// //                     console.error("⚠️ Failed to update payment status:", statusError);
// //                     // Don't fail the entire process if status update fails
// //                     // The payment is still successful, just the status might not be updated
// //                 }

// //                 // Fetch order details and show receipt in sidebar
// //                 const orderDetails = await fetchOrderDetails(orderId);
// //                 if (orderDetails) {
// //                     // Clear cart data locally
// //                     setCartData({ cartItems: [] });
// //                     setQuantities({});
// //                     setGrandTotal(0);
// //                     setSelectedPaymentMethod("");

// //                     // Fetch banner data for receipt
// //                     await fetchBannerData();

// //                     // Show receipt in sidebar
// //                     setOrderData(orderDetails);
// //                     setShowReceipt(true);

// //                     // Close cash popup
// //                     setShowCashPopup(false);
// //                     setNotesCount({});
// //                     setPaidAmount('');

// //                     // ✅ AUTO-REFRESH: Trigger full page refresh after 2 seconds
// //                     setTimeout(() => {
// //                         window.location.reload();
// //                     }, 20000);

// //                     // ✅ Also trigger cart refresh for other components immediately
// //                     triggerCartRefresh();
// //                     triggerFullRefresh();
// //                 } else {
// //                     alert("⚠️ Payment submitted but couldn't fetch order details.");
// //                 }
// //             }
// //         } catch (error) {
// //             console.error("Cash payment error:", error);
// //             alert("Failed to process cash payment.");
// //         } finally {
// //             setIsSubmittingCash(false);
// //         }
// //     };
// //     // Auto-print effect for cash receipts
// //     // Auto-print effect for receipts (both Cash and Online Payment)
// //     useEffect(() => {
// //         // Only auto-print when receipt is shown and order data is available
// //         if (showReceipt && orderData.orderId && !isPrinting) {
// //             // Check if we've already printed this receipt
// //             const hasPrintedKey = `hasPrinted_${orderData.orderId}`;
// //             const hasPrinted = localStorage.getItem(hasPrintedKey);

// //             // Determine payment method for auto-print
// //             const isCashPayment = orderData.paymentMethod === "Cash";
// //             const isOnlinePayment = orderData.paymentMethod === "Online_Payment";

// //             // Auto-print for both payment methods
// //             if ((isCashPayment || isOnlinePayment) && !hasPrinted) {
// //                 // Set a flag to prevent re-printing
// //                 localStorage.setItem(hasPrintedKey, 'true');

// //                 // Wait a bit for the DOM to fully render
// //                 const printTimer = setTimeout(() => {
// //                     if (printRef.current) {
// //                         handlePrint();
// //                     }
// //                 }, 1000); // Increased delay for better rendering

// //                 return () => clearTimeout(printTimer);
// //             } else if (hasPrinted) {
// //             }
// //         }
// //     }, [showReceipt, orderData, isPrinting]);

// //     const fetchCartData = async () => {
// //         const vendorId = localStorage.getItem("vendorId");
// //         const authToken = localStorage.getItem("authToken");

// //         if (!vendorId || !authToken) return;

// //         try {
// //             const response = await axios.get(
// //                 `https://backend.maamaas.com/food/api/cart/vendor/${vendorId}`,
// //                 { headers: { Authorization: `Bearer ${authToken}` } }
// //             );

// //             if (response.data) {
// //                 const data = response.data;
// //                 setCartData(data);
// //                 setGrandTotal(data.grandTotal || 0);

// //                 if (data.cartId) {
// //                     localStorage.setItem("cartId", data.cartId);
// //                 }
// //                 if (data.serviceCharges > 0) {
// //                     setServiceChargeStatus("APPLICABLE");
// //                 } else {
// //                     setServiceChargeStatus("NOT_APPLICABLE");
// //                 }

// //                 const updatedQuantities = (data.cartItems || []).reduce((acc, item) => {
// //                     acc[item.dishId] = item.quantity || 1;
// //                     return acc;
// //                 }, {});
// //                 setQuantities(updatedQuantities);
// //             }
// //         } catch (err) {
// //             console.error("Error fetching cart data:", err);
// //         }
// //     };

// //     const closeReceipt = () => {
// //         if (isProcessingBack) return;

// //         setIsProcessingBack(true);

// //         // Clear all receipt flags from localStorage
// //         localStorage.removeItem("showReceipt");
// //         localStorage.removeItem("receiptOrderId");
// //         localStorage.removeItem("receiptOrderData");
// //         localStorage.removeItem("receiptTimestamp");
// //         localStorage.removeItem("pendingReceiptShow");
// //         localStorage.removeItem("pendingReceiptOrderId");
// //         localStorage.removeItem("pendingReceiptPaymentMethod");

// //         // Clear the printed flag for this order
// //         if (orderData?.orderId) {
// //             localStorage.removeItem(`hasPrinted_${orderData.orderId}`);
// //         }

// //         // Hide receipt
// //         setShowReceipt(false);
// //         setOrderData({});

// //         // Fetch fresh cart data
// //         fetchCartData();

// //         // Trigger cart refresh for other components
// //         triggerCartRefresh();

// //         // Reset processing flag after delay
// //         setTimeout(() => {
// //             setIsProcessingBack(false);
// //         }, 500);
// //     };

// //     // const handlePrint = () => {
// //     //     // Check for order data (important for auto-print)
// //     //     if (!orderData || !orderData.orderId) {
// //     //         console.error("No order data available for printing");
// //     //         return;
// //     //     }

// //     //     // Store original content (only needed for manual print)
// //     //     const originalContent = document.body.innerHTML;

// //     //     const printStyles = `
// //     // <style>
// //     // @media print {
// //     //     body {
// //     //         width: 80mm !important;
// //     //         margin: 0 auto !important;
// //     //         padding: 0 !important;
// //     //         font-family: "Courier New", monospace !important;
// //     //         font-size: 10px !important;
// //     //         line-height: 1.2 !important;
// //     //         font-weight:900 !important;
// //     //     }

// //     //     h1, h2, h3 {
// //     //         font-weight: bold;
// //     //         text-align: center;
// //     //         margin: 0;
// //     //         padding: 0;
// //     //     }

// //     //     .big-title {
// //     //         font-size: 14px !important;
// //     //         font-weight: bold;
// //     //         text-align: center;
// //     //         margin-bottom: 5px;
// //     //     }

// //     //     .center-text {
// //     //         text-align: center;
// //     //         font-size: 10px;
// //     //         font-weight: bold;
// //     //     }

// //     //     .line {
// //     //         border-top: 1px solid black;
// //     //         margin: 6px 0;
// //     //     }

// //     //     .dashed {
// //     //         border-top: 1px dashed black;
// //     //         margin: 6px 0;
// //     //     }

// //     //     table {
// //     //         width: 100%;
// //     //         font-size: 10px;
// //     //         border-collapse: collapse;
// //     //     }

// //     //     th{
// //     //         padding: 0px 0px;
// //     //         font-weight: bold;
// //     //     }
// //     //     td { 
// //     //         padding: 2px 0px;
// //     //         font-weight: bold;
// //     //     }

// //     //     .row {
// //     //         display: flex;
// //     //         justify-content: space-around;
// //     //         font-size: 10px;
// //     //         font-weight: bold;
// //     //         white-space: nowrap;
// //     //         width: 100%;

// //     //     }

// //     //     .grand-label {
// //     //         font-size: 16px;
// //     //         font-weight: bold;
// //     //     }

// //     //     .grand-value {
// //     //         font-size: 16px;
// //     //         font-weight: bold;
// //     //     }

// //     //     .footer {
// //     //         text-align: center;
// //     //         margin-top: 10px;
// //     //         font-size: 10px;
// //     //     }

// //     //     .receipt-buttons, button {
// //     //         display: none !important;
// //     //     }

// //     //     @page {
// //     //         size: 80mm auto;
// //     //         margin: 0;
// //     //     }

// //     //     .page-break {
// //     //         page-break-after: always;
// //     //     }
// //     // }
// //     // </style>
// //     // `;

// //     //     // SIMPLE RECEIPT (Top Image) - HARDCODED "Take A Break"
// //     //     const receiptOne = `
// //     //     <div class="big-title">Take A Break</div>
// //     //     <div class="line"></div>

// //     //     <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
// //     //     <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>

// //     //     <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

// //     //     <div class="line"></div>

// //     //     <table>
// //     //         <thead>
// //     //             <tr>
// //     //                 <th style="text-align:center;">Item</th>
// //     //                 <th style="text-align:center;">Qty</th>
// //     //             </tr>
// //     //         </thead>
// //     //         <tbody>
// //     //             ${Array.isArray(orderData.order) ? orderData.order.map(item => `
// //     //                 <tr>
// //     //                     <td style="text-align:center;">${item.dishName || "Item"}</td>
// //     //                     <td style="text-align:center;">${item.quantity || 1}</td>
// //     //                 </tr>
// //     //             `).join("") : ""}
// //     //         </tbody>
// //     //     </table>

// //     //     <div class="line"></div>
// //     // `;

// //     //     // DETAILED RECEIPT (Bottom Image) - HARDCODED "Take A Break"
// //     //     const receiptTwo = `
// //     //     <div class="big-title">Take A Break</div>
// //     //     <div class="center-text">GSTIN: ${orderData?.vendorGstIn || "N/A"}</div>
// //     //     <div class="line"></div>

// //     //     <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
// //     //     <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>
// //     //     <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

// //     //     <div class="line"></div>

// //     //     <table class="items-table">
// //     //         <thead>
// //     //             <tr>
// //     //                 <th style="text-align:center;">Item</th>
// //     //                 <th style="text-align:center;">Qty</th>
// //     //                 <th style="text-align:center;">Price</th>
// //     //                 <th style="text-align:center;">Total</th>
// //     //             </tr>
// //     //         </thead>
// //     //         <tbody>
// //     //             ${Array.isArray(orderData.order) ? orderData.order.map(item => `
// //     //                 <tr>
// //     //                     <td style="text-align:center;">${item.dishName || "Item"}</td>
// //     //                     <td style="text-align:center;">${item.quantity || 1}</td>
// //     //                     <td style="text-align:center;">₹${(item.price || 0).toFixed(2)}</td>
// //     //                     <td style="text-align:center;">₹${((item.price || 0) * (item.quantity || 1)).toFixed(2)}</td>
// //     //                 </tr>
// //     //             `).join("") : ""}
// //     //         </tbody>
// //     //     </table>

// //     //     <div class="line"></div>

// //     //     <div class="row"><span>SubTotal</span><span>₹${(orderData.subTotal || 0).toFixed(2)}</span></div>
// //     //     <div class="row"><span>Platform</span><span>₹${(orderData.platformCharges || 0).toFixed(2)}</span></div>
// //     //     <div class="row"><span>Service</span><span>₹${(orderData.serviceCharge || 0).toFixed(2)}</span></div>
// //     //     <div class="row"><span>CGST</span><span>₹${(orderData.cgst || 0).toFixed(2)}</span></div>
// //     //     <div class="row"><span>SGST</span><span>₹${(orderData.sgst || 0).toFixed(2)}</span></div>

// //     //     <div class="line"></div>

// //     //     <div class="row">
// //     //         <span class="grand-label">Grand Total</span>
// //     //         <span class="grand-value">₹${(orderData.grandTotal || 0).toFixed(2)}</span>
// //     //     </div>

// //     //     <div class="dashed"></div>
// //     //     <div class="center-text">FSSAI: ${orderData?.vendorFssai || "23624032003384"}</div>

// //     //     <div class="footer">
// //     //         Thank you, visit again<br/>
// //     //         www.maamaas.com
// //     //     </div>
// //     // `;

// //     //     // FINAL PRINT CONTENT
// //     //     const finalHTML = `
// //     //     <!DOCTYPE html>
// //     //     <html>
// //     //     <head>
// //     //         <title>Receipt - ${orderData.orderId || 'Order'}</title>
// //     //         ${printStyles}
// //     //     </head>
// //     //     <body>
// //     //         ${receiptOne}
// //     //         <div class="page-break"></div>
// //     //         ${receiptTwo}
// //     //     </body>
// //     //     </html>
// //     // `;

// //     //     try {
// //     //         const printWindow = window.open('', '_blank', 'width=800,height=600');
// //     //         printWindow.document.open();
// //     //         printWindow.document.write(finalHTML);
// //     //         printWindow.document.close();

// //     //         printWindow.onload = () => {
// //     //             printWindow.print();

// //     //             // Listen for afterprint event
// //     //             printWindow.onafterprint = () => {
// //     //                 setTimeout(() => {
// //     //                     printWindow.close();

// //     //                     // AUTO-REFRESH: Only for manual prints, not auto-prints
// //     //                     // Check if we're in auto-print mode by seeing if receipt is showing
// //     //                     if (showReceipt) {
// //     //                         // This is auto-print - don't refresh, let auto-print handle closing
// //     //                         console.log("Auto-print completed, not refreshing");
// //     //                     } else {
// //     //                         // This is manual print - refresh the page
// //     //                         window.location.reload();
// //     //                     }
// //     //                 }, 500);
// //     //             };

// //     //             // Fallback in case afterprint doesn't fire
// //     //             setTimeout(() => {
// //     //                 printWindow.close();

// //     //                 // Same logic: only refresh for manual prints
// //     //                 if (!showReceipt) {
// //     //                     window.location.reload();
// //     //                 }
// //     //             }, 3000);
// //     //         };

// //     //         // Only restore original content for MANUAL prints
// //     //         // Auto-print doesn't need this since we're not modifying the page
// //     //         if (!showReceipt) {
// //     //             document.body.innerHTML = originalContent;
// //     //         }

// //     //     } catch (error) {
// //     //         console.error("Print error:", error);
// //     //         // Restore page on error
// //     //         if (!showReceipt) {
// //     //             document.body.innerHTML = originalContent;
// //     //         }
// //     //     }
// //     // };
// //     const handlePrint = () => {
// //         // Check for order data (important for auto-print)
// //         if (!orderData || !orderData.orderId) {
// //             console.error("No order data available for printing");
// //             return;
// //         }

// //         // Store original content (only needed for manual print)
// //         const originalContent = document.body.innerHTML;

// //         const printStyles = `
// //     <style>
// //     @media print {
// //         body {
// //             width: 80mm !important;
// //             margin: 0 auto !important;
// //             padding: 0 !important;
// //             font-family: "Courier New", monospace !important;
// //             font-size: 10px !important;
// //             line-height: 1.2 !important;
// //             font-weight:900 !important;
// //         }

// //         h1, h2, h3 {
// //             font-weight: bold;
// //             text-align: center;
// //             margin: 0;
// //             padding: 0;
// //         }

// //         .big-title {
// //             font-size: 14px !important;
// //             font-weight: bold;
// //             text-align: center;
// //             margin-bottom: 5px;
// //         }

// //         .center-text {
// //             text-align: center;
// //             font-size: 10px;
// //             font-weight: bold;
// //         }

// //         .line {
// //             border-top: 1px solid black;
// //             margin: 6px 0;
// //         }

// //         .dashed {
// //             border-top: 1px dashed black;
// //             margin: 6px 0;
// //         }

// //         table {
// //             width: 100%;
// //             font-size: 10px;
// //             border-collapse: collapse;
// //         }

// //         th{
// //             padding: 0px 0px;
// //             font-weight: bold;
// //         }
// //         td { 
// //             padding: 2px 0px;
// //             font-weight: bold;
// //         }

// //         .row {
// //             display: flex;
// //             justify-content: space-around;
// //             font-size: 10px;
// //             font-weight: bold;
// //             white-space: nowrap;
// //             width: 100%;

// //         }

// //         .grand-label {
// //             font-size: 16px;
// //             font-weight: bold;
// //         }

// //         .grand-value {
// //             font-size: 16px;
// //             font-weight: bold;
// //         }

// //         .footer {
// //             text-align: center;
// //             margin-top: 10px;
// //             font-size: 10px;
// //         }

// //         .receipt-buttons, button {
// //             display: none !important;
// //         }

// //         @page {
// //             size: 80mm auto;
// //             margin: 0;
// //         }

// //         .page-break {
// //             page-break-after: always;
// //         }
// //     }
// //     </style>
// //     `;

// //         // SIMPLE RECEIPT (Top Image) - HARDCODED "Take A Break"
// //         const receiptOne = `
// //         <div class="big-title">Take A Break</div>
// //         <div class="line"></div>

// //         <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
// //         <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>

// //         <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

// //         <div class="line"></div>

// //         <table>
// //             <thead>
// //                 <tr>
// //                     <th style="text-align:center;">Item</th>
// //                     <th style="text-align:center;">Qty</th>
// //                 </tr>
// //             </thead>
// //             <tbody>
// //                 ${Array.isArray(orderData.order) ? orderData.order.map(item => `
// //                     <tr>
// //                         <td style="text-align:center;">${item.dishName || "Item"}</td>
// //                         <td style="text-align:center;">${item.quantity || 1}</td>
// //                     </tr>
// //                 `).join("") : ""}
// //             </tbody>
// //         </table>

// //         <div class="line"></div>
// //     `;

// //         // DETAILED RECEIPT (Bottom Image) - HARDCODED "Take A Break"
// //         const receiptTwo = `
// //         <div class="big-title">Take A Break</div>
// //         <div class="center-text">GSTIN: ${orderData?.vendorGstIn || "N/A"}</div>
// //         <div class="line"></div>

// //         <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
// //         <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>
// //         <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

// //         <div class="line"></div>

// //         <table class="items-table">
// //             <thead>
// //                 <tr>
// //                     <th style="text-align:center;">Item</th>
// //                     <th style="text-align:center;">Qty</th>
// //                     <th style="text-align:center;">Price</th>
// //                     <th style="text-align:center;">Total</th>
// //                 </tr>
// //             </thead>
// //             <tbody>
// //                 ${Array.isArray(orderData.order) ? orderData.order.map(item => `
// //                     <tr>
// //                         <td style="text-align:center;">${item.dishName || "Item"}</td>
// //                         <td style="text-align:center;">${item.quantity || 1}</td>
// //                         <td style="text-align:center;">₹${(item.price || 0).toFixed(2)}</td>
// //                         <td style="text-align:center;">₹${((item.price || 0) * (item.quantity || 1)).toFixed(2)}</td>
// //                     </tr>
// //                 `).join("") : ""}
// //             </tbody>
// //         </table>

// //         <div class="line"></div>

// //         <div class="row"><span>SubTotal</span><span>₹${(orderData.subTotal || 0).toFixed(2)}</span></div>
// //         <div class="row"><span>Platform</span><span>₹${(orderData.platformCharges || 0).toFixed(2)}</span></div>
// //         <div class="row"><span>Service</span><span>₹${(orderData.serviceCharge || 0).toFixed(2)}</span></div>
// //         <div class="row"><span>CGST</span><span>₹${(orderData.cgst || 0).toFixed(2)}</span></div>
// //         <div class="row"><span>SGST</span><span>₹${(orderData.sgst || 0).toFixed(2)}</span></div>

// //         <div class="line"></div>

// //         <div class="row">
// //             <span class="grand-label">Grand Total</span>
// //             <span class="grand-value">₹${(orderData.grandTotal || 0).toFixed(2)}</span>
// //         </div>

// //         <div class="dashed"></div>
// //         <div class="center-text">FSSAI: ${orderData?.vendorFssai || "23624032003384"}</div>

// //         <div class="footer">
// //             Thank you, visit again<br/>
// //             www.maamaas.com
// //         </div>
// //     `;

// //         // FINAL PRINT CONTENT
// //         const finalHTML = `
// //         <!DOCTYPE html>
// //         <html>
// //         <head>
// //             <title>Receipt - ${orderData.orderId || 'Order'}</title>
// //             ${printStyles}
// //         </head>
// //         <body>
// //             ${receiptOne}
// //             <div class="page-break"></div>
// //             ${receiptTwo}
// //         </body>
// //         </html>
// //     `;

// //         try {
// //             const printWindow = window.open('', '_blank', 'width=800,height=600');
// //             printWindow.document.open();
// //             printWindow.document.write(finalHTML);
// //             printWindow.document.close();

// //             printWindow.onload = () => {
// //                 printWindow.print();

// //                 // Listen for afterprint event
// //                 printWindow.onafterprint = () => {
// //                     setTimeout(() => {
// //                         printWindow.close();

// //                         // ✅ ADDED: AUTO-REFRESH AND CLEAR CART/RECEIPT
// //                         // Check if this is an auto-print (receipt just generated after order)
// //                         const isAutoPrint = showReceipt && orderData.orderId;

// //                         if (isAutoPrint) {

// //                             // Clear cart data locally
// //                             setCartData({ cartItems: [] });
// //                             setQuantities({});
// //                             setGrandTotal(0);
// //                             setSelectedPaymentMethod("");

// //                             // Hide receipt
// //                             setShowReceipt(false);
// //                             setOrderData({});

// //                             // Clear localStorage flags
// //                             localStorage.removeItem("showReceipt");
// //                             localStorage.removeItem("receiptOrderId");
// //                             localStorage.removeItem("receiptTimestamp");

// //                             // Trigger cart refresh for other components
// //                             triggerCartRefresh();
// //                             triggerFullRefresh();

// //                             // Optional: Show success message
// //                             setTimeout(() => {
// //                                 alert("✅ Order completed! Cart has been cleared.");
// //                             }, 1000);
// //                         } else {
// //                             // This is manual print - just close window
// //                         }
// //                     }, 500);
// //                 };

// //                 // Fallback in case afterprint doesn't fire
// //                 setTimeout(() => {
// //                     printWindow.close();

// //                     // ✅ ADDED: Same auto-refresh logic for fallback
// //                     const isAutoPrint = showReceipt && orderData.orderId;

// //                     if (isAutoPrint) {

// //                         // Clear cart data locally
// //                         setCartData({ cartItems: [] });
// //                         setQuantities({});
// //                         setGrandTotal(0);
// //                         setSelectedPaymentMethod("");

// //                         // Hide receipt
// //                         setShowReceipt(false);
// //                         setOrderData({});

// //                         // Clear localStorage flags
// //                         localStorage.removeItem("showReceipt");
// //                         localStorage.removeItem("receiptOrderId");
// //                         localStorage.removeItem("receiptTimestamp");

// //                         // Trigger cart refresh
// //                         triggerCartRefresh();
// //                         triggerFullRefresh();
// //                     }
// //                 }, 3000);
// //             };
// //             setTimeout(() => {
// //                 if (printWindow && !printWindow.closed) {
// //                     printWindow.close();
// //                 }
// //             }, 1000);

// //             // Only restore original content for MANUAL prints
// //             // Auto-print doesn't need this since we're not modifying the page
// //             if (!showReceipt) {
// //                 document.body.innerHTML = originalContent;
// //             }

// //         } catch (error) {
// //             console.error("Print error:", error);
// //             // Restore page on error
// //             if (!showReceipt) {
// //                 document.body.innerHTML = originalContent;
// //             }
// //         }


// //         // Remove the setTimeout wrapper
// //     };
// //     const triggerFullRefresh = () => {
// //         window.location.reload();
// //     };

// //     // const handlePrint = () => {
// //     //     // Check for order data (important for auto-print)
// //     //     if (!orderData || !orderData.orderId) {
// //     //         console.error("No order data available for printing");
// //     //         return;
// //     //     }

// //     //     // Store original content (only needed for manual print)
// //     //     const originalContent = document.body.innerHTML;

// //     //     const printStyles = `
// //     // <style>
// //     // @media print {
// //     //     body {
// //     //         width: 80mm !important;
// //     //         margin: 0 auto !important;
// //     //         padding: 0 !important;
// //     //         font-family: "Courier New", monospace !important;
// //     //         font-size: 10px !important;
// //     //         line-height: 1.2 !important;
// //     //         font-weight:900 !important;
// //     //     }

// //     //     h1, h2, h3 {
// //     //         font-weight: bold;
// //     //         text-align: center;
// //     //         margin: 0;
// //     //         padding: 0;
// //     //     }

// //     //     .big-title {
// //     //         font-size: 14px !important;
// //     //         font-weight: bold;
// //     //         text-align: center;
// //     //         margin-bottom: 5px;
// //     //     }

// //     //     .center-text {
// //     //         text-align: center;
// //     //         font-size: 10px;
// //     //         font-weight: bold;
// //     //     }

// //     //     .line {
// //     //         border-top: 1px solid black;
// //     //         margin: 6px 0;
// //     //     }

// //     //     .dashed {
// //     //         border-top: 1px dashed black;
// //     //         margin: 6px 0;
// //     //     }

// //     //     table {
// //     //         width: 100%;
// //     //         font-size: 10px;
// //     //         border-collapse: collapse;
// //     //     }

// //     //     th{
// //     //         padding: 0px 0px;
// //     //         font-weight: bold;
// //     //     }
// //     //     td { 
// //     //         padding: 2px 0px;
// //     //         font-weight: bold;
// //     //     }

// //     //     .row {
// //     //         display: flex;
// //     //         justify-content: space-around;
// //     //         font-size: 10px;
// //     //         font-weight: bold;
// //     //         white-space: nowrap;
// //     //         width: 100%;

// //     //     }

// //     //     .grand-label {
// //     //         font-size: 16px;
// //     //         font-weight: bold;
// //     //     }

// //     //     .grand-value {
// //     //         font-size: 16px;
// //     //         font-weight: bold;
// //     //     }

// //     //     .footer {
// //     //         text-align: center;
// //     //         margin-top: 10px;
// //     //         font-size: 10px;
// //     //     }

// //     //     .receipt-buttons, button {
// //     //         display: none !important;
// //     //     }

// //     //     @page {
// //     //         size: 80mm auto;
// //     //         margin: 0;
// //     //     }

// //     //     .page-break {
// //     //         page-break-after: always;
// //     //     }
// //     // }
// //     // </style>
// //     // `;

// //     //     // SIMPLE RECEIPT (Top Image) - HARDCODED "Take A Break"
// //     //     const receiptOne = `
// //     //     <div class="big-title">Take A Break</div>
// //     //     <div class="line"></div>

// //     //     <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
// //     //     <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>

// //     //     <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

// //     //     <div class="line"></div>

// //     //     <table>
// //     //         <thead>
// //     //             <tr>
// //     //                 <th style="text-align:center;">Item</th>
// //     //                 <th style="text-align:center;">Qty</th>
// //     //             </tr>
// //     //         </thead>
// //     //         <tbody>
// //     //             ${Array.isArray(orderData.order) ? orderData.order.map(item => `
// //     //                 <tr>
// //     //                     <td style="text-align:center;">${item.dishName || "Item"}</td>
// //     //                     <td style="text-align:center;">${item.quantity || 1}</td>
// //     //                 </tr>
// //     //             `).join("") : ""}
// //     //         </tbody>
// //     //     </table>

// //     //     <div class="line"></div>
// //     // `;

// //     //     // DETAILED RECEIPT (Bottom Image) - HARDCODED "Take A Break"
// //     //     const receiptTwo = `
// //     //     <div class="big-title">Take A Break</div>
// //     //     <div class="center-text">GSTIN: ${orderData?.vendorGstIn || "N/A"}</div>
// //     //     <div class="line"></div>

// //     //     <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
// //     //     <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>
// //     //     <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

// //     //     <div class="line"></div>

// //     //     <table class="items-table">
// //     //         <thead>
// //     //             <tr>
// //     //                 <th style="text-align:center;">Item</th>
// //     //                 <th style="text-align:center;">Qty</th>
// //     //                 <th style="text-align:center;">Price</th>
// //     //                 <th style="text-align:center;">Total</th>
// //     //             </tr>
// //     //         </thead>
// //     //         <tbody>
// //     //             ${Array.isArray(orderData.order) ? orderData.order.map(item => `
// //     //                 <tr>
// //     //                     <td style="text-align:center;">${item.dishName || "Item"}</td>
// //     //                     <td style="text-align:center;">${item.quantity || 1}</td>
// //     //                     <td style="text-align:center;">₹${(item.price || 0).toFixed(2)}</td>
// //     //                     <td style="text-align:center;">₹${((item.price || 0) * (item.quantity || 1)).toFixed(2)}</td>
// //     //                 </tr>
// //     //             `).join("") : ""}
// //     //         </tbody>
// //     //     </table>

// //     //     <div class="line"></div>

// //     //     <div class="row"><span>SubTotal</span><span>₹${(orderData.subTotal || 0).toFixed(2)}</span></div>
// //     //     <div class="row"><span>Platform</span><span>₹${(orderData.platformCharges || 0).toFixed(2)}</span></div>
// //     //     <div class="row"><span>Service</span><span>₹${(orderData.serviceCharge || 0).toFixed(2)}</span></div>
// //     //     <div class="row"><span>CGST</span><span>₹${(orderData.cgst || 0).toFixed(2)}</span></div>
// //     //     <div class="row"><span>SGST</span><span>₹${(orderData.sgst || 0).toFixed(2)}</span></div>

// //     //     <div class="line"></div>

// //     //     <div class="row">
// //     //         <span class="grand-label">Grand Total</span>
// //     //         <span class="grand-value">₹${(orderData.grandTotal || 0).toFixed(2)}</span>
// //     //     </div>

// //     //     <div class="dashed"></div>
// //     //     <div class="center-text">FSSAI: ${orderData?.vendorFssai || "23624032003384"}</div>

// //     //     <div class="footer">
// //     //         Thank you, visit again<br/>
// //     //         www.maamaas.com
// //     //     </div>
// //     // `;

// //     //     // FINAL PRINT CONTENT
// //     //     const finalHTML = `
// //     //     <!DOCTYPE html>
// //     //     <html>
// //     //     <head>
// //     //         <title>Receipt - ${orderData.orderId || 'Order'}</title>
// //     //         ${printStyles}
// //     //     </head>
// //     //     <body>
// //     //         ${receiptOne}
// //     //         <div class="page-break"></div>
// //     //         ${receiptTwo}
// //     //     </body>
// //     //     </html>
// //     // `;

// //     //     // try {
// //     //     //     const printWindow = window.open('', '_blank', 'width=800,height=600');
// //     //     //     printWindow.document.open();
// //     //     //     printWindow.document.write(finalHTML);
// //     //     //     printWindow.document.close();

// //     //     //     printWindow.onload = () => {
// //     //     //         printWindow.print();

// //     //     //         // Listen for afterprint event
// //     //     //         printWindow.onafterprint = () => {
// //     //     //             setTimeout(() => {
// //     //     //                 printWindow.close();

// //     //     //                 // ✅ ADDED: AUTO-REFRESH AND CLEAR CART/RECEIPT
// //     //     //                 // Check if this is an auto-print (receipt just generated after order)
// //     //     //                 const isAutoPrint = showReceipt && orderData.orderId;

// //     //     //                 if (isAutoPrint) {

// //     //     //                     // Clear cart data locally
// //     //     //                     setCartData({ cartItems: [] });
// //     //     //                     setQuantities({});
// //     //     //                     setGrandTotal(0);
// //     //     //                     setSelectedPaymentMethod("");

// //     //     //                     // Hide receipt
// //     //     //                     setShowReceipt(false);
// //     //     //                     setOrderData({});

// //     //     //                     // Clear localStorage flags
// //     //     //                     localStorage.removeItem("showReceipt");
// //     //     //                     localStorage.removeItem("receiptOrderId");
// //     //     //                     localStorage.removeItem("receiptTimestamp");

// //     //     //                     // Trigger cart refresh for other components
// //     //     //                     triggerCartRefresh();
// //     //     //                     triggerFullRefresh();

// //     //     //                     // Optional: Show success message
// //     //     //                     setTimeout(() => {
// //     //     //                         alert("✅ Order completed! Cart has been cleared.");
// //     //     //                     }, 1000);
// //     //     //                 } else {
// //     //     //                     // This is manual print - just close window
// //     //     //                 }
// //     //     //             }, 500);
// //     //     //         };

// //     //     //         // Fallback in case afterprint doesn't fire
// //     //     //         setTimeout(() => {
// //     //     //             printWindow.close();

// //     //     //             // ✅ ADDED: Same auto-refresh logic for fallback
// //     //     //             const isAutoPrint = showReceipt && orderData.orderId;

// //     //     //             if (isAutoPrint) {

// //     //     //                 // Clear cart data locally
// //     //     //                 setCartData({ cartItems: [] });
// //     //     //                 setQuantities({});
// //     //     //                 setGrandTotal(0);
// //     //     //                 setSelectedPaymentMethod("");

// //     //     //                 // Hide receipt
// //     //     //                 setShowReceipt(false);
// //     //     //                 setOrderData({});

// //     //     //                 // Clear localStorage flags
// //     //     //                 localStorage.removeItem("showReceipt");
// //     //     //                 localStorage.removeItem("receiptOrderId");
// //     //     //                 localStorage.removeItem("receiptTimestamp");

// //     //     //                 // Trigger cart refresh
// //     //     //                 triggerCartRefresh();
// //     //     //                 triggerFullRefresh();
// //     //     //             }
// //     //     //         }, 3000);
// //     //     //     };
// //     //     //     setTimeout(() => {
// //     //     //         if (printWindow && !printWindow.closed) {
// //     //     //             printWindow.close();
// //     //     //         }
// //     //     //     }, 1000);

// //     //     //     // Only restore original content for MANUAL prints
// //     //     //     // Auto-print doesn't need this since we're not modifying the page
// //     //     //     if (!showReceipt) {
// //     //     //         document.body.innerHTML = originalContent;
// //     //     //     }

// //     //     // } catch (error) {
// //     //     //     console.error("Print error:", error);
// //     //     //     // Restore page on error
// //     //     //     if (!showReceipt) {
// //     //     //         document.body.innerHTML = originalContent;
// //     //     //     }
// //     //     // }
// //     //     // Replace the setTimeout with:
// //     //     window.location.reload();
// //     //     // Remove the setTimeout wrapper
// //     // };

// //     const handleDownload = async () => {
// //         const receipt = receiptRef.current;
// //         if (!receipt) return;

// //         const buttons = receipt.querySelectorAll(".receipt-buttons");
// //         const buttonStates = [];
// //         buttons.forEach(btn => {
// //             buttonStates.push({
// //                 element: btn,
// //                 originalDisplay: btn.style.display
// //             });
// //             btn.style.display = "none";
// //         });

// //         await new Promise(resolve => setTimeout(resolve, 100));

// //         const originalStyle = {
// //             height: receipt.style.height,
// //             overflowY: receipt.style.overflowY
// //         };
// //         receipt.style.height = "auto";
// //         receipt.style.overflowY = "visible";

// //         try {
// //             const canvas = await html2canvas(receipt, {
// //                 scale: 2,
// //                 useCORS: true,
// //                 logging: false
// //             });

// //             const imgData = canvas.toDataURL("image/png");
// //             const pdf = new jsPDF("p", "mm", "a4");
// //             const imgWidth = 210;
// //             const imgHeight = (canvas.height * imgWidth) / canvas.width;

// //             pdf.addImage(imgData, "PNG", 0, 10, imgWidth, imgHeight);
// //             pdf.save("Payment_Receipt.pdf");

// //             buttonStates.forEach(state => {
// //                 state.element.style.display = state.originalDisplay;
// //             });
// //             receipt.style.height = originalStyle.height;
// //             receipt.style.overflowY = originalStyle.overflowY;

// //         } catch (err) {
// //             console.error("❌ Error generating PDF:", err);
// //             buttonStates.forEach(state => {
// //                 state.element.style.display = state.originalDisplay;
// //             });
// //             receipt.style.height = originalStyle.height;
// //             receipt.style.overflowY = originalStyle.overflowY;
// //         }
// //     };


// //     const clearCart = async () => {
// //         const token = localStorage.getItem("authToken");
// //         const vendorId = localStorage.getItem("vendorId");
// //         const cartId = localStorage.getItem("cartId");

// //         if (!token || !vendorId || !cartId) {
// //             alert("Unable to clear cart. Missing required data.");
// //             return;
// //         }

// //         if (cartData.cartItems.length === 0) {
// //             alert("Cart is already empty!");
// //             return;
// //         }

// //         if (!window.confirm("Are you sure you want to clear all items from your cart?")) {
// //             return;
// //         }

// //         try {
// //             for (const item of cartData.cartItems) {
// //                 const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartId}?dishId=${item.dishId}&quantity=0`;
// //                 await axios.put(apiUrl, null, {
// //                     headers: { Authorization: `Bearer ${token}` }
// //                 });
// //             }

// //             setCartData({ cartItems: [] });
// //             setQuantities({});
// //             setGrandTotal(0);
// //             setShowReceipt(false);

// //             alert("Cart cleared successfully!");
// //             triggerCartRefresh();

// //         } catch (err) {
// //             console.error("Error clearing cart:", err);
// //             alert("Failed to clear cart. Please try again.");
// //         }
// //     };

// //     const triggerCartRefresh = () => {
// //         const event = new CustomEvent('cartUpdated');
// //         window.dispatchEvent(event);
// //     }

// //     useEffect(() => {
// //         const handleCartUpdate = () => {
// //             setRefresh(prev => prev + 1);
// //         };

// //         window.addEventListener('cartUpdated', handleCartUpdate);
// //         return () => {
// //             window.removeEventListener('cartUpdated', handleCartUpdate);
// //         };
// //     }, []);

// //     useEffect(() => {
// //         fetchCartData();
// //     }, [refresh]);



// //     const increaseQuantity = async (dishId) => {
// //         const token = localStorage.getItem("authToken");
// //         const vendorId = localStorage.getItem("vendorId");
// //         if (!token || !vendorId) return alert("Auth token or vendorId missing");

// //         if (!cartData || !cartData.cartItems) {
// //             alert("Cart is empty or not loaded yet.");
// //             return;
// //         }

// //         const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
// //         if (!cartItem) {
// //             alert("Item not found in cart. Please add it first.");
// //             return;
// //         }

// //         const newQty = (quantities[dishId] || 0) + 1;

// //         const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartData.cartId}?dishId=${dishId}&quantity=${newQty}`;

// //         try {
// //             await axios.put(apiUrl, null, {
// //                 headers: { Authorization: `Bearer ${token}` }
// //             });

// //             setQuantities(prev => ({ ...prev, [dishId]: newQty }));
// //             setCartData(prev => ({
// //                 ...prev,
// //                 cartItems: prev.cartItems.map(item =>
// //                     item.dishId === dishId ? { ...item, quantity: newQty } : item
// //                 )
// //             }));
// //             setIsModalOpen(true);
// //             triggerCartRefresh();
// //             setTimeout(() => {
// //                 if (!isHovered) setIsModalOpen(false);
// //             }, 20000000);
// //         } catch (err) {
// //             console.error("API Error:", err.response ? err.response.data : err);
// //             alert("Unable to update quantity for dishId: " + dishId);
// //         }
// //     };

// //     const decreaseQuantity = async (dishId) => {
// //         const token = localStorage.getItem("authToken");
// //         const vendorId = localStorage.getItem("vendorId");
// //         const currentQty = quantities[dishId] || 0;
// //         if (currentQty === 0) return;

// //         if (!cartData || !cartData.cartItems) {
// //             alert("Cart is empty or not loaded yet.");
// //             return;
// //         }

// //         const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
// //         if (!cartItem) return alert("Item not found");

// //         const newQty = currentQty - 1;

// //         if (newQty === 0) {
// //             setItemToRemove({ dishId, cartItem });
// //             setShowRemoveConfirm(true);
// //             return;
// //         }

// //         await updateQuantity(dishId, newQty);
// //     };
// //     const updateQuantity = async (dishId, newQty) => {
// //         const token = localStorage.getItem("authToken");
// //         const vendorId = localStorage.getItem("vendorId");

// //         const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartData.cartId}?dishId=${dishId}&quantity=${newQty}`;

// //         try {
// //             await axios.put(apiUrl, null, {
// //                 headers: { Authorization: `Bearer ${token}` }
// //             });

// //             setQuantities(prev => ({ ...prev, [dishId]: newQty > 0 ? newQty : 0 }));
// //             setCartData(prev => ({
// //                 ...prev,
// //                 cartItems: newQty > 0
// //                     ? prev.cartItems.map(item =>
// //                         item.dishId === dishId ? { ...item, quantity: newQty } : item
// //                     )
// //                     : prev.cartItems.filter(item => item.dishId !== dishId)
// //             }));
// //             setIsModalOpen(true);
// //             triggerCartRefresh();
// //             setTimeout(() => {
// //                 if (!isHovered) setIsModalOpen(false);
// //             }, 20000000);
// //         } catch (err) {
// //             console.error("API Error:", err.response ? err.response.data : err);
// //             alert("Unable to update quantity for dishId: " + dishId);
// //         }
// //     };

// //     const confirmRemove = async () => {
// //         if (itemToRemove) {
// //             await updateQuantity(itemToRemove.dishId, 0);
// //             setShowRemoveConfirm(false);
// //             setItemToRemove(null);
// //         }
// //     };

// //     const cancelRemove = () => {
// //         setShowRemoveConfirm(false);
// //         setItemToRemove(null);
// //     };

// //     const displayData = cartData.cartItems || [];
// //     const hasItems = displayData.filter(item => (quantities[item.dishId] ?? item.quantity ?? 1) > 0).length > 0;

// //     if (!hasItems && !showReceipt) {
// //         return null;
// //     }

// //     const calculateDenominationTotal = () => {
// //         let total = 0;
// //         Object.keys(notesCount).forEach(denom => {
// //             const count = parseInt(notesCount[denom]) || 0;
// //             total += count * parseInt(denom);
// //         });
// //         return total;
// //     };

// //     const denominationTotal = calculateDenominationTotal();
// //     const remainingAmount = denominationTotal - grandTotal;

// //     return (
// //         <div style={{
// //             background: '#b15cd6',
// //             borderRadius: '0.5rem',
// //             padding: '1rem',
// //             height: 'fit-content',
// //             maxHeight: '85vh',
// //             display: 'flex',
// //             flexDirection: 'column',
// //             marginTop: window.innerHeight <= 700 ? "3rem" : "5rem",
// //             minHeight: '500px',
// //             position: 'sticky',
// //             top: '6rem',
// //             zIndex: window.innerHeight <= 700 ? 30000 : " ",
// //         }}>
// //             <div style={{
// //                 display: 'flex',
// //                 justifyContent: 'center',
// //                 alignItems: 'center',
// //                 marginBottom: '0.3rem',
// //                 paddingBottom: '0.75rem',
// //                 borderBottom: '0px solid #e9ecef',
// //                 flexShrink: 0,
// //                 position: 'relative',
// //                 height: '40px'
// //             }}>
// //                 <h4 style={{
// //                     color: '#f8f9fa',
// //                     margin: 0,
// //                     fontSize: '1.3rem',
// //                     fontWeight: '600',
// //                     textAlign: 'center'
// //                 }}>
// //                     {showReceipt ? 'Order Receipt' : 'Cart'}
// //                 </h4>

// //                 {hasItems && !showReceipt && (
// //                     <button
// //                         onClick={clearCart}
// //                         style={{
// //                             background: '#e53e3e',
// //                             border: '1px solid #e53e3e',
// //                             color: 'white',
// //                             padding: '0.4rem 0.8rem',
// //                             borderRadius: '0.25rem',
// //                             fontSize: '0.85rem',
// //                             fontWeight: '600',
// //                             cursor: 'pointer',
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             gap: '0.3rem',
// //                             transition: 'all 0.2s ease',
// //                             position: 'absolute',
// //                             right: "10px",
// //                             top: '50%',
// //                             transform: 'translateY(-75%)'
// //                         }}
// //                     >
// //                         Clear
// //                     </button>
// //                 )}

// //                 {showReceipt && (
// //                     <>
// //                         <button
// //                             onClick={closeReceipt}
// //                             disabled={isProcessingBack}
// //                             style={{
// //                                 background: 'transparent',
// //                                 border: '1px solid #f8f9fa',
// //                                 color: '#f8f9fa',
// //                                 padding: '0.4rem 0.8rem',
// //                                 borderRadius: '0.25rem',
// //                                 fontSize: '0.85rem',
// //                                 fontWeight: '600',
// //                                 cursor: isProcessingBack ? 'not-allowed' : 'pointer',
// //                                 display: window.innerWidth <= 1400 ? "none" : "flex",
// //                                 alignItems: 'center',
// //                                 gap: '0.3rem',
// //                                 transition: 'all 0.2s ease',
// //                                 position: 'absolute',
// //                                 left: "10px",
// //                                 top: '50%',
// //                                 transform: 'translateY(-75%)',
// //                                 opacity: isProcessingBack ? 0.7 : 1
// //                             }}
// //                             onMouseOver={(e) => {
// //                                 if (!isProcessingBack) {
// //                                     e.target.style.backgroundColor = '#f8f9fa';
// //                                     e.target.style.color = '#b15cd6';
// //                                 }
// //                             }}
// //                             onMouseOut={(e) => {
// //                                 if (!isProcessingBack) {
// //                                     e.target.style.backgroundColor = 'transparent';
// //                                     e.target.style.color = '#f8f9fa';
// //                                 }
// //                             }}
// //                         >
// //                             {isProcessingBack ? '...' : '← Back'}
// //                         </button>
// //                         <button
// //                             onClick={closeReceipt}
// //                             disabled={isProcessingBack}
// //                             style={{
// //                                 background: 'transparent',
// //                                 border: '1px solid #f8f9fa',
// //                                 color: '#f8f9fa',
// //                                 padding: '0.4rem 0.8rem',
// //                                 borderRadius: '0.25rem',
// //                                 fontSize: '0.85rem',
// //                                 fontWeight: '600',
// //                                 cursor: isProcessingBack ? 'not-allowed' : 'pointer',
// //                                 display: window.innerWidth <= 1400 ? "flex" : "none",
// //                                 alignItems: 'center',
// //                                 gap: '0.3rem',
// //                                 transition: 'all 0.2s ease',
// //                                 position: 'absolute',
// //                                 left: "0px",
// //                                 top: '50%',
// //                                 transform: 'translateY(-75%)',
// //                                 opacity: isProcessingBack ? 0.7 : 1
// //                             }}
// //                             onMouseOver={(e) => {
// //                                 if (!isProcessingBack) {
// //                                     e.target.style.backgroundColor = '#f8f9fa';
// //                                     e.target.style.color = '#b15cd6';
// //                                 }
// //                             }}
// //                             onMouseOut={(e) => {
// //                                 if (!isProcessingBack) {
// //                                     e.target.style.backgroundColor = 'transparent';
// //                                     e.target.style.color = '#f8f9fa';
// //                                 }
// //                             }}
// //                         >
// //                             {isProcessingBack ? '...' : '←'}
// //                         </button>
// //                     </>
// //                 )}
// //             </div>

// //             <div className="cart-content-container hide-scrollbar">
// //                 {showReceipt ? (
// //                     <div ref={receiptRef} style={{
// //                         backgroundColor: "white",
// //                         borderRadius: '0.5rem',
// //                         padding: '1rem',
// //                         overflowY: 'auto',
// //                         maxHeight: 'calc(85vh - 100px)',
// //                         scrollbarWidth: "none",
// //                     }}>
// //                         <div ref={printRef}>
// //                             <div style={{
// //                                 textAlign: 'center',
// //                                 marginBottom: '1rem',
// //                                 paddingBottom: '0.5rem',
// //                                 borderBottom: '2px solid #b15cd6'
// //                             }}>
// //                                 <h5 style={{
// //                                     color: '#b15cd6',
// //                                     margin: '0.5rem 0',
// //                                     fontSize: window.innerWidth < 1200 ? '1.1rem' : '1.2rem'
// //                                 }}>
// //                                     ✅ Payment Successful!
// //                                 </h5>
// //                                 <h6 style={{
// //                                     margin: 0,
// //                                     color: '#2d3748',
// //                                     fontSize: '1rem'
// //                                 }}>
// //                                     {bannerData?.companyName || "MAAMAAS HOUSE"}
// //                                 </h6>
// //                             </div>

// //                             <div style={{
// //                                 display: 'flex',
// //                                 flexDirection: 'column',
// //                                 gap: '0.5rem',
// //                                 marginBottom: '1rem',
// //                                 fontSize: '0.9rem'
// //                             }}>
// //                                 <div style={{ display: 'flex', justifyContent: 'space-between' }}>
// //                                     <span style={{ fontWeight: '600', color: '#4a5568' }}>Order ID:</span>
// //                                     <span className='endalign' style={{ fontWeight: '700', color: '#2d3748' }}>{orderData.orderId}</span>
// //                                 </div>
// //                                 <div style={{ display: 'flex', justifyContent: 'space-between' }}>
// //                                     <span style={{ fontWeight: '600', color: '#4a5568' }}>Date:</span>
// //                                     <span className='endalign' style={{ fontWeight: '700', color: '#2d3748' }}>
// //                                         {orderData.date ? new Date(orderData.date).toLocaleDateString('en-GB') : new Date().toLocaleDateString('en-GB')}
// //                                     </span>
// //                                 </div>
// //                                 <div style={{ display: 'flex', justifyContent: 'space-between' }}>
// //                                     <span style={{ fontWeight: '600', color: '#4a5568' }}>Order Type:</span>
// //                                     <span className='endalign' style={{ fontWeight: '700', color: '#2d3748' }}>{orderData.orderType}</span>
// //                                 </div>
// //                                 <div style={{ display: 'flex', justifyContent: 'space-between' }}>
// //                                     <span style={{ fontWeight: '600', color: '#4a5568' }}>Time:</span>
// //                                     <span className='endalign' style={{ fontWeight: '700', color: '#2d3748' }}>
// //                                         {orderData.time ? new Date(`1970-01-01T${orderData.time}`).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }) : "N/A"}
// //                                     </span>
// //                                 </div>
// //                                 <div style={{ display: 'flex', justifyContent: 'space-between' }}>
// //                                     <span style={{ fontWeight: '600', color: '#4a5568' }}>Payment Method:</span>
// //                                     <span style={{ fontWeight: '700', color: '#2d3748', display: window.innerWidth < 1200 ? "flex" : "flex", alignItems: window.innerWidth < 1200 ? "end" : " " }}>{orderData.paymentMethod}</span>
// //                                 </div>
// //                             </div>

// //                             <hr style={{ border: '1px dashed #cbd5e0', margin: '1rem 0' }} />

// //                             {Array.isArray(orderData.order) && orderData.order.length > 0 ? (
// //                                 <>
// //                                     <table style={{
// //                                         width: '100%',
// //                                         borderCollapse: 'collapse',
// //                                         fontSize: '0.85rem',
// //                                         marginBottom: '1rem'
// //                                     }}>
// //                                         <thead>
// //                                             <tr style={{ borderBottom: '2px solid #e2e8f0' }}>
// //                                                 <th style={{ padding: '0.5rem', textAlign: 'left', fontWeight: '600', color: '#4a5568' }}>Item</th>
// //                                                 <th style={{ padding: '0.5rem', textAlign: 'center', fontWeight: '600', color: '#4a5568' }}>Qty</th>
// //                                                 <th style={{ padding: '0.5rem', textAlign: 'right', fontWeight: '600', color: '#4a5568' }}>Price</th>
// //                                                 <th style={{ padding: '0.5rem', textAlign: 'right', fontWeight: '600', color: '#4a5568' }}>Total</th>
// //                                             </tr>
// //                                         </thead>
// //                                         <tbody>
// //                                             {orderData.order.map((item, index) => (
// //                                                 <tr key={index} style={{ borderBottom: '1px solid #e2e8f0' }}>
// //                                                     <td style={{ padding: '0.5rem', textAlign: 'left' }}>{item.dishName || "N/A"}</td>
// //                                                     <td style={{ padding: '0.5rem', textAlign: 'center' }}>{item.quantity ?? "N/A"}</td>
// //                                                     <td style={{ padding: '0.5rem', textAlign: 'right' }}>₹{item.price?.toFixed(2) || "0.00"}</td>
// //                                                     <td style={{ padding: '0.5rem', textAlign: 'right' }}>
// //                                                         ₹{item.price && item.quantity ? (item.price * item.quantity).toFixed(2) : "0.00"}
// //                                                     </td>
// //                                                 </tr>
// //                                             ))}
// //                                         </tbody>
// //                                     </table>

// //                                     <div style={{ marginBottom: '1rem', fontSize: '0.9rem' }}>
// //                                         <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
// //                                             <span>Sub Total:</span>
// //                                             <span>₹{orderData.subTotal?.toFixed(2) || "0.00"}</span>
// //                                         </div>
// //                                         {orderData.platformCharges > 0 && (
// //                                             <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
// //                                                 <span>Platform Charges:</span>
// //                                                 <span>₹{orderData.platformCharges?.toFixed(2) || "0.00"}</span>
// //                                             </div>
// //                                         )}
// //                                         {orderData.serviceCharge > 0 && (
// //                                             <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
// //                                                 <span>Service Charges:</span>
// //                                                 <span>₹{orderData.serviceCharge?.toFixed(2) || "0.00"}</span>
// //                                             </div>
// //                                         )}
// //                                         {orderData.cgst > 0 && (
// //                                             <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
// //                                                 <span>CGST:</span>
// //                                                 <span>₹{orderData.cgst?.toFixed(2) || "0.00"}</span>
// //                                             </div>
// //                                         )}
// //                                         {orderData.sgst > 0 && (
// //                                             <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
// //                                                 <span>SGST:</span>
// //                                                 <span>₹{orderData.sgst?.toFixed(2) || "0.00"}</span>
// //                                             </div>
// //                                         )}
// //                                     </div>

// //                                     <hr style={{ border: '1px dashed #cbd5e0', margin: '1rem 0' }} />

// //                                     <div style={{
// //                                         display: 'flex',
// //                                         justifyContent: 'space-between',
// //                                         alignItems: 'center',
// //                                         padding: '0.75rem',
// //                                         backgroundColor: '#f7fafc',
// //                                         borderRadius: '0.25rem',
// //                                         border: '0px solid #b15cd6',
// //                                         marginBottom: '1rem'
// //                                     }}>
// //                                         <span style={{ fontSize: '1.1rem', fontWeight: '700', color: '#2d3748' }}>Grand Total:</span>
// //                                         <span style={{ fontSize: '1.3rem', fontWeight: '900', color: '#b15cd6' }}>
// //                                             ₹{orderData.grandTotal?.toFixed(2) || "0.00"}
// //                                         </span>
// //                                     </div>

// //                                     <div style={{
// //                                         textAlign: 'center',
// //                                         padding: '1rem',
// //                                         borderTop: '2px solid #e2e8f0',
// //                                         marginTop: '1rem'
// //                                     }}>
// //                                         <h6 style={{ color: '#4a5568', marginBottom: '0.5rem' }}>
// //                                             Thank You! Visit Again
// //                                         </h6>
// //                                         <p style={{ color: '#a0aec0', fontSize: '0.8rem', margin: 0 }}>
// //                                             www.maamaas.com
// //                                         </p>
// //                                     </div>
// //                                 </>
// //                             ) : (
// //                                 <p style={{ textAlign: 'center', color: '#718096' }}>No order data available.</p>
// //                             )}
// //                         </div>

// //                         <div className="receipt-buttons" style={{
// //                             display: 'flex',
// //                             gap: window.innerWidth < 1200 ? '0.5rem' : '1rem',
// //                             justifyContent: 'center',
// //                             marginTop: '1rem',
// //                             paddingTop: '1rem',
// //                             borderTop: '1px solid #e2e8f0'
// //                         }}>
// //                             <button
// //                                 onClick={handlePrint}
// //                                 style={{
// //                                     display: 'flex',
// //                                     alignItems: 'center',
// //                                     gap: '0.5rem',
// //                                     padding: window.innerWidth < 1200 ? '0.3rem 1rem ' : '0.75rem 1.5rem',
// //                                     backgroundColor: '#b15cd6',
// //                                     color: 'white',
// //                                     border: 'none',
// //                                     borderRadius: '0.5rem',
// //                                     cursor: 'pointer',
// //                                     fontWeight: '600',
// //                                     fontSize: '0.9rem',
// //                                     transition: 'all 0.2s ease'
// //                                 }}
// //                                 onMouseOver={(e) => e.target.style.backgroundColor = '#9b46c9'}
// //                                 onMouseOut={(e) => e.target.style.backgroundColor = '#b15cd6'}
// //                             >
// //                                 <FaPrint /> Print
// //                             </button>
// //                             <button
// //                                 onClick={handleDownload}
// //                                 style={{
// //                                     display: 'flex',
// //                                     alignItems: 'center',
// //                                     gap: '0.5rem',
// //                                     padding: window.innerWidth < 1200 ? '0.5rem 1rem ' : '0.75rem 1.5rem',
// //                                     backgroundColor: '#4a5568',
// //                                     color: 'white',
// //                                     border: 'none',
// //                                     borderRadius: '0.5rem',
// //                                     cursor: 'pointer',
// //                                     fontWeight: '600',
// //                                     fontSize: '0.9rem',
// //                                     transition: 'all 0.2s ease'
// //                                 }}
// //                                 onMouseOver={(e) => e.target.style.backgroundColor = '#2d3748'}
// //                                 onMouseOut={(e) => e.target.style.backgroundColor = '#4a5568'}
// //                             >
// //                                 <FaDownload /> Download
// //                             </button>
// //                         </div>
// //                     </div>
// //                 ) : hasItems ? (
// //                     <>
// //                         <div style={{
// //                             backgroundColor: "white",
// //                             border: "1px solid #e9ecef",
// //                             boxShadow: "0 4px 8px rgba(0, 0, 0, 0.08)",
// //                         }}>
// //                             {/* Cart Headers - Only shown on larger screens */}
// //                             <div className="cart-headers" style={{
// //                                 display: 'flex',
// //                                 justifyContent: 'space-between',
// //                                 alignItems: 'center',
// //                                 padding: '0.75rem 1rem',
// //                                 borderBottom: '2px solid #b15cd6',
// //                                 backgroundColor: '#f8f9fa',
// //                                 fontWeight: '600',
// //                                 color: '#2d3748',
// //                                 fontSize: '0.9rem'
// //                             }}>
// //                                 <div style={{ flex: window.innerWidth < 1399 ? "1" : "2", textAlign: 'left' }}>
// //                                     Items
// //                                 </div>
// //                                 <div style={{ flex: 1, textAlign: 'center' }}>
// //                                     Quantity
// //                                 </div>
// //                                 <div style={{ flex: 1, textAlign: 'right' }}>
// //                                     Price
// //                                 </div>
// //                             </div>

// //                             {displayData
// //                                 .filter(item => (quantities[item.dishId] ?? item.quantity ?? 1) > 0)
// //                                 .map((item, index) => {
// //                                     const currentQuantity = quantities[item.dishId] ?? item.quantity ?? 1;

// //                                     return (
// //                                         <div key={item.cartItemId || index} className="cart-item-box">
// //                                             <div className="cart-item-row">
// //                                                 <div className="item-name-container">
// //                                                     <div className="item-name" title={item.dishName}>
// //                                                         {item.dishName}
// //                                                     </div>
// //                                                 </div>
// //                                                 <div className="item-controls-container">
// //                                                     <div className="quantity-controls">
// //                                                         <button
// //                                                             className="quantity-btn outline-btn"
// //                                                             onClick={() => decreaseQuantity(item.dishId)}
// //                                                             title="Decrease quantity"
// //                                                         >
// //                                                             <FaMinus className="quantity-icon" />
// //                                                         </button>
// //                                                         <span className="quantity-display">
// //                                                             {currentQuantity}
// //                                                         </span>
// //                                                         <button
// //                                                             className="quantity-btn outline-btn"
// //                                                             onClick={() => increaseQuantity(item.dishId)}
// //                                                             title="Increase quantity"
// //                                                         >
// //                                                             <FaPlus className="quantity-icon" />
// //                                                         </button>
// //                                                     </div>
// //                                                     <div className="item-price">
// //                                                         ₹{item.totalPrice?.toFixed(2) || '0.00'}
// //                                                     </div>
// //                                                 </div>
// //                                             </div>
// //                                         </div>
// //                                     );
// //                                 })}

// //                             <div className="total-section">
// //                                 <div style={{
// //                                     fontSize: window.innerWidth < 1300 ? '0.9rem' : '1rem',
// //                                     fontWeight: '600',
// //                                     color: '#2d3748',
// //                                     marginBottom: window.innerWidth < 768 ? '0.75rem' : '1rem',
// //                                     textAlign: 'center'
// //                                 }}>
// //                                     Order Summary
// //                                 </div>

// //                                 {/* Replace this section in your JSX */}
// //                                 <div style={{ marginBottom: window.innerWidth < 1300 ? '0.75rem' : '1rem' }}>
// //                                     <div style={{
// //                                         display: 'flex',
// //                                         justifyContent: 'space-between',
// //                                         alignItems: 'center',
// //                                         marginBottom: window.innerWidth < 768 ? '0.4rem' : '0.5rem',
// //                                         fontSize: window.innerWidth < 1300 ? '0.85rem' : '1rem',
// //                                         color: '#4a5568'
// //                                     }}>
// //                                         <span>Sub Total</span>
// //                                         <span>₹{cartData.subtotal?.toFixed(2) || '0.00'}</span>
// //                                     </div>

// //                                     {cartData.platformCharges > 0 && (
// //                                         <div style={{
// //                                             display: 'flex',
// //                                             justifyContent: 'space-between',
// //                                             alignItems: 'center',
// //                                             marginBottom: window.innerWidth < 768 ? '0.4rem' : '0.5rem',
// //                                             fontSize: window.innerWidth < 1300 ? '0.85rem' : '1rem',
// //                                             color: '#4a5568'
// //                                         }}>
// //                                             <span style={{ textAlign: "start" }}>Platform Charges</span>
// //                                             <span>₹{cartData.platformCharges?.toFixed(2) || '0.00'}</span>
// //                                         </div>
// //                                     )}

// //                                     {/* ✅ FIX: Show packing charges ONLY for TAKEAWAY orders */}
// //                                     {cartData.orderType === 'TAKEAWAY' && cartData.packingTotal > 0 && (
// //                                         <div style={{
// //                                             display: 'flex',
// //                                             justifyContent: 'space-between',
// //                                             alignItems: 'center',
// //                                             marginBottom: window.innerWidth < 768 ? '0.4rem' : '0.5rem',
// //                                             fontSize: window.innerWidth < 1300 ? '0.85rem' : '1rem',
// //                                             color: '#4a5568'
// //                                         }}>
// //                                             <span>Packing Charges</span>
// //                                             <span>₹{cartData.packingTotal?.toFixed(2) || '0.00'}</span>
// //                                         </div>
// //                                     )}

// //                                     {/* ✅ FIX: Show service charges ONLY for DINE_IN orders */}
// //                                     {cartData.orderType === 'DINE_IN' && (
// //                                         <div style={{
// //                                             display: 'flex',
// //                                             justifyContent: 'space-between',
// //                                             alignItems: window.innerWidth < 480 ? 'flex-start' : 'center',
// //                                             marginBottom: window.innerWidth < 768 ? '0.4rem' : '0.5rem',
// //                                             fontSize: window.innerWidth < 1300 ? '0.85rem' : '1rem',
// //                                             color: '#4a5568',
// //                                             flexDirection: window.innerWidth < 480 ? 'column' : 'row',
// //                                             gap: window.innerWidth < 480 ? '0.3rem' : '0'
// //                                         }}>
// //                                             <span style={{
// //                                                 flex: window.innerWidth < 480 ? '0 0 100%' : 'none',
// //                                                 marginBottom: window.innerWidth < 480 ? '0.2rem' : '0'
// //                                             }}>
// //                                                 Service Charges
// //                                             </span>

// //                                             <div style={{
// //                                                 display: window.innerWidth < 1300 ? ' ' : 'flex',
// //                                                 alignItems: 'center',
// //                                                 gap: window.innerWidth < 768 ? '0.3rem' : '0.5rem',
// //                                                 flexDirection: window.innerWidth < 480 ? 'row' : 'row',
// //                                                 justifyContent: window.innerWidth < 480 ? 'space-between' : 'flex-end',
// //                                                 width: window.innerWidth < 480 ? '100%' : 'auto'
// //                                             }}>
// //                                                 <button
// //                                                     onClick={toggleServiceCharge}
// //                                                     disabled={isUpdatingServiceCharge || !cartData.cartId}
// //                                                     style={{
// //                                                         display: 'flex',
// //                                                         alignItems: 'center',
// //                                                         justifyContent: 'center',
// //                                                         gap: window.innerWidth < 768 ? '0.2rem' : '0.3rem',
// //                                                         padding: window.innerWidth < 1300 ? '0.2rem 0.4rem' : '0.3rem 0.6rem',
// //                                                         backgroundColor: serviceChargeStatus === "APPLICABLE" ? '#4caf50' : '#e53e3e',
// //                                                         color: 'white',
// //                                                         border: 'none',
// //                                                         borderRadius: '0.25rem',
// //                                                         fontSize: window.innerWidth < 768 ? '0.7rem' : '0.8rem',
// //                                                         fontWeight: '600',
// //                                                         cursor: (isUpdatingServiceCharge || !cartData.cartId) ? 'not-allowed' : 'pointer',
// //                                                         transition: 'all 0.2s ease',
// //                                                         opacity: (isUpdatingServiceCharge || !cartData.cartId) ? 0.7 : 1,
// //                                                         minWidth: window.innerWidth < 480 ? '60px' : 'auto',
// //                                                         minHeight: window.innerWidth < 768 ? '28px' : '32px'
// //                                                     }}
// //                                                     title={!cartData.cartId ? "Add items to cart first" : ""}
// //                                                     onMouseOver={(e) => {
// //                                                         if (!isUpdatingServiceCharge && cartData.cartId) {
// //                                                             e.target.style.backgroundColor = serviceChargeStatus === "APPLICABLE" ? '#3d8b40' : '#c53030';
// //                                                         }
// //                                                     }}
// //                                                     onMouseOut={(e) => {
// //                                                         if (!isUpdatingServiceCharge && cartData.cartId) {
// //                                                             e.target.style.backgroundColor = serviceChargeStatus === "APPLICABLE" ? '#4caf50' : '#e53e3e';
// //                                                         }
// //                                                     }}
// //                                                 >
// //                                                     {isUpdatingServiceCharge ? (
// //                                                         '...'
// //                                                     ) : serviceChargeStatus === "APPLICABLE" ? (
// //                                                         'Remove'
// //                                                     ) : (
// //                                                         'Apply'
// //                                                     )}
// //                                                 </button>

// //                                                 <span style={{
// //                                                     minWidth: window.innerWidth < 768 ? '50px' : '60px',
// //                                                     textAlign: 'right',
// //                                                     fontSize: window.innerWidth < 1300 ? '0.85rem' : '1rem',
// //                                                     fontWeight: '500'
// //                                                 }}>
// //                                                     ₹{cartData.serviceCharges?.toFixed(2) || '0.00'}
// //                                                 </span>
// //                                             </div>
// //                                         </div>
// //                                     )}

// //                                     {cartData.gstTotal > 0 && (
// //                                         <div style={{
// //                                             display: 'flex',
// //                                             justifyContent: 'space-between',
// //                                             alignItems: 'center',
// //                                             marginBottom: window.innerWidth < 768 ? '0.6rem' : '0.75rem',
// //                                             fontSize: window.innerWidth < 1300 ? '0.85rem' : '1rem',
// //                                             color: '#4a5568'
// //                                         }}>
// //                                             <span>GST</span>
// //                                             <span>₹{cartData.gstTotal?.toFixed(2) || '0.00'}</span>
// //                                         </div>
// //                                     )}

// //                                     <div style={{
// //                                         borderTop: '1px solid #e2e8f0',
// //                                         margin: window.innerWidth < 768 ? '0.5rem 0' : '0.75rem 0'
// //                                     }}></div>

// //                                     <div style={{
// //                                         display: 'flex',
// //                                         justifyContent: 'space-between',
// //                                         alignItems: 'center',
// //                                         fontSize: window.innerWidth < 1300 ? '0.90rem' : (window.innerHeight <= 700 ? '1rem' : '1.1rem'),
// //                                         fontWeight: '700',
// //                                         color: '#2d3748',
// //                                         paddingTop: window.innerWidth < 768 ? '0.3rem' : '0.5rem'
// //                                     }}>
// //                                         <span>Grand Total</span>
// //                                         <span style={{
// //                                             color: '#b15cd6',
// //                                             fontSize: window.innerWidth < 480 ? '0.95rem' : (
// //                                                 window.innerWidth < 768 ? '1rem' : (
// //                                                     window.innerWidth < 1300 ? '0.9rem' : '1.3rem'
// //                                                 )
// //                                             )
// //                                         }}>
// //                                             ₹{grandTotal.toFixed(2)}
// //                                         </span>
// //                                     </div>
// //                                 </div>

// //                                 <div style={{
// //                                     fontSize: window.innerWidth < 768 ? '0.7rem' : '0.8rem',
// //                                     color: '#718096',
// //                                     textAlign: 'center',
// //                                     marginTop: window.innerWidth < 768 ? '0.3rem' : '0.5rem',
// //                                     padding: window.innerWidth < 768 ? '0.3rem' : '0.5rem',
// //                                     backgroundColor: '#f7fafc',
// //                                     borderRadius: '0.25rem',
// //                                     border: '1px solid #e2e8f0'
// //                                 }}>
// //                                     {cartData.orderType === 'DINE_IN' ? 'Dine In Order' : 'Take Away Order'}
// //                                 </div>
// //                             </div>
// //                         </div>

// //                         <div style={{
// //                             marginTop: '1rem',
// //                             padding: '1rem',
// //                             border: '1px solid #e2e8f0',
// //                             borderRadius: '0.25rem',
// //                             backgroundColor: 'white'
// //                         }}>
// //                             <div style={{
// //                                 fontSize: window.innerWidth < 1300 ? '0.9rem' : '1rem',
// //                                 fontWeight: '600',
// //                                 color: '#2d3748',
// //                                 marginBottom: '0.5rem'
// //                             }}>
// //                                 Select Payment Method
// //                             </div>

// //                             <div style={{ display: 'flex', gap: '1rem' }}>
// //                                 <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
// //                                     <input
// //                                         type="radio"
// //                                         name="payment"
// //                                         value="Cash"
// //                                         checked={selectedPaymentMethod === "Cash"}
// //                                         onChange={() => handlePaymentMethodChange("Cash")}
// //                                     />
// //                                     <span>Cash</span>
// //                                 </label>

// //                                 <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
// //                                     <input
// //                                         type="radio"
// //                                         name="payment"
// //                                         value="Online_Payment"
// //                                         checked={selectedPaymentMethod === "Online_Payment"}
// //                                         onChange={() => handlePaymentMethodChange("Online_Payment")}
// //                                     />
// //                                     <span>Online</span>
// //                                 </label>
// //                             </div>
// //                         </div>

// //                         {selectedPaymentMethod === "Cash" && (
// //                             <button
// //                                 onClick={() => handlePlaceOrder("Cash")}
// //                                 style={{
// //                                     width: '100%',
// //                                     backgroundColor: 'white',
// //                                     color: 'black',
// //                                     fontWeight: '700',
// //                                     fontSize: '1rem',
// //                                     padding: '12px',
// //                                     border: 'none',
// //                                     borderRadius: '0.5rem',
// //                                     marginTop: '1rem',
// //                                     cursor: 'pointer',
// //                                     transition: 'background-color 0.2s ease'
// //                                 }}
// //                                 onMouseOver={(e) => e.target.style.backgroundColor = '#f8f9fa'}
// //                                 onMouseOut={(e) => e.target.style.backgroundColor = 'white'}
// //                             >
// //                                 Place Order
// //                             </button>
// //                         )}

// //                         {selectedPaymentMethod === "Online_Payment" && loading && (
// //                             <div style={{
// //                                 textAlign: 'center',
// //                                 padding: '1rem',
// //                                 color: '#4a5568',
// //                                 fontSize: '0.9rem'
// //                             }}>
// //                                 Loading payment gateway...
// //                             </div>
// //                         )}
// //                     </>
// //                 ) : (
// //                     <div className="empty-cart">
// //                         Cart is empty
// //                     </div>
// //                 )}
// //             </div>
// //             <Modal
// //                 isOpen={showRemoveConfirm}
// //                 onRequestClose={cancelRemove}
// //                 contentLabel="Remove Item Confirmation"
// //                 style={{
// //                     overlay: {
// //                         backgroundColor: "rgba(0, 0, 0, 0.5)",
// //                         display: "flex",
// //                         alignItems: "center",
// //                         justifyContent: "center",
// //                         zIndex: 9999
// //                     },
// //                     content: {
// //                         position: "relative",
// //                         top: "auto",
// //                         left: "auto",
// //                         right: "auto",
// //                         bottom: "auto",
// //                         width: "90%",
// //                         maxWidth: "400px",
// //                         margin: "0 auto",
// //                         border: "none",
// //                         borderRadius: "10px",
// //                         padding: "2rem",
// //                         textAlign: "center",
// //                         boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)"
// //                     }
// //                 }}
// //             >
// //                 <div style={{ textAlign: "center" }}>
// //                     <h3 style={{
// //                         color: "#2d3748",
// //                         marginBottom: "1rem",
// //                         fontSize: "1.3rem"
// //                     }}>
// //                         Remove Item
// //                     </h3>
// //                     <p style={{
// //                         color: "#718096",
// //                         marginBottom: "2rem",
// //                         fontSize: "1rem",
// //                         lineHeight: "1.5"
// //                     }}>
// //                         Are you sure you want to remove<br />
// //                         <strong>"{itemToRemove?.cartItem?.dishName}"</strong><br />
// //                         from your cart?
// //                     </p>
// //                     <div style={{
// //                         display: "flex",
// //                         gap: "1rem",
// //                         justifyContent: "center"
// //                     }}>
// //                         <button
// //                             onClick={cancelRemove}
// //                             style={{
// //                                 padding: "0.75rem 1.5rem",
// //                                 border: "2px solid #e2e8f0",
// //                                 background: "white",
// //                                 color: "#4a5568",
// //                                 borderRadius: "0.5rem",
// //                                 cursor: "pointer",
// //                                 fontWeight: "600",
// //                                 fontSize: "1rem",
// //                                 transition: "all 0.2s ease"
// //                             }}
// //                             onMouseOver={(e) => {
// //                                 e.target.style.borderColor = "#b15cd6";
// //                                 e.target.style.color = "#b15cd6";
// //                             }}
// //                             onMouseOut={(e) => {
// //                                 e.target.style.borderColor = "#e2e8f0";
// //                                 e.target.style.color = "#4a5568";
// //                             }}
// //                         >
// //                             Cancel
// //                         </button>
// //                         <button
// //                             onClick={confirmRemove}
// //                             style={{
// //                                 padding: "0.75rem 1.5rem",
// //                                 border: "none",
// //                                 background: "#e53e3e",
// //                                 color: "white",
// //                                 borderRadius: "0.5rem",
// //                                 cursor: "pointer",
// //                                 fontWeight: "600",
// //                                 fontSize: "1rem",
// //                                 transition: "all 0.2s ease"
// //                             }}
// //                             onMouseOver={(e) => {
// //                                 e.target.style.background = "#c53030";
// //                             }}
// //                             onMouseOut={(e) => {
// //                                 e.target.style.background = "#e53e3e";
// //                             }}
// //                         >
// //                             Remove
// //                         </button>
// //                     </div>
// //                 </div>
// //             </Modal>

// //             {showCashPopup && (
// //                 <div style={{
// //                     position: 'fixed',
// //                     top: 0,
// //                     left: 0,
// //                     width: '100vw',
// //                     height: '100vh',
// //                     backgroundColor: 'rgba(0,0,0,0.5)',
// //                     display: 'flex',
// //                     justifyContent: 'center',
// //                     alignItems: 'center',
// //                     zIndex: 10000,
// //                     padding: '20px',
// //                 }}>
// //                     <div style={{
// //                         backgroundColor: '#fff',
// //                         padding: '24px',
// //                         borderRadius: '10px',
// //                         width: '90%',
// //                         maxWidth: '450px',
// //                         boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
// //                         fontFamily: 'sans-serif',
// //                     }}>
// //                         <h3 style={{ marginBottom: '16px', fontSize: '18px' }}>
// //                             Enter Cash Payment Details
// //                         </h3>



// //                         <div style={{
// //                             marginBottom: '20px',
// //                             backgroundColor: '#f9f9f9',
// //                             padding: '16px',
// //                             borderRadius: '8px',
// //                             border: '1px solid #eee',
// //                         }}>
// //                             <div style={{
// //                                 display: 'grid',
// //                                 gridTemplateColumns: screenWidth < 768 ? "1fr" : "repeat(3, 1fr)",
// //                                 gap: '10px 16px',
// //                             }}>
// //                                 {[1, 2, 5, 10, 20, 50, 100, 200, 500].map((denom) => (
// //                                     <div key={denom} style={{ display: 'flex', alignItems: 'center', fontWeight: "bold" }}>
// //                                         <label style={{ width: '50px', fontSize: '16px' }}>₹{denom}</label>
// //                                         <input
// //                                             type="number"
// //                                             value={notesCount[denom] || ''}
// //                                             onChange={(e) => handleNotesChange(denom, e.target.value)}
// //                                             placeholder="0"
// //                                             style={{
// //                                                 width: '60px',
// //                                                 padding: '6px',
// //                                                 borderRadius: '4px',
// //                                                 border: '1px solid #ccc',
// //                                                 fontSize: '14px',
// //                                             }}
// //                                         />
// //                                     </div>
// //                                 ))}
// //                             </div>

// //                             <div style={{
// //                                 marginTop: '16px',
// //                                 padding: '12px',
// //                                 backgroundColor: '#fff',
// //                                 borderRadius: '6px',
// //                                 border: '1px solid #e0e0e0'
// //                             }}>
// //                                 <div style={{
// //                                     display: 'flex',
// //                                     justifyContent: 'space-between',
// //                                     marginBottom: '6px',
// //                                     fontSize: '14px'
// //                                 }}>
// //                                     <span>Grand Total:</span>
// //                                     <strong style={{ color: '#2d3748' }}>₹{grandTotal.toFixed(2)}</strong>
// //                                 </div>
// //                                 <div style={{
// //                                     display: 'flex',
// //                                     justifyContent: 'space-between',
// //                                     marginBottom: '6px',
// //                                     fontSize: '14px'
// //                                 }}>
// //                                     <span>Denomination Total:</span>
// //                                     <strong style={{ color: '#2d3748' }}>₹{denominationTotal.toFixed(2)}</strong>
// //                                 </div>

// //                                 <div style={{
// //                                     display: 'flex',
// //                                     justifyContent: 'space-between',
// //                                     marginBottom: '6px',
// //                                     fontSize: '14px'
// //                                 }}>
// //                                     {remainingAmount >= 0 ? 'Return Amount:' : 'Remaining Amount:'}
// //                                     <strong style={{
// //                                         color: remainingAmount >= 0 ? '#4caf50' : '#f44336',
// //                                         fontWeight: 'bold'
// //                                     }}>
// //                                         {remainingAmount >= 0 ? '+' : ''}₹{Math.abs(remainingAmount).toFixed(2)}
// //                                     </strong>
// //                                 </div>


// //                             </div>
// //                         </div>



// //                         <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
// //                             <button
// //                                 style={{
// //                                     flex: 1,
// //                                     padding: '12px',
// //                                     backgroundColor: isSubmittingCash ? '#cccccc' : '#4caf50',
// //                                     border: 'none',
// //                                     borderRadius: '6px',
// //                                     color: 'white',
// //                                     fontWeight: 'bold',
// //                                     fontSize: '16px',
// //                                     cursor: isSubmittingCash ? 'not-allowed' : 'pointer',
// //                                     transition: 'background-color 0.3s'
// //                                 }}
// //                                 onClick={handleCashPaymentSubmit}
// //                                 disabled={!paidAmount || parseFloat(paidAmount) < grandTotal || isSubmittingCash}
// //                             >
// //                                 {isSubmittingCash ? 'Processing...' : 'Submit Payment'}
// //                             </button>
// //                             <button
// //                                 style={{
// //                                     flex: 1,
// //                                     padding: '12px',
// //                                     backgroundColor: '#f44336',
// //                                     border: 'none',
// //                                     borderRadius: '6px',
// //                                     color: 'white',
// //                                     fontWeight: 'bold',
// //                                     fontSize: '16px',
// //                                     cursor: 'pointer',
// //                                     transition: 'background-color 0.3s'
// //                                 }}
// //                                 onClick={() => {
// //                                     setShowCashPopup(false);
// //                                     setSelectedPaymentMethod("");
// //                                     setNotesCount({});
// //                                     setPaidAmount('');
// //                                 }}
// //                             >
// //                                 Cancel
// //                             </button>
// //                         </div>
// //                     </div>
// //                 </div>
// //             )}

// //             <style>{`
// //                 .cart-item-box {
// //                     padding: 0.5rem 0.5rem;
// //                     border-bottom: 0px solid #e9ecef;
// //                 }

// //                 .cart-item-row {
// //                     display: flex;
// //                     justify-content: space-between;
// //                     align-items: center;
// //                     gap: 1rem;
// //                 }

// //                 .item-name-container {
// //                     flex: 2;
// //                     min-width: 0;
// //                 }

// //                 .item-name {
// //                     font-weight: 500;
// //                     color: #2d3748;
// //                     white-space: nowrap;
// //                     overflow: hidden;
// //                     text-overflow: ellipsis;
// //                     max-width: 100%;
// //                 }

// //                 .item-controls-container {
// //                     flex: 1;
// //                     display: flex;
// //                     justify-content: space-between;
// //                     align-items: center;
// //                     min-width: 150px;
// //                 }

// //                 .quantity-controls {
// //                     display: flex;
// //                     align-items: center;
// //                     gap: 0.5rem;
// //                 }

// //                 .quantity-btn {
// //                     width: 24px;
// //                     height: 24px;
// //                     border-radius: 4px;
// //                     display: flex;
// //                     align-items: center;
// //                     justify-content: center;
// //                     cursor: pointer;
// //                     transition: all 0.2s ease;
// //                 }

// //                 .outline-btn {
// //                     border: 0px solid #b15cd6;
// //                     background: white;
// //                     color: #b15cd6;
// //                 }

// //                 .outline-btn:hover {
// //                     background: #b15cd6;
// //                     color: white;
// //                 }

// //                 .quantity-display {
// //                     min-width: 20px;
// //                     text-align: center;
// //                     font-weight: 600;
// //                     color: #2d3748;
// //                 }

// //                 .item-price {
// //                     font-weight: 600;
// //                     color: #2d3748;
// //                     min-width: 0px;
// //                     text-align: right;
// //                 }

// //                 .cart-content-container {
// //                     flex: 1;
// //                     overflow-y: auto;
// //                     padding-right: 4px;
// //                 }

// //                 .hide-scrollbar::-webkit-scrollbar {
// //                     width: 4px;
// //                 }

// //                 .hide-scrollbar::-webkit-scrollbar-track {
// //                     background: #f1f1f1;
// //                     border-radius: 4px;
// //                 }

// //                 .hide-scrollbar::-webkit-scrollbar-thumb {
// //                     background: #b15cd6;
// //                     border-radius: 4px;
// //                 }

// //                 .empty-cart {
// //                     text-align: center;
// //                     padding: 3rem 1rem;
// //                     color: #718096;
// //                     font-size: 1.1rem;
// //                     background: white;
// //                     border-radius: 0.5rem;
// //                     border: 1px solid #e9ecef;
// //                 }

// //                 .total-section {
// //                     padding: 1rem;
// //                     border-top: 0px solid #e9ecef;
// //                 }

// //                 @media (max-width: 1399px) {
// //                 .total-section {
// //                     padding: 0.5rem;
// //                     border-top: 0px solid #e9ecef;
// //                 }
// //                     .cart-item-row {
// //                         flex-direction: column;
// //                         align-items: flex-start;
// //                         gap: 0.5rem;
// //                     }

// //                     .item-name-container {
// //                         width: 100%;
// //                         margin-bottom: 0rem;
// //                     }

// //                     .item-name {
// //                         font-size: 13px;
// //                         width: 100%;
// //                     }

// //                     .item-controls-container {
// //                         width: 100%;
// //                         justify-content: space-between;
// //                         min-width: auto;
// //                     }

// //                     .quantity-controls {
// //                         margin-left: 0;
// //                     }

// //                     .quantity-btn {
// //                         width: 22px;
// //                         height: 22px;
// //                     }

// //                     .quantity-icon {
// //                         width: 9px;
// //                         height: 9px;
// //                     }

// //                     .quantity-display {
// //                         font-size: 13px;
// //                         min-width: 18px;
// //                     }

// //                     .item-price {
// //                         font-size: 13px;
// //                         min-width: 0px;
// //                         text-align: right;
// //                         margin-left: auto;
// //                     }
// //                 }

// //                 @media (max-width: 768px) {
// //                     .cart-item-box {
// //                         padding: 0.5rem;
// //                     }

// //                     .quantity-btn {
// //                         width: 20px;
// //                         height: 20px;
// //                     }

// //                     .quantity-icon {
// //                         width: 8px;
// //                         height: 8px;
// //                     }

// //                     .quantity-display {
// //                         min-width: 16px;
// //                         font-size: 12px;
// //                     }

// //                     .item-price {
// //                         min-width: 0px;
// //                         font-size: 12px;
// //                     }

// //                     .item-name {
// //                         font-size: 12px;
// //                     }
// //                 }
// //                     @media(max-width:1200px) {
// //                     .endalign{
// //                     text-align:end;
// //                     }
// //                     }
// //             `}</style>
// //             <style>{`
    

// //     .cart-item-row {
// //         display: flex;
// //         justify-content: space-between;
// //         align-items: center;
// //         gap: 1rem;
// //     }

// //     .item-name-container {
// //         flex: 2;
// //         min-width: 0;
// //     }

// //     .item-name {
// //         font-weight: 500;
// //         color: #2d3748;
// //         white-space: nowrap;
// //         overflow: hidden;
// //         text-overflow: ellipsis;
// //         max-width: 100%;
// //         font-size: 0.9rem;
// //     }

// //     .item-controls-container {
// //         flex: 2;
// //         display: flex;
// //         justify-content: space-between;
// //         align-items: center;
// //         min-width: 180px;
// //     }

// //     .quantity-controls {
// //         flex: 1;
// //         display: flex;
// //         align-items: center;
// //         justify-content: center;
// //         gap: 0rem;
// //     }

// //     .quantity-btn {
// //         width: 26px;
// //         height: 26px;
// //         border-radius: 4px;
// //         display: flex;
// //         align-items: center;
// //         justify-content: center;
// //         cursor: pointer;
// //         transition: all 0.2s ease;
// //     }

// //     .outline-btn {
// //         border: 0px solid #b15cd6;
// //         background: white;
// //         color: #b15cd6;
// //     }

// //     .outline-btn:hover {
// //         background: #b15cd6;
// //         color: white;
// //     }

// //     .quantity-display {
// //         min-width: 25px;
// //         text-align: center;
// //         font-weight: 600;
// //         color: #2d3748;
// //         font-size: 0.9rem;
// //     }

// //     .item-price {
// //         flex: 1;
// //         font-weight: 600;
// //         color: #2d3748;
// //         text-align: right;
// //         font-size: 0.9rem;
// //     }

// //     /* Responsive for screens < 1399px */
// //     @media (max-width: 1399px) {
        
        
// //         .cart-item-row {
// //             flex-direction: row;
// //             justify-content: space-between;
// //             gap: 0.75rem;
// //         }

// //         .item-name-container {
// //             flex: 1;
// //             min-width: 0;
// //         }

// //         .item-name {
// //             font-size: 0.85rem;
// //             white-space: normal;
// //             line-height: 1.3;
// //         }

// //         .item-controls-container {
// //             flex-direction: row;
// //             align-items: center;
            
// //             min-width: 120px;
// //         }

// //         .quantity-controls {
// //             justify-content: center;
// //         }

// //         .quantity-btn {
// //             width: 24px;
// //             height: 24px;
// //         }

// //         .quantity-icon {
// //             width: 10px;
// //             height: 10px;
// //         }

// //         .quantity-display {
// //             min-width: 22px;
// //             font-size: 0.85rem;
// //         }

// //         .item-price {
// //             text-align: right;
// //             font-size: 0.85rem;
// //             min-width: 0px;
// //         }
// //     }

// //     /* For very small screens */
// //     @media (max-width: 768px) {
// //         .cart-item-box {
// //             padding: 0.5rem;
// //         }

// //         .cart-item-row {
// //             gap: 0.5rem;
// //         }

// //         .item-name {
// //             font-size: 0.8rem;
// //         }

// //         .item-controls-container {
// //             gap: 0.5rem;
// //             min-width: 100px;
// //         }

// //         .quantity-btn {
// //             width: 22px;
// //             height: 22px;
// //         }

// //         .quantity-display {
// //             min-width: 20px;
// //             font-size: 0.8rem;
// //         }

// //         .item-price {
// //             font-size: 0.8rem;
// //             min-width: 0px;
// //         }
// //     }
// // `}</style>
// //         </div>
// //     );
// // };

// // export default MenuCartSidebar;




// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import Modal from 'react-modal';
// import { FaPlus, FaMinus, FaTrash, FaPrint, FaDownload, FaCheck, FaTimes } from "react-icons/fa"; import { useNavigate } from 'react-router-dom';
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
// import "./MenuCartSidebar.css";

// Modal.setAppElement('#root');

// const MenuCartSidebar = () => {
//     const navigate = useNavigate();
//     const [cartData, setCartData] = useState({ cartItems: [] });
//     const [quantities, setQuantities] = useState({});
//     const [grandTotal, setGrandTotal] = useState(0);
//     const [refresh, setRefresh] = useState(0);
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [isHovered, setIsHovered] = useState(false);
//     const [itemToRemove, setItemToRemove] = useState(null);
//     const [showRemoveConfirm, setShowRemoveConfirm] = useState(false);
//     const [userId, setUserId] = useState(localStorage.getItem("userId") || 3);
//     const [loading, setLoading] = useState(false);
//     const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
//     const [savedDetails, setSavedDetails] = useState(null);
//     const [vendorDetails, setVendorDetails] = useState({
//         name: "",
//         email: "",
//         phone: ""
//     });
//     const vendorDetailsRef = useRef({
//         name: "",
//         email: "",
//         phone: ""
//     });
//     const [showCashPopup, setShowCashPopup] = useState(false);
//     const [notesCount, setNotesCount] = useState({});
//     const [paidAmount, setPaidAmount] = useState('');
//     const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//     const [showReceipt, setShowReceipt] = useState(false);
//     const [orderData, setOrderData] = useState({});
//     const [bannerData, setBannerData] = useState(null);
//     const [isProcessingBack, setIsProcessingBack] = useState(false);
//     const [isPrinting, setIsPrinting] = useState(false);
//     const [isSubmittingCash, setIsSubmittingCash] = useState(false);
//     const printRef = useRef();
//     const receiptRef = useRef();
//     // Add this with other useState declarations
//     const [serviceChargeStatus, setServiceChargeStatus] = useState("NOT_APPLICABLE");
//     const [isUpdatingServiceCharge, setIsUpdatingServiceCharge] = useState(false);

//     // Add effect for screen resize
//     useEffect(() => {
//         const handleResize = () => setScreenWidth(window.innerWidth);
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);
//     // Add this function in your component
//     const toggleServiceCharge = async () => {
//         const token = localStorage.getItem("authToken");
//         const cartId = localStorage.getItem("cartId");

//         if (!token || !cartId) {
//             alert("Unable to update service charge. Missing required data.");
//             return;
//         }

//         const newStatus = serviceChargeStatus === "APPLICABLE" ? "NOT_APPLICABLE" : "APPLICABLE";

//         setIsUpdatingServiceCharge(true);

//         try {
//             const response = await axios.put(
//                 `https://backend.maamaas.com/food/api/cart/coupon/${cartId}`,
//                 {
//                     serviceCharge: newStatus
//                 },
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         "Content-Type": "application/json"
//                     }
//                 }
//             );

//             if (response.status === 200) {
//                 setServiceChargeStatus(newStatus);
//                 // Refresh cart data to update charges
//                 fetchCartData();
//                 alert(`Service charge ${newStatus === "APPLICABLE" ? "applied" : "removed"} successfully`);
//             }
//         } catch (error) {
//             console.error("Error updating service charge:", error);
//             alert("Failed to update service charge. Please try again.");
//         } finally {
//             setIsUpdatingServiceCharge(false);
//         }
//     };

//     useEffect(() => {
//         // When order type changes to TAKEAWAY, automatically remove service charges
//         if (cartData.orderType === 'TAKEAWAY' && serviceChargeStatus === "APPLICABLE") {
//             const removeServiceChargesForTakeaway = async () => {
//                 const token = localStorage.getItem("authToken");
//                 const cartId = localStorage.getItem("cartId");

//                 if (!token || !cartId) return;

//                 setIsUpdatingServiceCharge(true);

//                 try {
//                     await axios.put(
//                         `https://backend.maamaas.com/food/api/cart/coupon/${cartId}`,
//                         {
//                             serviceCharge: "NOT_APPLICABLE"
//                         },
//                         {
//                             headers: {
//                                 Authorization: `Bearer ${token}`,
//                                 "Content-Type": "application/json"
//                             }
//                         }
//                     );

//                     setServiceChargeStatus("NOT_APPLICABLE");
//                     await fetchCartData(); // Refresh cart to update totals
//                     console.log("✅ Service charges removed for Takeaway order");
//                 } catch (error) {
//                     console.error("Failed to remove service charges for Takeaway:", error);
//                 } finally {
//                     setIsUpdatingServiceCharge(false);
//                 }
//             };

//             removeServiceChargesForTakeaway();
//         }
//     }, [cartData.orderType, serviceChargeStatus]);
//     // Fetch vendor details
//     const fetchVendorDetails = async () => {
//         const vendorId = localStorage.getItem("vendorId");
//         const token = localStorage.getItem("authToken");

//         if (!vendorId || !token) return;

//         try {
//             // ✅ USE THE SAME ENDPOINT AS MANAGEMENT5
//             const response = await axios.get(
//                 `https://backend.maamaas.com/food/api/vendors/${vendorId}`,
//                 {
//                     headers: { Authorization: `Bearer ${token}` }
//                 }
//             );

//             if (response.data) {
//                 const vendorData = response.data;

//                 // ✅ EXACT SAME LOGIC AS MANAGEMENT5
//                 const vendorMobile =
//                     vendorData?.mobileNumber && vendorData.mobileNumber.toString().trim() !== ""
//                         ? vendorData.mobileNumber.toString()
//                         : "9999999999";

//                 const vendorName =
//                     vendorData?.ownerName && vendorData.ownerName.trim() !== ""
//                         ? vendorData.ownerName
//                         : "Vendor";

//                 const vendorEmail =
//                     vendorData?.email && vendorData.email.trim() !== ""
//                         ? vendorData.email
//                         : "vendor@example.com";

//                 setVendorDetails({
//                     name: vendorName,
//                     email: vendorEmail,
//                     phone: vendorMobile  // ✅ This will be used in payment
//                 });

//                 console.log("✅ Vendor details fetched:", { vendorMobile, vendorName, vendorEmail });
//             }
//         } catch (error) {
//             console.error("❌ Error fetching vendor details:", error);

//             // ✅ Use same fallback as Management5
//             setVendorDetails({
//                 name: "Vendor",
//                 email: "vendor@example.com",
//                 phone: "9999999999"  // Same fallback number
//             });
//         }

//         console.log("Vendor phone for payment:", vendorDetails.phone);
//     };


//     useEffect(() => {
//         fetchCartData();
//         fetchVendorDetails();  // ✅ ADD THIS LINE
//         fetchBannerData();
//     }, [refresh]);

//     const loadRazorpayScript = () => {
//         return new Promise((resolve) => {
//             const script = document.createElement('script');
//             script.src = "https://checkout.razorpay.com/v1/checkout.js";
//             script.onload = () => resolve(true);
//             script.onerror = () => resolve(false);
//             document.body.appendChild(script);
//         });
//     };

//     const fetchOrderDetails = async (orderId) => {
//         try {
//             const authToken = localStorage.getItem("authToken");
//             if (!authToken) {
//                 console.error("❌ No auth token found in localStorage");
//                 return;
//             }

//             const response = await axios.get(
//                 `https://backend.maamaas.com/food/api/orders/order/${orderId}`,
//                 {
//                     headers: {
//                         "Authorization": `Bearer ${authToken}`,
//                         "Content-Type": "application/json",
//                     },
//                 }
//             );

//             if (response.status === 200) {
//                 setOrderData(response.data);
//                 return response.data;
//             }
//         } catch (error) {
//             console.error("❌ Failed to fetch order details:", error.response?.data || error.message);
//         }
//     };

//     const fetchBannerData = async () => {
//         const vendorId = localStorage.getItem("vendorId");
//         if (!vendorId) return;

//         try {
//             const token = localStorage.getItem("authToken");
//             const response = await axios.get(
//                 `https://backend.maamaas.com/food/banner/vendor/${vendorId}`,
//                 {
//                     headers: { Authorization: `Bearer ${token}` }
//                 }
//             );

//             setBannerData({
//                 ...response.data,
//                 companyName: response.data.companyName || "MAAMAAS HOUSE",
//             });
//         } catch (err) {
//             console.error("Error fetching banner data:", err);
//         }
//     };
//     // const triggerFullRefresh = () => {
//     //     // Trigger refresh for all components
//     //     setRefresh(prev => prev + 1);

//     //     // Dispatch a custom event for other components to listen to
//     //     const event = new CustomEvent('fullRefresh');
//     //     window.dispatchEvent(event);

//     //     // Also force fetch cart data
//     //     fetchCartData();
//     // };
//     useEffect(() => {
//         fetchVendorDetails();
//     }, []);

//     const handlePlaceOrder = async (paymentMethodParam = null) => {
//         const vendorId = localStorage.getItem("vendorId");
//         const token = localStorage.getItem("authToken");
//         const cartId = localStorage.getItem("cartId");

//         if (!userId) {
//             alert("User ID not found. Please log in again.");
//             return;
//         }

//         const paymentMethod = paymentMethodParam || selectedPaymentMethod;

//         if (!paymentMethod) {
//             alert("Please select a payment method");
//             return;
//         }

//         try {
//             localStorage.removeItem("orderId");

//             if (paymentMethod === "Online_Payment") {
//                 try {
//                     const isRazorpayLoaded = await loadRazorpayScript();
//                     if (!isRazorpayLoaded) {
//                         alert("❌ Razorpay SDK failed to load.");
//                         setLoading(false);
//                         return;
//                     }

//                     const amountInPaise = Math.round(grandTotal * 100);
//                     const displayAmount = amountInPaise / 100;

//                     const orderResponse = await fetch(
//                         "https://backend.maamaas.com/food/api/payments/create-order",
//                         {
//                             method: "POST",
//                             headers: {
//                                 "Content-Type": "application/json",
//                                 Authorization: `Bearer ${token}`,
//                             },
//                             body: JSON.stringify({
//                                 amount: displayAmount,
//                                 phoneNumber: vendorDetails.phone,
//                                 currency: "INR",
//                                 receipt: `order_${Date.now()}`,
//                                 notes: {
//                                     customer_name: vendorDetails.name,
//                                     order_reference: `WEB_ORDER_${Math.floor(Math.random() * 10000)}`,
//                                 },
//                             }),
//                         }
//                     );

//                     if (!orderResponse.ok) throw new Error("❌ Failed to create Razorpay order");
//                     const orderData = await orderResponse.json();

//                     const options = {
//                         key: "rzp_live_RU5whSMu9rPV7s",
//                         amount: amountInPaise,
//                         currency: "INR",
//                         order_id: orderData.orderId,
//                         name: "Maamaa's House",
//                         description: "Order Payment",
//                         // In the Razorpay options:
//                         prefill: {
//                             name: vendorDetails.name,
//                             email: vendorDetails.email,
//                             contact: vendorDetails.phone,  // ✅ This now has the vendor's mobile
//                         },
//                         theme: { color: "#3399cc" },

//                         handler: async function (response) {
//                             try {
//                                 const capturePayload = {
//                                     paymentId: response.razorpay_payment_id,
//                                     amount: amountInPaise / 100,
//                                     currency: "INR",
//                                     receipt: `receipt_${Date.now()}`,
//                                 };


//                                 const captureRes = await fetch(
//                                     "https://backend.maamaas.com/food/api/payments/capture",
//                                     {
//                                         method: "POST",
//                                         headers: {
//                                             "Content-Type": "application/json",
//                                             Authorization: `Bearer ${token}`,
//                                         },
//                                         body: JSON.stringify(capturePayload),
//                                     }
//                                 );

//                                 const captureData = await captureRes.json();

//                                 if (!captureRes.ok || captureData.status !== "captured") {
//                                     alert("❌ Payment capture failed!");
//                                     return;
//                                 }

//                                 const backendOrderParams = {
//                                     vendorId: vendorId,
//                                     paymentMethod: "Online_Payment",
//                                     razorpayPaymentId: response.razorpay_payment_id,
//                                     razorpayOrderId: 1,
//                                     phoneNumber: vendorDetails.phone,  // ✅ Use the fetched vendor phone
//                                 };

//                                 const responseOrder = await axios.post(
//                                     `https://backend.maamaas.com/food/api/orders/orders/vendor/create/${cartId}`,
//                                     "",
//                                     {
//                                         params: backendOrderParams,
//                                         headers: { Authorization: `Bearer ${token}` },
//                                         validateStatus: false,
//                                     }
//                                 );

//                                 if (responseOrder.status === 200 || responseOrder.status === 201) {
//                                     const orderId = responseOrder.data.orderId;
//                                     localStorage.setItem("orderId", orderId);

//                                     const orderDetails = await fetchOrderDetails(orderId);
//                                     if (orderDetails) {
//                                         // Set payment method to Online_Payment for auto-print
//                                         orderDetails.paymentMethod = "Online_Payment";
//                                         setOrderData(orderDetails);
//                                         setShowReceipt(true);
//                                         fetchBannerData();

//                                         // Clear cart data
//                                         setCartData({ cartItems: [] });
//                                         setQuantities({});
//                                         setGrandTotal(0);
//                                         setSelectedPaymentMethod("");

//                                         // ✅ AUTO-REFRESH: Trigger full page refresh after 2 seconds
//                                         // setTimeout(() => {
//                                         //     window.location.reload();
//                                         // }, 20000);

//                                         // ✅ Trigger cart refresh for other components
//                                         // triggerCartRefresh();
//                                         // triggerFullRefresh();
//                                     }
//                                 } else {
//                                     alert("❌ Order creation failed after payment!");
//                                 }

//                             } catch (err) {
//                                 alert("❌ Something went wrong after payment.");
//                             }
//                         },
//                     };

//                     const paymentObject = new window.Razorpay(options);
//                     paymentObject.open();
//                     return;
//                 } catch (err) {
//                     alert("❌ Razorpay flow failed.");
//                     setLoading(false);
//                     return;
//                 }
//             }

//             // Cash Payment Flow - Modified to stay in sidebar

//             const cashParams = {
//                 vendorId,
//                 paymentMethod: "Cash"
//             };

//             const cashRes = await axios.post(
//                 `https://backend.maamaas.com/food/api/orders/orders/vendor/create/${cartId}`,
//                 "",
//                 {
//                     params: cashParams,
//                     headers: { Authorization: `Bearer ${token}` }
//                 }
//             );

//             if (cashRes.data.orderId) {
//                 const orderId = cashRes.data.orderId;
//                 localStorage.setItem("orderId", orderId);

//                 // Don't navigate, just show cash popup
//                 setShowCashPopup(true);
//                 setPaidAmount(grandTotal.toFixed(2));

//                 alert("Order created! Please enter cash payment details.");

//             } else {
//                 alert("⚠️ Cash Order creation failed");
//             }

//         } catch (error) {
//             console.error("🚨 Checkout Error:", error);
//             alert("Failed to proceed to checkout.");
//         }
//     };






//     useEffect(() => {
//         const handleFullRefresh = () => {
//             fetchCartData();
//             setRefresh(prev => prev + 1);
//         };

//         window.addEventListener('fullRefresh', handleFullRefresh);

//         return () => {
//             window.removeEventListener('fullRefresh', handleFullRefresh);
//         };
//     }, []);
//     // Check for pending receipt on mount
//     useEffect(() => {
//         const checkPendingReceipt = async () => {
//             const showReceiptFlag = localStorage.getItem("showReceipt");
//             const receiptOrderId = localStorage.getItem("receiptOrderId");
//             const receiptTimestamp = localStorage.getItem("receiptTimestamp");
//             const currentTime = Date.now();

//             if (showReceiptFlag === "true" && receiptOrderId) {
//                 // Check if receipt is recent (less than 5 minutes old)
//                 if (!receiptTimestamp || (currentTime - parseInt(receiptTimestamp)) < 5 * 60 * 1000) {
//                     try {
//                         const orderDetails = await fetchOrderDetails(receiptOrderId);
//                         if (orderDetails) {
//                             setOrderData(orderDetails);
//                             setShowReceipt(true);
//                             await fetchBannerData();
//                         }
//                     } catch (err) {
//                         console.error("Error showing pending receipt:", err);
//                     }
//                 } else {
//                     // Clear old receipt data
//                     localStorage.removeItem("showReceipt");
//                     localStorage.removeItem("receiptOrderId");
//                     localStorage.removeItem("receiptOrderData");
//                     localStorage.removeItem("receiptTimestamp");
//                 }
//             }
//         };

//         checkPendingReceipt();
//     }, []);

//     const handlePaymentMethodChange = async (method) => {
//         setSelectedPaymentMethod(method);

//         if (method === "Online_Payment") {
//             await handlePlaceOrder(method);
//         }

//         if (method === "Cash") {
//             // Show cash popup immediately for cash payment
//             setShowCashPopup(true);
//             setPaidAmount(grandTotal.toFixed(2));
//         }
//     };

//     const handleNotesChange = (denomination, count) => {
//         if (count === '' || /^[0-9\b]+$/.test(count)) {
//             setNotesCount((prev) => {
//                 const newNotesCount = {
//                     ...prev,
//                     [denomination]: count,
//                 };

//                 let totalFromDenominations = 0;
//                 Object.keys(newNotesCount).forEach(denom => {
//                     const noteCount = parseInt(newNotesCount[denom]) || 0;
//                     totalFromDenominations += noteCount * parseInt(denom);
//                 });

//                 if (totalFromDenominations > 0) {
//                     setPaidAmount(totalFromDenominations.toFixed(2));
//                 }

//                 return newNotesCount;
//             });
//         }
//     };

//     const handleCashPaymentSubmit = async () => {
//         const token = localStorage.getItem("authToken");
//         const vendorId = localStorage.getItem("vendorId");
//         const cartId = localStorage.getItem("cartId");

//         if (!token || !vendorId || !cartId) {
//             alert("Authentication error. Please try again.");
//             return;
//         }

//         const paid = parseFloat(paidAmount);
//         if (isNaN(paid) || paid <= 0) {
//             alert("Please enter a valid paid amount.");
//             return;
//         }

//         if (paid < grandTotal) {
//             alert(`Paid amount (₹${paid.toFixed(2)}) is less than the grand total (₹${grandTotal.toFixed(2)}).`);
//             return;
//         }

//         setIsSubmittingCash(true);

//         const returnMoney = parseFloat((paid - grandTotal).toFixed(2));

//         // Get current date in YYYY-MM-DD format
//         const currentDate = new Date().toISOString().split('T')[0];

//         const cashPaymentData = {
//             id: 0,
//             orderId: 0,
//             oneRupee: parseInt(notesCount[1] || 0),
//             twoRupee: parseInt(notesCount[2] || 0),
//             fiveRupee: parseInt(notesCount[5] || 0),
//             tenRupee: parseInt(notesCount[10] || 0),
//             twentyRupee: parseInt(notesCount[20] || 0),
//             fiftyRupee: parseInt(notesCount[50] || 0),
//             hundredRupee: parseInt(notesCount[100] || 0),
//             twoHundredRupee: parseInt(notesCount[200] || 0),
//             fiveHundredRupee: parseInt(notesCount[500] || 0),
//             twoThousandRupee: 0,
//             grandTotal: grandTotal,
//             paid: paid,
//             returnMoney: returnMoney,
//             date: currentDate, // Just add this line - date in YYYY-MM-DD format
//         };

//         try {
//             // First create the order
//             const orderResponse = await axios.post(
//                 `https://backend.maamaas.com/food/api/orders/orders/vendor/create/${cartId}`,
//                 "",
//                 {
//                     params: {
//                         vendorId,
//                         paymentMethod: "Cash"
//                     },
//                     headers: { Authorization: `Bearer ${token}` }
//                 }
//             );

//             if (orderResponse.data.orderId) {
//                 const orderId = orderResponse.data.orderId;
//                 cashPaymentData.orderId = orderId;

//                 // Submit cash payment details
//                 await axios.post(
//                     `https://backend.maamaas.com/food/api/cash-billing/addCash/${orderId}`,
//                     cashPaymentData,
//                     {
//                         headers: {
//                             Authorization: `Bearer ${token}`,
//                             "Content-Type": "application/json",
//                         },
//                     }
//                 );

//                 // ✅ NEW: Update payment status to PAID
//                 try {
//                     // Assuming the API endpoint is like this (you might need to adjust the endpoint)
//                     await axios.put(
//                         `https://backend.maamaas.com/food/api/payments/update-status/${orderId}`,
//                         { paymentStatus: "PAID" }, // or just "PAID" as string if that's what the API expects
//                         {
//                             headers: {
//                                 Authorization: `Bearer ${token}`,
//                                 "Content-Type": "application/json",
//                             },
//                         }
//                     );
//                 } catch (statusError) {
//                     console.error("⚠️ Failed to update payment status:", statusError);
//                     // Don't fail the entire process if status update fails
//                     // The payment is still successful, just the status might not be updated
//                 }

//                 // Fetch order details and show receipt in sidebar
//                 const orderDetails = await fetchOrderDetails(orderId);
//                 if (orderDetails) {
//                     // Clear cart data locally
//                     setCartData({ cartItems: [] });
//                     setQuantities({});
//                     setGrandTotal(0);
//                     setSelectedPaymentMethod("");

//                     // Fetch banner data for receipt
//                     await fetchBannerData();

//                     // Show receipt in sidebar
//                     setOrderData(orderDetails);
//                     setShowReceipt(true);

//                     // Close cash popup
//                     setShowCashPopup(false);
//                     setNotesCount({});
//                     setPaidAmount('');

//                     // ✅ AUTO-REFRESH: Trigger full page refresh after 2 seconds
//                     // setTimeout(() => {
//                     //     window.location.reload();
//                     // }, 20000);

//                     // ✅ Also trigger cart refresh for other components immediately
//                     triggerCartRefresh();
//                     // triggerFullRefresh();
//                 } else {
//                     alert("⚠️ Payment submitted but couldn't fetch order details.");
//                 }
//             }
//         } catch (error) {
//             console.error("Cash payment error:", error);
//             alert("Failed to process cash payment.");
//         } finally {
//             setIsSubmittingCash(false);
//         }
//     };
//     // Auto-print effect for cash receipts
//     // Auto-print effect for receipts (both Cash and Online Payment)
//     useEffect(() => {
//         // Only auto-print when receipt is shown and order data is available
//         if (showReceipt && orderData.orderId && !isPrinting) {
//             // Check if we've already printed this receipt
//             const hasPrintedKey = `hasPrinted_${orderData.orderId}`;
//             const hasPrinted = localStorage.getItem(hasPrintedKey);

//             // Determine payment method for auto-print
//             const isCashPayment = orderData.paymentMethod === "Cash";
//             const isOnlinePayment = orderData.paymentMethod === "Online_Payment";

//             // Auto-print for both payment methods
//             if ((isCashPayment || isOnlinePayment) && !hasPrinted) {
//                 // Set a flag to prevent re-printing
//                 localStorage.setItem(hasPrintedKey, 'true');

//                 // Wait a bit for the DOM to fully render
//                 // const printTimer = setTimeout(() => {
//                 //     if (printRef.current) {
//                 //         handlePrint();
//                 //     }
//                 // }, 1000); // Increased delay for better rendering

//                 // return () => clearTimeout(printTimer);
//             } else if (hasPrinted) {
//             }
//         }
//     }, [showReceipt, orderData, isPrinting]);

//     const fetchCartData = async () => {
//         const vendorId = localStorage.getItem("vendorId");
//         const authToken = localStorage.getItem("authToken");

//         if (!vendorId || !authToken) return;

//         try {
//             const response = await axios.get(
//                 `https://backend.maamaas.com/food/api/cart/vendor/${vendorId}`,
//                 { headers: { Authorization: `Bearer ${authToken}` } }
//             );

//             if (response.data) {
//                 const data = response.data;
//                 setCartData(data);
//                 setGrandTotal(data.grandTotal || 0);

//                 if (data.cartId) {
//                     localStorage.setItem("cartId", data.cartId);
//                 }
//                 if (data.serviceCharges > 0) {
//                     setServiceChargeStatus("APPLICABLE");
//                 } else {
//                     setServiceChargeStatus("NOT_APPLICABLE");
//                 }

//                 const updatedQuantities = (data.cartItems || []).reduce((acc, item) => {
//                     acc[item.dishId] = item.quantity || 1;
//                     return acc;
//                 }, {});
//                 setQuantities(updatedQuantities);
//             }
//         } catch (err) {
//             console.error("Error fetching cart data:", err);
//         }
//     };

//     const closeReceipt = () => {
//         if (isProcessingBack) return;

//         setIsProcessingBack(true);

//         // Clear all receipt flags from localStorage
//         localStorage.removeItem("showReceipt");
//         localStorage.removeItem("receiptOrderId");
//         localStorage.removeItem("receiptOrderData");
//         localStorage.removeItem("receiptTimestamp");
//         localStorage.removeItem("pendingReceiptShow");
//         localStorage.removeItem("pendingReceiptOrderId");
//         localStorage.removeItem("pendingReceiptPaymentMethod");

//         // Clear the printed flag for this order
//         if (orderData?.orderId) {
//             localStorage.removeItem(`hasPrinted_${orderData.orderId}`);
//         }

//         // Hide receipt
//         setShowReceipt(false);
//         setOrderData({});

//         // Fetch fresh cart data
//         fetchCartData();

//         // Trigger cart refresh for other components
//         triggerCartRefresh();

//         // Reset processing flag after delay
//         setTimeout(() => {
//             setIsProcessingBack(false);
//         }, 500);
//     };

//     // const handlePrint = () => {
//     //     // Check for order data (important for auto-print)
//     //     if (!orderData || !orderData.orderId) {
//     //         console.error("No order data available for printing");
//     //         return;
//     //     }

//     //     // Store original content (only needed for manual print)
//     //     const originalContent = document.body.innerHTML;

//     //     const printStyles = `
//     // <style>
//     // @media print {
//     //     body {
//     //         width: 80mm !important;
//     //         margin: 0 auto !important;
//     //         padding: 0 !important;
//     //         font-family: "Courier New", monospace !important;
//     //         font-size: 10px !important;
//     //         line-height: 1.2 !important;
//     //         font-weight:900 !important;
//     //     }

//     //     h1, h2, h3 {
//     //         font-weight: bold;
//     //         text-align: center;
//     //         margin: 0;
//     //         padding: 0;
//     //     }

//     //     .big-title {
//     //         font-size: 14px !important;
//     //         font-weight: bold;
//     //         text-align: center;
//     //         margin-bottom: 5px;
//     //     }

//     //     .center-text {
//     //         text-align: center;
//     //         font-size: 10px;
//     //         font-weight: bold;
//     //     }

//     //     .line {
//     //         border-top: 1px solid black;
//     //         margin: 6px 0;
//     //     }

//     //     .dashed {
//     //         border-top: 1px dashed black;
//     //         margin: 6px 0;
//     //     }

//     //     table {
//     //         width: 100%;
//     //         font-size: 10px;
//     //         border-collapse: collapse;
//     //     }

//     //     th{
//     //         padding: 0px 0px;
//     //         font-weight: bold;
//     //     }
//     //     td { 
//     //         padding: 2px 0px;
//     //         font-weight: bold;
//     //     }

//     //     .row {
//     //         display: flex;
//     //         justify-content: space-around;
//     //         font-size: 10px;
//     //         font-weight: bold;
//     //         white-space: nowrap;
//     //         width: 100%;

//     //     }

//     //     .grand-label {
//     //         font-size: 16px;
//     //         font-weight: bold;
//     //     }

//     //     .grand-value {
//     //         font-size: 16px;
//     //         font-weight: bold;
//     //     }

//     //     .footer {
//     //         text-align: center;
//     //         margin-top: 10px;
//     //         font-size: 10px;
//     //     }

//     //     .receipt-buttons, button {
//     //         display: none !important;
//     //     }

//     //     @page {
//     //         size: 80mm auto;
//     //         margin: 0;
//     //     }

//     //     .page-break {
//     //         page-break-after: always;
//     //     }
//     // }
//     // </style>
//     // `;

//     //     // SIMPLE RECEIPT (Top Image) - HARDCODED "Take A Break"
//     //     const receiptOne = `
//     //     <div class="big-title">Take A Break</div>
//     //     <div class="line"></div>

//     //     <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
//     //     <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>

//     //     <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

//     //     <div class="line"></div>

//     //     <table>
//     //         <thead>
//     //             <tr>
//     //                 <th style="text-align:center;">Item</th>
//     //                 <th style="text-align:center;">Qty</th>
//     //             </tr>
//     //         </thead>
//     //         <tbody>
//     //             ${Array.isArray(orderData.order) ? orderData.order.map(item => `
//     //                 <tr>
//     //                     <td style="text-align:center;">${item.dishName || "Item"}</td>
//     //                     <td style="text-align:center;">${item.quantity || 1}</td>
//     //                 </tr>
//     //             `).join("") : ""}
//     //         </tbody>
//     //     </table>

//     //     <div class="line"></div>
//     // `;

//     //     // DETAILED RECEIPT (Bottom Image) - HARDCODED "Take A Break"
//     //     const receiptTwo = `
//     //     <div class="big-title">Take A Break</div>
//     //     <div class="center-text">GSTIN: ${orderData?.vendorGstIn || "N/A"}</div>
//     //     <div class="line"></div>

//     //     <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
//     //     <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>
//     //     <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

//     //     <div class="line"></div>

//     //     <table class="items-table">
//     //         <thead>
//     //             <tr>
//     //                 <th style="text-align:center;">Item</th>
//     //                 <th style="text-align:center;">Qty</th>
//     //                 <th style="text-align:center;">Price</th>
//     //                 <th style="text-align:center;">Total</th>
//     //             </tr>
//     //         </thead>
//     //         <tbody>
//     //             ${Array.isArray(orderData.order) ? orderData.order.map(item => `
//     //                 <tr>
//     //                     <td style="text-align:center;">${item.dishName || "Item"}</td>
//     //                     <td style="text-align:center;">${item.quantity || 1}</td>
//     //                     <td style="text-align:center;">₹${(item.price || 0).toFixed(2)}</td>
//     //                     <td style="text-align:center;">₹${((item.price || 0) * (item.quantity || 1)).toFixed(2)}</td>
//     //                 </tr>
//     //             `).join("") : ""}
//     //         </tbody>
//     //     </table>

//     //     <div class="line"></div>

//     //     <div class="row"><span>SubTotal</span><span>₹${(orderData.subTotal || 0).toFixed(2)}</span></div>
//     //     <div class="row"><span>Platform</span><span>₹${(orderData.platformCharges || 0).toFixed(2)}</span></div>
//     //     <div class="row"><span>Service</span><span>₹${(orderData.serviceCharge || 0).toFixed(2)}</span></div>
//     //     <div class="row"><span>CGST</span><span>₹${(orderData.cgst || 0).toFixed(2)}</span></div>
//     //     <div class="row"><span>SGST</span><span>₹${(orderData.sgst || 0).toFixed(2)}</span></div>

//     //     <div class="line"></div>

//     //     <div class="row">
//     //         <span class="grand-label">Grand Total</span>
//     //         <span class="grand-value">₹${(orderData.grandTotal || 0).toFixed(2)}</span>
//     //     </div>

//     //     <div class="dashed"></div>
//     //     <div class="center-text">FSSAI: ${orderData?.vendorFssai || "23624032003384"}</div>

//     //     <div class="footer">
//     //         Thank you, visit again<br/>
//     //         www.maamaas.com
//     //     </div>
//     // `;

//     //     // FINAL PRINT CONTENT
//     //     const finalHTML = `
//     //     <!DOCTYPE html>
//     //     <html>
//     //     <head>
//     //         <title>Receipt - ${orderData.orderId || 'Order'}</title>
//     //         ${printStyles}
//     //     </head>
//     //     <body>
//     //         ${receiptOne}
//     //         <div class="page-break"></div>
//     //         ${receiptTwo}
//     //     </body>
//     //     </html>
//     // `;

//     //     try {
//     //         const printWindow = window.open('', '_blank', 'width=800,height=600');
//     //         printWindow.document.open();
//     //         printWindow.document.write(finalHTML);
//     //         printWindow.document.close();

//     //         printWindow.onload = () => {
//     //             printWindow.print();

//     //             // Listen for afterprint event
//     //             printWindow.onafterprint = () => {
//     //                 setTimeout(() => {
//     //                     printWindow.close();

//     //                     // AUTO-REFRESH: Only for manual prints, not auto-prints
//     //                     // Check if we're in auto-print mode by seeing if receipt is showing
//     //                     if (showReceipt) {
//     //                         // This is auto-print - don't refresh, let auto-print handle closing
//     //                         console.log("Auto-print completed, not refreshing");
//     //                     } else {
//     //                         // This is manual print - refresh the page
//     //                         window.location.reload();
//     //                     }
//     //                 }, 500);
//     //             };

//     //             // Fallback in case afterprint doesn't fire
//     //             setTimeout(() => {
//     //                 printWindow.close();

//     //                 // Same logic: only refresh for manual prints
//     //                 if (!showReceipt) {
//     //                     window.location.reload();
//     //                 }
//     //             }, 3000);
//     //         };

//     //         // Only restore original content for MANUAL prints
//     //         // Auto-print doesn't need this since we're not modifying the page
//     //         if (!showReceipt) {
//     //             document.body.innerHTML = originalContent;
//     //         }

//     //     } catch (error) {
//     //         console.error("Print error:", error);
//     //         // Restore page on error
//     //         if (!showReceipt) {
//     //             document.body.innerHTML = originalContent;
//     //         }
//     //     }
//     // };

//     const handlePrint = () => {
//         // Check for order data (important for auto-print)
//         if (!orderData || !orderData.orderId) {
//             console.error("No order data available for printing");
//             return;
//         }

//         // Store original content (only needed for manual print)
//         const originalContent = document.body.innerHTML;

//         const printStyles = `
//     <style>
//     @media print {
//         body {
//             width: 80mm !important;
//             margin: 0 auto !important;
//             padding: 0 !important;
//             font-family: "Courier New", monospace !important;
//             font-size: 10px !important;
//             line-height: 1.2 !important;
//             font-weight:900 !important;
//         }

//         h1, h2, h3 {
//             font-weight: bold;
//             text-align: center;
//             margin: 0;
//             padding: 0;
//         }

//         .big-title {
//             font-size: 14px !important;
//             font-weight: bold;
//             text-align: center;
//             margin-bottom: 5px;
//         }

//         .center-text {
//             text-align: center;
//             font-size: 10px;
//             font-weight: bold;
//         }

//         .line {
//             border-top: 1px solid black;
//             margin: 6px 0;
//         }

//         .dashed {
//             border-top: 1px dashed black;
//             margin: 6px 0;
//         }

//         table {
//             width: 100%;
//             font-size: 10px;
//             border-collapse: collapse;
//         }

//         th{
//             padding: 0px 0px;
//             font-weight: bold;
//         }
//         td { 
//             padding: 2px 0px;
//             font-weight: bold;
//         }

//         .row {
//             display: flex;
//             justify-content: space-around;
//             font-size: 10px;
//             font-weight: bold;
//             white-space: nowrap;
//             width: 100%;

//         }

//         .grand-label {
//             font-size: 16px;
//             font-weight: bold;
//         }

//         .grand-value {
//             font-size: 16px;
//             font-weight: bold;
//         }

//         .footer {
//             text-align: center;
//             margin-top: 10px;
//             font-size: 10px;
//         }

//         .receipt-buttons, button {
//             display: none !important;
//         }

//         @page {
//             size: 80mm auto;
//             margin: 0;
//         }

//         .page-break {
//             page-break-after: always;
//         }
//     }
//     </style>
//     `;

//         // SIMPLE RECEIPT (Top Image) - HARDCODED "Take A Break"
//         const receiptOne = `
//         <div class="big-title">Take A Break</div>
//         <div class="line"></div>

//         <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
//         <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>

//         <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

//         <div class="line"></div>

//         <table>
//             <thead>
//                 <tr>
//                     <th style="text-align:center;">Item</th>
//                     <th style="text-align:center;">Qty</th>
//                 </tr>
//             </thead>
//             <tbody>
//                 ${Array.isArray(orderData.order) ? orderData.order.map(item => `
//                     <tr>
//                         <td style="text-align:center;">${item.dishName || "Item"}</td>
//                         <td style="text-align:center;">${item.quantity || 1}</td>
//                     </tr>
//                 `).join("") : ""}
//             </tbody>
//         </table>

//         <div class="line"></div>
//     `;

//         // DETAILED RECEIPT (Bottom Image) - HARDCODED "Take A Break"
//         const receiptTwo = `
//         <div class="big-title">Take A Break</div>
//         <div class="center-text">GSTIN: ${orderData?.vendorGstIn || "N/A"}</div>
//         <div class="line"></div>

//         <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
//         <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>
//         <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

//         <div class="line"></div>

//         <table class="items-table">
//             <thead>
//                 <tr>
//                     <th style="text-align:center;">Item</th>
//                     <th style="text-align:center;">Qty</th>
//                     <th style="text-align:center;">Price</th>
//                     <th style="text-align:center;">Total</th>
//                 </tr>
//             </thead>
//             <tbody>
//                 ${Array.isArray(orderData.order) ? orderData.order.map(item => `
//                     <tr>
//                         <td style="text-align:center;">${item.dishName || "Item"}</td>
//                         <td style="text-align:center;">${item.quantity || 1}</td>
//                         <td style="text-align:center;">₹${(item.price || 0).toFixed(2)}</td>
//                         <td style="text-align:center;">₹${((item.price || 0) * (item.quantity || 1)).toFixed(2)}</td>
//                     </tr>
//                 `).join("") : ""}
//             </tbody>
//         </table>

//         <div class="line"></div>

//         <div class="row"><span>SubTotal</span><span>₹${(orderData.subTotal || 0).toFixed(2)}</span></div>
//         <div class="row"><span>Platform</span><span>₹${(orderData.platformCharges || 0).toFixed(2)}</span></div>
//         <div class="row"><span>Service</span><span>₹${(orderData.serviceCharge || 0).toFixed(2)}</span></div>
//         <div class="row"><span>CGST</span><span>₹${(orderData.cgst || 0).toFixed(2)}</span></div>
//         <div class="row"><span>SGST</span><span>₹${(orderData.sgst || 0).toFixed(2)}</span></div>

//         <div class="line"></div>

//         <div class="row">
//             <span class="grand-label">Grand Total</span>
//             <span class="grand-value">₹${(orderData.grandTotal || 0).toFixed(2)}</span>
//         </div>

//         <div class="dashed"></div>
//         <div class="center-text">FSSAI: ${orderData?.vendorFssai || "23624032003384"}</div>

//         <div class="footer">
//             Thank you, visit again<br/>
//             www.maamaas.com
//         </div>
//     `;

//         // FINAL PRINT CONTENT
//         const finalHTML = `
//         <!DOCTYPE html>
//         <html>
//         <head>
//             <title>Receipt - ${orderData.orderId || 'Order'}</title>
//             ${printStyles}
//         </head>
//         <body>
//             ${receiptOne}
//             <div class="page-break"></div>
//             ${receiptTwo}
//         </body>
//         </html>
//     `;

//         try {
//             const printWindow = window.open('', '_blank', 'width=800,height=600');
//             printWindow.document.open();
//             printWindow.document.write(finalHTML);
//             printWindow.document.close();

//             printWindow.onload = () => {
//                 printWindow.print();

//                 // Listen for afterprint event
//                 printWindow.onafterprint = () => {
//                     setTimeout(() => {
//                         printWindow.close();

//                         // ✅ ADDED: AUTO-REFRESH AND CLEAR CART/RECEIPT
//                         // Check if this is an auto-print (receipt just generated after order)
//                         const isAutoPrint = showReceipt && orderData.orderId;

//                         if (isAutoPrint) {

//                             // Clear cart data locally
//                             setCartData({ cartItems: [] });
//                             setQuantities({});
//                             setGrandTotal(0);
//                             setSelectedPaymentMethod("");

//                             // Hide receipt
//                             setShowReceipt(false);
//                             setOrderData({});

//                             // Clear localStorage flags
//                             localStorage.removeItem("showReceipt");
//                             localStorage.removeItem("receiptOrderId");
//                             localStorage.removeItem("receiptTimestamp");

//                             // Trigger cart refresh for other components
//                             triggerCartRefresh();
//                             triggerFullRefresh();

//                             // Optional: Show success message
//                             setTimeout(() => {
//                                 alert("✅ Order completed! Cart has been cleared.");
//                             }, 1000);
//                         } else {
//                             // This is manual print - just close window
//                         }
//                     }, 500);
//                 };

//                 // Fallback in case afterprint doesn't fire
//                 setTimeout(() => {
//                     printWindow.close();

//                     // ✅ ADDED: Same auto-refresh logic for fallback
//                     const isAutoPrint = showReceipt && orderData.orderId;

//                     if (isAutoPrint) {

//                         // Clear cart data locally
//                         setCartData({ cartItems: [] });
//                         setQuantities({});
//                         setGrandTotal(0);
//                         setSelectedPaymentMethod("");

//                         // Hide receipt
//                         setShowReceipt(false);
//                         setOrderData({});

//                         // Clear localStorage flags
//                         localStorage.removeItem("showReceipt");
//                         localStorage.removeItem("receiptOrderId");
//                         localStorage.removeItem("receiptTimestamp");

//                         // Trigger cart refresh
//                         triggerCartRefresh();
//                         triggerFullRefresh();
//                     }
//                 }, 3000);
//             };
//             setTimeout(() => {
//                 if (printWindow && !printWindow.closed) {
//                     printWindow.close();
//                 }
//             }, 1000);

//             // Only restore original content for MANUAL prints
//             // Auto-print doesn't need this since we're not modifying the page
//             if (!showReceipt) {
//                 document.body.innerHTML = originalContent;
//             }

//         } catch (error) {
//             console.error("Print error:", error);
//             // Restore page on error
//             if (!showReceipt) {
//                 document.body.innerHTML = originalContent;
//             }
//         }


//         // Remove the setTimeout wrapper
//     };
//     const triggerFullRefresh = () => {
//         window.location.reload();
//     };

//     // const handlePrint = () => {
//     //     // Check for order data (important for auto-print)
//     //     if (!orderData || !orderData.orderId) {
//     //         console.error("No order data available for printing");
//     //         return;
//     //     }

//     //     // Store original content (only needed for manual print)
//     //     const originalContent = document.body.innerHTML;

//     //     const printStyles = `
//     // <style>
//     // @media print {
//     //     body {
//     //         width: 80mm !important;
//     //         margin: 0 auto !important;
//     //         padding: 0 !important;
//     //         font-family: "Courier New", monospace !important;
//     //         font-size: 10px !important;
//     //         line-height: 1.2 !important;
//     //         font-weight:900 !important;
//     //     }

//     //     h1, h2, h3 {
//     //         font-weight: bold;
//     //         text-align: center;
//     //         margin: 0;
//     //         padding: 0;
//     //     }

//     //     .big-title {
//     //         font-size: 14px !important;
//     //         font-weight: bold;
//     //         text-align: center;
//     //         margin-bottom: 5px;
//     //     }

//     //     .center-text {
//     //         text-align: center;
//     //         font-size: 10px;
//     //         font-weight: bold;
//     //     }

//     //     .line {
//     //         border-top: 1px solid black;
//     //         margin: 6px 0;
//     //     }

//     //     .dashed {
//     //         border-top: 1px dashed black;
//     //         margin: 6px 0;
//     //     }

//     //     table {
//     //         width: 100%;
//     //         font-size: 10px;
//     //         border-collapse: collapse;
//     //     }

//     //     th{
//     //         padding: 0px 0px;
//     //         font-weight: bold;
//     //     }
//     //     td { 
//     //         padding: 2px 0px;
//     //         font-weight: bold;
//     //     }

//     //     .row {
//     //         display: flex;
//     //         justify-content: space-around;
//     //         font-size: 10px;
//     //         font-weight: bold;
//     //         white-space: nowrap;
//     //         width: 100%;

//     //     }

//     //     .grand-label {
//     //         font-size: 16px;
//     //         font-weight: bold;
//     //     }

//     //     .grand-value {
//     //         font-size: 16px;
//     //         font-weight: bold;
//     //     }

//     //     .footer {
//     //         text-align: center;
//     //         margin-top: 10px;
//     //         font-size: 10px;
//     //     }

//     //     .receipt-buttons, button {
//     //         display: none !important;
//     //     }

//     //     @page {
//     //         size: 80mm auto;
//     //         margin: 0;
//     //     }

//     //     .page-break {
//     //         page-break-after: always;
//     //     }
//     // }
//     // </style>
//     // `;

//     //     // SIMPLE RECEIPT (Top Image) - HARDCODED "Take A Break"
//     //     const receiptOne = `
//     //     <div class="big-title">Take A Break</div>
//     //     <div class="line"></div>

//     //     <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
//     //     <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>

//     //     <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

//     //     <div class="line"></div>

//     //     <table>
//     //         <thead>
//     //             <tr>
//     //                 <th style="text-align:center;">Item</th>
//     //                 <th style="text-align:center;">Qty</th>
//     //             </tr>
//     //         </thead>
//     //         <tbody>
//     //             ${Array.isArray(orderData.order) ? orderData.order.map(item => `
//     //                 <tr>
//     //                     <td style="text-align:center;">${item.dishName || "Item"}</td>
//     //                     <td style="text-align:center;">${item.quantity || 1}</td>
//     //                 </tr>
//     //             `).join("") : ""}
//     //         </tbody>
//     //     </table>

//     //     <div class="line"></div>
//     // `;

//     //     // DETAILED RECEIPT (Bottom Image) - HARDCODED "Take A Break"
//     //     const receiptTwo = `
//     //     <div class="big-title">Take A Break</div>
//     //     <div class="center-text">GSTIN: ${orderData?.vendorGstIn || "N/A"}</div>
//     //     <div class="line"></div>

//     //     <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
//     //     <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>
//     //     <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

//     //     <div class="line"></div>

//     //     <table class="items-table">
//     //         <thead>
//     //             <tr>
//     //                 <th style="text-align:center;">Item</th>
//     //                 <th style="text-align:center;">Qty</th>
//     //                 <th style="text-align:center;">Price</th>
//     //                 <th style="text-align:center;">Total</th>
//     //             </tr>
//     //         </thead>
//     //         <tbody>
//     //             ${Array.isArray(orderData.order) ? orderData.order.map(item => `
//     //                 <tr>
//     //                     <td style="text-align:center;">${item.dishName || "Item"}</td>
//     //                     <td style="text-align:center;">${item.quantity || 1}</td>
//     //                     <td style="text-align:center;">₹${(item.price || 0).toFixed(2)}</td>
//     //                     <td style="text-align:center;">₹${((item.price || 0) * (item.quantity || 1)).toFixed(2)}</td>
//     //                 </tr>
//     //             `).join("") : ""}
//     //         </tbody>
//     //     </table>

//     //     <div class="line"></div>

//     //     <div class="row"><span>SubTotal</span><span>₹${(orderData.subTotal || 0).toFixed(2)}</span></div>
//     //     <div class="row"><span>Platform</span><span>₹${(orderData.platformCharges || 0).toFixed(2)}</span></div>
//     //     <div class="row"><span>Service</span><span>₹${(orderData.serviceCharge || 0).toFixed(2)}</span></div>
//     //     <div class="row"><span>CGST</span><span>₹${(orderData.cgst || 0).toFixed(2)}</span></div>
//     //     <div class="row"><span>SGST</span><span>₹${(orderData.sgst || 0).toFixed(2)}</span></div>

//     //     <div class="line"></div>

//     //     <div class="row">
//     //         <span class="grand-label">Grand Total</span>
//     //         <span class="grand-value">₹${(orderData.grandTotal || 0).toFixed(2)}</span>
//     //     </div>

//     //     <div class="dashed"></div>
//     //     <div class="center-text">FSSAI: ${orderData?.vendorFssai || "23624032003384"}</div>

//     //     <div class="footer">
//     //         Thank you, visit again<br/>
//     //         www.maamaas.com
//     //     </div>
//     // `;

//     //     // FINAL PRINT CONTENT
//     //     const finalHTML = `
//     //     <!DOCTYPE html>
//     //     <html>
//     //     <head>
//     //         <title>Receipt - ${orderData.orderId || 'Order'}</title>
//     //         ${printStyles}
//     //     </head>
//     //     <body>
//     //         ${receiptOne}
//     //         <div class="page-break"></div>
//     //         ${receiptTwo}
//     //     </body>
//     //     </html>
//     // `;

//     //     try {
//     //         const printWindow = window.open('', '_blank', 'width=800,height=600');
//     //         printWindow.document.open();
//     //         printWindow.document.write(finalHTML);
//     //         printWindow.document.close();

//     //         printWindow.onload = () => {
//     //             printWindow.print();

//     //             // Listen for afterprint event
//     //             printWindow.onafterprint = () => {
//     //                 setTimeout(() => {
//     //                     printWindow.close();

//     //                     // ✅ ADDED: AUTO-REFRESH AND CLEAR CART/RECEIPT
//     //                     // Check if this is an auto-print (receipt just generated after order)
//     //                     const isAutoPrint = showReceipt && orderData.orderId;

//     //                     if (isAutoPrint) {

//     //                         // Clear cart data locally
//     //                         setCartData({ cartItems: [] });
//     //                         setQuantities({});
//     //                         setGrandTotal(0);
//     //                         setSelectedPaymentMethod("");

//     //                         // Hide receipt
//     //                         setShowReceipt(false);
//     //                         setOrderData({});

//     //                         // Clear localStorage flags
//     //                         localStorage.removeItem("showReceipt");
//     //                         localStorage.removeItem("receiptOrderId");
//     //                         localStorage.removeItem("receiptTimestamp");

//     //                         // Trigger cart refresh for other components
//     //                         triggerCartRefresh();
//     //                         triggerFullRefresh();

//     //                         // Optional: Show success message
//     //                         setTimeout(() => {
//     //                             alert("✅ Order completed! Cart has been cleared.");
//     //                         }, 1000);
//     //                     } else {
//     //                         // This is manual print - just close window
//     //                     }
//     //                 }, 500);
//     //             };

//     //             // Fallback in case afterprint doesn't fire
//     //             setTimeout(() => {
//     //                 printWindow.close();

//     //                 // ✅ ADDED: Same auto-refresh logic for fallback
//     //                 const isAutoPrint = showReceipt && orderData.orderId;

//     //                 if (isAutoPrint) {

//     //                     // Clear cart data locally
//     //                     setCartData({ cartItems: [] });
//     //                     setQuantities({});
//     //                     setGrandTotal(0);
//     //                     setSelectedPaymentMethod("");

//     //                     // Hide receipt
//     //                     setShowReceipt(false);
//     //                     setOrderData({});

//     //                     // Clear localStorage flags
//     //                     localStorage.removeItem("showReceipt");
//     //                     localStorage.removeItem("receiptOrderId");
//     //                     localStorage.removeItem("receiptTimestamp");

//     //                     // Trigger cart refresh
//     //                     triggerCartRefresh();
//     //                     triggerFullRefresh();
//     //                 }
//     //             }, 3000);
//     //         };
//     //         setTimeout(() => {
//     //             if (printWindow && !printWindow.closed) {
//     //                 printWindow.close();
//     //             }
//     //         }, 1000);

//     //         // Only restore original content for MANUAL prints
//     //         // Auto-print doesn't need this since we're not modifying the page
//     //         if (!showReceipt) {
//     //             document.body.innerHTML = originalContent;
//     //         }

//     //     } catch (error) {
//     //         console.error("Print error:", error);
//     //         // Restore page on error
//     //         if (!showReceipt) {
//     //             document.body.innerHTML = originalContent;
//     //         }
//     //     }

//     //     window.location.reload();
//     //     // Remove the setTimeout wrapper
//     // };
    
//     const handleDownload = async () => {
//         const receipt = receiptRef.current;
//         if (!receipt) return;

//         const buttons = receipt.querySelectorAll(".receipt-buttons");
//         const buttonStates = [];
//         buttons.forEach(btn => {
//             buttonStates.push({
//                 element: btn,
//                 originalDisplay: btn.style.display
//             });
//             btn.style.display = "none";
//         });

//         await new Promise(resolve => setTimeout(resolve, 100));

//         const originalStyle = {
//             height: receipt.style.height,
//             overflowY: receipt.style.overflowY
//         };
//         receipt.style.height = "auto";
//         receipt.style.overflowY = "visible";

//         try {
//             const canvas = await html2canvas(receipt, {
//                 scale: 2,
//                 useCORS: true,
//                 logging: false
//             });

//             const imgData = canvas.toDataURL("image/png");
//             const pdf = new jsPDF("p", "mm", "a4");
//             const imgWidth = 210;
//             const imgHeight = (canvas.height * imgWidth) / canvas.width;

//             pdf.addImage(imgData, "PNG", 0, 10, imgWidth, imgHeight);
//             pdf.save("Payment_Receipt.pdf");

//             buttonStates.forEach(state => {
//                 state.element.style.display = state.originalDisplay;
//             });
//             receipt.style.height = originalStyle.height;
//             receipt.style.overflowY = originalStyle.overflowY;

//         } catch (err) {
//             console.error("❌ Error generating PDF:", err);
//             buttonStates.forEach(state => {
//                 state.element.style.display = state.originalDisplay;
//             });
//             receipt.style.height = originalStyle.height;
//             receipt.style.overflowY = originalStyle.overflowY;
//         }
//     };


//     const clearCart = async () => {
//         const token = localStorage.getItem("authToken");
//         const vendorId = localStorage.getItem("vendorId");
//         const cartId = localStorage.getItem("cartId");

//         if (!token || !vendorId || !cartId) {
//             alert("Unable to clear cart. Missing required data.");
//             return;
//         }

//         if (cartData.cartItems.length === 0) {
//             alert("Cart is already empty!");
//             return;
//         }

//         if (!window.confirm("Are you sure you want to clear all items from your cart?")) {
//             return;
//         }

//         try {
//             for (const item of cartData.cartItems) {
//                 const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartId}?dishId=${item.dishId}&quantity=0`;
//                 await axios.put(apiUrl, null, {
//                     headers: { Authorization: `Bearer ${token}` }
//                 });
//             }

//             setCartData({ cartItems: [] });
//             setQuantities({});
//             setGrandTotal(0);
//             setShowReceipt(false);

//             alert("Cart cleared successfully!");
//             triggerCartRefresh();

//         } catch (err) {
//             console.error("Error clearing cart:", err);
//             alert("Failed to clear cart. Please try again.");
//         }
//     };

//     const triggerCartRefresh = () => {
//         const event = new CustomEvent('cartUpdated');
//         window.dispatchEvent(event);
//     }

//     useEffect(() => {
//         const handleCartUpdate = () => {
//             setRefresh(prev => prev + 1);
//         };

//         window.addEventListener('cartUpdated', handleCartUpdate);
//         return () => {
//             window.removeEventListener('cartUpdated', handleCartUpdate);
//         };
//     }, []);

//     useEffect(() => {
//         fetchCartData();
//     }, [refresh]);



//     const increaseQuantity = async (dishId) => {
//         const token = localStorage.getItem("authToken");
//         const vendorId = localStorage.getItem("vendorId");
//         if (!token || !vendorId) return alert("Auth token or vendorId missing");

//         if (!cartData || !cartData.cartItems) {
//             alert("Cart is empty or not loaded yet.");
//             return;
//         }

//         const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
//         if (!cartItem) {
//             alert("Item not found in cart. Please add it first.");
//             return;
//         }

//         const newQty = (quantities[dishId] || 0) + 1;

//         const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartData.cartId}?dishId=${dishId}&quantity=${newQty}`;

//         try {
//             await axios.put(apiUrl, null, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });

//             setQuantities(prev => ({ ...prev, [dishId]: newQty }));
//             setCartData(prev => ({
//                 ...prev,
//                 cartItems: prev.cartItems.map(item =>
//                     item.dishId === dishId ? { ...item, quantity: newQty } : item
//                 )
//             }));
//             setIsModalOpen(true);
//             triggerCartRefresh();
//             setTimeout(() => {
//                 if (!isHovered) setIsModalOpen(false);
//             }, 20000000);
//         } catch (err) {
//             console.error("API Error:", err.response ? err.response.data : err);
//             alert("Unable to update quantity for dishId: " + dishId);
//         }
//     };

//     const decreaseQuantity = async (dishId) => {
//         const token = localStorage.getItem("authToken");
//         const vendorId = localStorage.getItem("vendorId");
//         const currentQty = quantities[dishId] || 0;
//         if (currentQty === 0) return;

//         if (!cartData || !cartData.cartItems) {
//             alert("Cart is empty or not loaded yet.");
//             return;
//         }

//         const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
//         if (!cartItem) return alert("Item not found");

//         const newQty = currentQty - 1;

//         if (newQty === 0) {
//             setItemToRemove({ dishId, cartItem });
//             setShowRemoveConfirm(true);
//             return;
//         }

//         await updateQuantity(dishId, newQty);
//     };
//     const updateQuantity = async (dishId, newQty) => {
//         const token = localStorage.getItem("authToken");
//         const vendorId = localStorage.getItem("vendorId");

//         const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartData.cartId}?dishId=${dishId}&quantity=${newQty}`;

//         try {
//             await axios.put(apiUrl, null, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });

//             setQuantities(prev => ({ ...prev, [dishId]: newQty > 0 ? newQty : 0 }));
//             setCartData(prev => ({
//                 ...prev,
//                 cartItems: newQty > 0
//                     ? prev.cartItems.map(item =>
//                         item.dishId === dishId ? { ...item, quantity: newQty } : item
//                     )
//                     : prev.cartItems.filter(item => item.dishId !== dishId)
//             }));
//             setIsModalOpen(true);
//             triggerCartRefresh();
//             setTimeout(() => {
//                 if (!isHovered) setIsModalOpen(false);
//             }, 20000000);
//         } catch (err) {
//             console.error("API Error:", err.response ? err.response.data : err);
//             alert("Unable to update quantity for dishId: " + dishId);
//         }
//     };

//     const confirmRemove = async () => {
//         if (itemToRemove) {
//             await updateQuantity(itemToRemove.dishId, 0);
//             setShowRemoveConfirm(false);
//             setItemToRemove(null);
//         }
//     };

//     const cancelRemove = () => {
//         setShowRemoveConfirm(false);
//         setItemToRemove(null);
//     };

//     const displayData = cartData.cartItems || [];
//     const hasItems = displayData.filter(item => (quantities[item.dishId] ?? item.quantity ?? 1) > 0).length > 0;

//     if (!hasItems && !showReceipt) {
//         return null;
//     }

//     const calculateDenominationTotal = () => {
//         let total = 0;
//         Object.keys(notesCount).forEach(denom => {
//             const count = parseInt(notesCount[denom]) || 0;
//             total += count * parseInt(denom);
//         });
//         return total;
//     };

//     const denominationTotal = calculateDenominationTotal();
//     const remainingAmount = denominationTotal - grandTotal;

//     return (
//         <div style={{
//             background: '#b15cd6',
//             borderRadius: '0.5rem',
//             padding: '1rem',
//             height: 'fit-content',
//             maxHeight: '85vh',
//             display: 'flex',
//             flexDirection: 'column',
//             marginTop: window.innerHeight <= 700 ? "3rem" : "5rem",
//             minHeight: '500px',
//             position: 'sticky',
//             top: '6rem',
//             zIndex: window.innerHeight <= 700 ? 30000 : " ",
//         }}>
//             <div style={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 marginBottom: '0.3rem',
//                 paddingBottom: '0.75rem',
//                 borderBottom: '0px solid #e9ecef',
//                 flexShrink: 0,
//                 position: 'relative',
//                 height: '40px'
//             }}>
//                 <h4 style={{
//                     color: '#f8f9fa',
//                     margin: 0,
//                     fontSize: '1.3rem',
//                     fontWeight: '600',
//                     textAlign: 'center'
//                 }}>
//                     {showReceipt ? 'Order Receipt' : 'Cart'}
//                 </h4>

//                 {hasItems && !showReceipt && (
//                     <button
//                         onClick={clearCart}
//                         style={{
//                             background: '#e53e3e',
//                             border: '1px solid #e53e3e',
//                             color: 'white',
//                             padding: '0.4rem 0.8rem',
//                             borderRadius: '0.25rem',
//                             fontSize: '0.85rem',
//                             fontWeight: '600',
//                             cursor: 'pointer',
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: '0.3rem',
//                             transition: 'all 0.2s ease',
//                             position: 'absolute',
//                             right: "10px",
//                             top: '50%',
//                             transform: 'translateY(-75%)'
//                         }}
//                     >
//                         Clear
//                     </button>
//                 )}

//                 {showReceipt && (
//                     <>
//                         <button
//                             onClick={closeReceipt}
//                             disabled={isProcessingBack}
//                             style={{
//                                 background: 'transparent',
//                                 border: '1px solid #f8f9fa',
//                                 color: '#f8f9fa',
//                                 padding: '0.4rem 0.8rem',
//                                 borderRadius: '0.25rem',
//                                 fontSize: '0.85rem',
//                                 fontWeight: '600',
//                                 cursor: isProcessingBack ? 'not-allowed' : 'pointer',
//                                 display: window.innerWidth <= 1400 ? "none" : "flex",
//                                 alignItems: 'center',
//                                 gap: '0.3rem',
//                                 transition: 'all 0.2s ease',
//                                 position: 'absolute',
//                                 left: "10px",
//                                 top: '50%',
//                                 transform: 'translateY(-75%)',
//                                 opacity: isProcessingBack ? 0.7 : 1
//                             }}
//                             onMouseOver={(e) => {
//                                 if (!isProcessingBack) {
//                                     e.target.style.backgroundColor = '#f8f9fa';
//                                     e.target.style.color = '#b15cd6';
//                                 }
//                             }}
//                             onMouseOut={(e) => {
//                                 if (!isProcessingBack) {
//                                     e.target.style.backgroundColor = 'transparent';
//                                     e.target.style.color = '#f8f9fa';
//                                 }
//                             }}
//                         >
//                             {isProcessingBack ? '...' : '← Back'}
//                         </button>
//                         <button
//                             onClick={closeReceipt}
//                             disabled={isProcessingBack}
//                             style={{
//                                 background: 'transparent',
//                                 border: '1px solid #f8f9fa',
//                                 color: '#f8f9fa',
//                                 padding: '0.4rem 0.8rem',
//                                 borderRadius: '0.25rem',
//                                 fontSize: '0.85rem',
//                                 fontWeight: '600',
//                                 cursor: isProcessingBack ? 'not-allowed' : 'pointer',
//                                 display: window.innerWidth <= 1400 ? "flex" : "none",
//                                 alignItems: 'center',
//                                 gap: '0.3rem',
//                                 transition: 'all 0.2s ease',
//                                 position: 'absolute',
//                                 left: "0px",
//                                 top: '50%',
//                                 transform: 'translateY(-75%)',
//                                 opacity: isProcessingBack ? 0.7 : 1
//                             }}
//                             onMouseOver={(e) => {
//                                 if (!isProcessingBack) {
//                                     e.target.style.backgroundColor = '#f8f9fa';
//                                     e.target.style.color = '#b15cd6';
//                                 }
//                             }}
//                             onMouseOut={(e) => {
//                                 if (!isProcessingBack) {
//                                     e.target.style.backgroundColor = 'transparent';
//                                     e.target.style.color = '#f8f9fa';
//                                 }
//                             }}
//                         >
//                             {isProcessingBack ? '...' : '←'}
//                         </button>
//                     </>
//                 )}
//             </div>

//             <div className="cart-content-container hide-scrollbar">
//                 {showReceipt ? (
//                     <div ref={receiptRef} style={{
//                         backgroundColor: "white",
//                         borderRadius: '0.5rem',
//                         padding: '1rem',
//                         overflowY: 'auto',
//                         maxHeight: 'calc(85vh - 100px)',
//                         scrollbarWidth: "none",
//                     }}>
//                         <div ref={printRef}>
//                             <div style={{
//                                 textAlign: 'center',
//                                 marginBottom: '1rem',
//                                 paddingBottom: '0.5rem',
//                                 borderBottom: '2px solid #b15cd6'
//                             }}>
//                                 <h5 style={{
//                                     color: '#b15cd6',
//                                     margin: '0.5rem 0',
//                                     fontSize: window.innerWidth < 1200 ? '1.1rem' : '1.2rem'
//                                 }}>
//                                     ✅ Payment Successful!
//                                 </h5>
//                                 <h6 style={{
//                                     margin: 0,
//                                     color: '#2d3748',
//                                     fontSize: '1rem'
//                                 }}>
//                                     {bannerData?.companyName || "MAAMAAS HOUSE"}
//                                 </h6>
//                             </div>

//                             <div style={{
//                                 display: 'flex',
//                                 flexDirection: 'column',
//                                 gap: '0.5rem',
//                                 marginBottom: '1rem',
//                                 fontSize: '0.9rem'
//                             }}>
//                                 <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                                     <span style={{ fontWeight: '600', color: '#4a5568' }}>Order ID:</span>
//                                     <span className='endalign' style={{ fontWeight: '700', color: '#2d3748' }}>{orderData.orderId}</span>
//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                                     <span style={{ fontWeight: '600', color: '#4a5568' }}>Date:</span>
//                                     <span className='endalign' style={{ fontWeight: '700', color: '#2d3748' }}>
//                                         {orderData.date ? new Date(orderData.date).toLocaleDateString('en-GB') : new Date().toLocaleDateString('en-GB')}
//                                     </span>
//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                                     <span style={{ fontWeight: '600', color: '#4a5568' }}>Order Type:</span>
//                                     <span className='endalign' style={{ fontWeight: '700', color: '#2d3748' }}>{orderData.orderType}</span>
//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                                     <span style={{ fontWeight: '600', color: '#4a5568' }}>Time:</span>
//                                     <span className='endalign' style={{ fontWeight: '700', color: '#2d3748' }}>
//                                         {orderData.time ? new Date(`1970-01-01T${orderData.time}`).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }) : "N/A"}
//                                     </span>
//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                                     <span style={{ fontWeight: '600', color: '#4a5568' }}>Payment Method:</span>
//                                     <span style={{ fontWeight: '700', color: '#2d3748', display: window.innerWidth < 1200 ? "flex" : "flex", alignItems: window.innerWidth < 1200 ? "end" : " " }}>{orderData.paymentMethod}</span>
//                                 </div>
//                             </div>

//                             <hr style={{ border: '1px dashed #cbd5e0', margin: '1rem 0' }} />

//                             {Array.isArray(orderData.order) && orderData.order.length > 0 ? (
//                                 <>
//                                     <table style={{
//                                         width: '100%',
//                                         borderCollapse: 'collapse',
//                                         fontSize: '0.85rem',
//                                         marginBottom: '1rem'
//                                     }}>
//                                         <thead>
//                                             <tr style={{ borderBottom: '2px solid #e2e8f0' }}>
//                                                 <th style={{ padding: '0.5rem', textAlign: 'left', fontWeight: '600', color: '#4a5568' }}>Item</th>
//                                                 <th style={{ padding: '0.5rem', textAlign: 'center', fontWeight: '600', color: '#4a5568' }}>Qty</th>
//                                                 <th style={{ padding: '0.5rem', textAlign: 'right', fontWeight: '600', color: '#4a5568' }}>Price</th>
//                                                 <th style={{ padding: '0.5rem', textAlign: 'right', fontWeight: '600', color: '#4a5568' }}>Total</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {orderData.order.map((item, index) => (
//                                                 <tr key={index} style={{ borderBottom: '1px solid #e2e8f0' }}>
//                                                     <td style={{ padding: '0.5rem', textAlign: 'left' }}>{item.dishName || "N/A"}</td>
//                                                     <td style={{ padding: '0.5rem', textAlign: 'center' }}>{item.quantity ?? "N/A"}</td>
//                                                     <td style={{ padding: '0.5rem', textAlign: 'right' }}>₹{item.price?.toFixed(2) || "0.00"}</td>
//                                                     <td style={{ padding: '0.5rem', textAlign: 'right' }}>
//                                                         ₹{item.price && item.quantity ? (item.price * item.quantity).toFixed(2) : "0.00"}
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>

//                                     <div style={{ marginBottom: '1rem', fontSize: '0.9rem' }}>
//                                         <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
//                                             <span>Sub Total:</span>
//                                             <span>₹{orderData.subTotal?.toFixed(2) || "0.00"}</span>
//                                         </div>
//                                         {orderData.platformCharges > 0 && (
//                                             <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
//                                                 <span>Platform Charges:</span>
//                                                 <span>₹{orderData.platformCharges?.toFixed(2) || "0.00"}</span>
//                                             </div>
//                                         )}
//                                         {orderData.serviceCharge > 0 && (
//                                             <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
//                                                 <span>Service Charges:</span>
//                                                 <span>₹{orderData.serviceCharge?.toFixed(2) || "0.00"}</span>
//                                             </div>
//                                         )}
//                                         {orderData.cgst > 0 && (
//                                             <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
//                                                 <span>CGST:</span>
//                                                 <span>₹{orderData.cgst?.toFixed(2) || "0.00"}</span>
//                                             </div>
//                                         )}
//                                         {orderData.sgst > 0 && (
//                                             <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
//                                                 <span>SGST:</span>
//                                                 <span>₹{orderData.sgst?.toFixed(2) || "0.00"}</span>
//                                             </div>
//                                         )}
//                                     </div>

//                                     <hr style={{ border: '1px dashed #cbd5e0', margin: '1rem 0' }} />

//                                     <div style={{
//                                         display: 'flex',
//                                         justifyContent: 'space-between',
//                                         alignItems: 'center',
//                                         padding: '0.75rem',
//                                         backgroundColor: '#f7fafc',
//                                         borderRadius: '0.25rem',
//                                         border: '0px solid #b15cd6',
//                                         marginBottom: '1rem'
//                                     }}>
//                                         <span style={{ fontSize: '1.1rem', fontWeight: '700', color: '#2d3748' }}>Grand Total:</span>
//                                         <span style={{ fontSize: '1.3rem', fontWeight: '900', color: '#b15cd6' }}>
//                                             ₹{orderData.grandTotal?.toFixed(2) || "0.00"}
//                                         </span>
//                                     </div>

//                                     <div style={{
//                                         textAlign: 'center',
//                                         padding: '1rem',
//                                         borderTop: '2px solid #e2e8f0',
//                                         marginTop: '1rem'
//                                     }}>
//                                         <h6 style={{ color: '#4a5568', marginBottom: '0.5rem' }}>
//                                             Thank You! Visit Again
//                                         </h6>
//                                         <p style={{ color: '#a0aec0', fontSize: '0.8rem', margin: 0 }}>
//                                             www.maamaas.com
//                                         </p>
//                                     </div>
//                                 </>
//                             ) : (
//                                 <p style={{ textAlign: 'center', color: '#718096' }}>No order data available.</p>
//                             )}
//                         </div>

//                         <div className="receipt-buttons" style={{
//                             display: 'flex',
//                             gap: window.innerWidth < 1200 ? '0.5rem' : '1rem',
//                             justifyContent: 'center',
//                             marginTop: '1rem',
//                             paddingTop: '1rem',
//                             borderTop: '1px solid #e2e8f0'
//                         }}>
//                             <button
//                                 onClick={handlePrint}
//                                 style={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: '0.5rem',
//                                     padding: window.innerWidth < 1200 ? '0.3rem 1rem ' : '0.75rem 1.5rem',
//                                     backgroundColor: '#b15cd6',
//                                     color: 'white',
//                                     border: 'none',
//                                     borderRadius: '0.5rem',
//                                     cursor: 'pointer',
//                                     fontWeight: '600',
//                                     fontSize: '0.9rem',
//                                     transition: 'all 0.2s ease'
//                                 }}
//                                 onMouseOver={(e) => e.target.style.backgroundColor = '#9b46c9'}
//                                 onMouseOut={(e) => e.target.style.backgroundColor = '#b15cd6'}
//                             >
//                                 <FaPrint /> Print
//                             </button>
//                             <button
//                                 onClick={handleDownload}
//                                 style={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: '0.5rem',
//                                     padding: window.innerWidth < 1200 ? '0.5rem 1rem ' : '0.75rem 1.5rem',
//                                     backgroundColor: '#4a5568',
//                                     color: 'white',
//                                     border: 'none',
//                                     borderRadius: '0.5rem',
//                                     cursor: 'pointer',
//                                     fontWeight: '600',
//                                     fontSize: '0.9rem',
//                                     transition: 'all 0.2s ease'
//                                 }}
//                                 onMouseOver={(e) => e.target.style.backgroundColor = '#2d3748'}
//                                 onMouseOut={(e) => e.target.style.backgroundColor = '#4a5568'}
//                             >
//                                 <FaDownload /> Download
//                             </button>
//                         </div>
//                     </div>
//                 ) : hasItems ? (
//                     <>
//                         <div style={{
//                             backgroundColor: "white",
//                             border: "1px solid #e9ecef",
//                             boxShadow: "0 4px 8px rgba(0, 0, 0, 0.08)",
//                         }}>
//                             {/* Cart Headers - Only shown on larger screens */}
//                             <div className="cart-headers" style={{
//                                 display: 'flex',
//                                 justifyContent: 'space-between',
//                                 alignItems: 'center',
//                                 padding: '0.75rem 1rem',
//                                 borderBottom: '2px solid #b15cd6',
//                                 backgroundColor: '#f8f9fa',
//                                 fontWeight: '600',
//                                 color: '#2d3748',
//                                 fontSize: '0.9rem'
//                             }}>
//                                 <div style={{ flex: window.innerWidth < 1399 ? "1" : "2", textAlign: 'left' }}>
//                                     Items
//                                 </div>
//                                 <div style={{ flex: 1, textAlign: 'center' }}>
//                                     Quantity
//                                 </div>
//                                 <div style={{ flex: 1, textAlign: 'right' }}>
//                                     Price
//                                 </div>
//                             </div>

//                             {displayData
//                                 .filter(item => (quantities[item.dishId] ?? item.quantity ?? 1) > 0)
//                                 .map((item, index) => {
//                                     const currentQuantity = quantities[item.dishId] ?? item.quantity ?? 1;

//                                     return (
//                                         <div key={item.cartItemId || index} className="cart-item-box">
//                                             <div className="cart-item-row">
//                                                 <div className="item-name-container">
//                                                     <div className="item-name" title={item.dishName}>
//                                                         {item.dishName}
//                                                     </div>
//                                                 </div>
//                                                 <div className="item-controls-container">
//                                                     <div className="quantity-controls">
//                                                         <button
//                                                             className="quantity-btn outline-btn"
//                                                             onClick={() => decreaseQuantity(item.dishId)}
//                                                             title="Decrease quantity"
//                                                         >
//                                                             <FaMinus className="quantity-icon" />
//                                                         </button>
//                                                         <span className="quantity-display">
//                                                             {currentQuantity}
//                                                         </span>
//                                                         <button
//                                                             className="quantity-btn outline-btn"
//                                                             onClick={() => increaseQuantity(item.dishId)}
//                                                             title="Increase quantity"
//                                                         >
//                                                             <FaPlus className="quantity-icon" />
//                                                         </button>
//                                                     </div>
//                                                     <div className="item-price">
//                                                         ₹{item.totalPrice?.toFixed(2) || '0.00'}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     );
//                                 })}

//                             <div className="total-section">
//                                 <div style={{
//                                     fontSize: window.innerWidth < 1300 ? '0.9rem' : '1rem',
//                                     fontWeight: '600',
//                                     color: '#2d3748',
//                                     marginBottom: window.innerWidth < 768 ? '0.75rem' : '1rem',
//                                     textAlign: 'center'
//                                 }}>
//                                     Order Summary
//                                 </div>

//                                 {/* Replace this section in your JSX */}
//                                 <div style={{ marginBottom: window.innerWidth < 1300 ? '0.75rem' : '1rem' }}>
//                                     <div style={{
//                                         display: 'flex',
//                                         justifyContent: 'space-between',
//                                         alignItems: 'center',
//                                         marginBottom: window.innerWidth < 768 ? '0.4rem' : '0.5rem',
//                                         fontSize: window.innerWidth < 1300 ? '0.85rem' : '1rem',
//                                         color: '#4a5568'
//                                     }}>
//                                         <span>Sub Total</span>
//                                         <span>₹{cartData.subtotal?.toFixed(2) || '0.00'}</span>
//                                     </div>

//                                     {cartData.platformCharges > 0 && (
//                                         <div style={{
//                                             display: 'flex',
//                                             justifyContent: 'space-between',
//                                             alignItems: 'center',
//                                             marginBottom: window.innerWidth < 768 ? '0.4rem' : '0.5rem',
//                                             fontSize: window.innerWidth < 1300 ? '0.85rem' : '1rem',
//                                             color: '#4a5568'
//                                         }}>
//                                             <span style={{ textAlign: "start" }}>Platform Charges</span>
//                                             <span>₹{cartData.platformCharges?.toFixed(2) || '0.00'}</span>
//                                         </div>
//                                     )}

//                                     {/* ✅ FIX: Show packing charges ONLY for TAKEAWAY orders */}
//                                     {cartData.orderType === 'TAKEAWAY' && cartData.packingTotal > 0 && (
//                                         <div style={{
//                                             display: 'flex',
//                                             justifyContent: 'space-between',
//                                             alignItems: 'center',
//                                             marginBottom: window.innerWidth < 768 ? '0.4rem' : '0.5rem',
//                                             fontSize: window.innerWidth < 1300 ? '0.85rem' : '1rem',
//                                             color: '#4a5568'
//                                         }}>
//                                             <span>Packing Charges</span>
//                                             <span>₹{cartData.packingTotal?.toFixed(2) || '0.00'}</span>
//                                         </div>
//                                     )}

//                                     {/* ✅ FIX: Show service charges ONLY for DINE_IN orders */}
//                                     {cartData.orderType === 'DINE_IN' && (
//                                         <div style={{
//                                             display: 'flex',
//                                             justifyContent: 'space-between',
//                                             alignItems: window.innerWidth < 480 ? 'flex-start' : 'center',
//                                             marginBottom: window.innerWidth < 768 ? '0.4rem' : '0.5rem',
//                                             fontSize: window.innerWidth < 1300 ? '0.85rem' : '1rem',
//                                             color: '#4a5568',
//                                             flexDirection: window.innerWidth < 480 ? 'column' : 'row',
//                                             gap: window.innerWidth < 480 ? '0.3rem' : '0'
//                                         }}>
//                                             <span style={{
//                                                 flex: window.innerWidth < 480 ? '0 0 100%' : 'none',
//                                                 marginBottom: window.innerWidth < 480 ? '0.2rem' : '0'
//                                             }}>
//                                                 Service Charges
//                                             </span>

//                                             <div style={{
//                                                 display: window.innerWidth < 1300 ? ' ' : 'flex',
//                                                 alignItems: 'center',
//                                                 gap: window.innerWidth < 768 ? '0.3rem' : '0.5rem',
//                                                 flexDirection: window.innerWidth < 480 ? 'row' : 'row',
//                                                 justifyContent: window.innerWidth < 480 ? 'space-between' : 'flex-end',
//                                                 width: window.innerWidth < 480 ? '100%' : 'auto'
//                                             }}>
//                                                 <button
//                                                     onClick={toggleServiceCharge}
//                                                     disabled={isUpdatingServiceCharge || !cartData.cartId}
//                                                     style={{
//                                                         display: 'flex',
//                                                         alignItems: 'center',
//                                                         justifyContent: 'center',
//                                                         gap: window.innerWidth < 768 ? '0.2rem' : '0.3rem',
//                                                         padding: window.innerWidth < 1300 ? '0.2rem 0.4rem' : '0.3rem 0.6rem',
//                                                         backgroundColor: serviceChargeStatus === "APPLICABLE" ? '#4caf50' : '#e53e3e',
//                                                         color: 'white',
//                                                         border: 'none',
//                                                         borderRadius: '0.25rem',
//                                                         fontSize: window.innerWidth < 768 ? '0.7rem' : '0.8rem',
//                                                         fontWeight: '600',
//                                                         cursor: (isUpdatingServiceCharge || !cartData.cartId) ? 'not-allowed' : 'pointer',
//                                                         transition: 'all 0.2s ease',
//                                                         opacity: (isUpdatingServiceCharge || !cartData.cartId) ? 0.7 : 1,
//                                                         minWidth: window.innerWidth < 480 ? '60px' : 'auto',
//                                                         minHeight: window.innerWidth < 768 ? '28px' : '32px'
//                                                     }}
//                                                     title={!cartData.cartId ? "Add items to cart first" : ""}
//                                                     onMouseOver={(e) => {
//                                                         if (!isUpdatingServiceCharge && cartData.cartId) {
//                                                             e.target.style.backgroundColor = serviceChargeStatus === "APPLICABLE" ? '#3d8b40' : '#c53030';
//                                                         }
//                                                     }}
//                                                     onMouseOut={(e) => {
//                                                         if (!isUpdatingServiceCharge && cartData.cartId) {
//                                                             e.target.style.backgroundColor = serviceChargeStatus === "APPLICABLE" ? '#4caf50' : '#e53e3e';
//                                                         }
//                                                     }}
//                                                 >
//                                                     {isUpdatingServiceCharge ? (
//                                                         '...'
//                                                     ) : serviceChargeStatus === "APPLICABLE" ? (
//                                                         'Remove'
//                                                     ) : (
//                                                         'Apply'
//                                                     )}
//                                                 </button>

//                                                 <span style={{
//                                                     minWidth: window.innerWidth < 768 ? '50px' : '60px',
//                                                     textAlign: 'right',
//                                                     fontSize: window.innerWidth < 1300 ? '0.85rem' : '1rem',
//                                                     fontWeight: '500'
//                                                 }}>
//                                                     ₹{cartData.serviceCharges?.toFixed(2) || '0.00'}
//                                                 </span>
//                                             </div>
//                                         </div>
//                                     )}

//                                     {cartData.gstTotal > 0 && (
//                                         <div style={{
//                                             display: 'flex',
//                                             justifyContent: 'space-between',
//                                             alignItems: 'center',
//                                             marginBottom: window.innerWidth < 768 ? '0.6rem' : '0.75rem',
//                                             fontSize: window.innerWidth < 1300 ? '0.85rem' : '1rem',
//                                             color: '#4a5568'
//                                         }}>
//                                             <span>GST</span>
//                                             <span>₹{cartData.gstTotal?.toFixed(2) || '0.00'}</span>
//                                         </div>
//                                     )}

//                                     <div style={{
//                                         borderTop: '1px solid #e2e8f0',
//                                         margin: window.innerWidth < 768 ? '0.5rem 0' : '0.75rem 0'
//                                     }}></div>

//                                     <div style={{
//                                         display: 'flex',
//                                         justifyContent: 'space-between',
//                                         alignItems: 'center',
//                                         fontSize: window.innerWidth < 1300 ? '0.90rem' : (window.innerHeight <= 700 ? '1rem' : '1.1rem'),
//                                         fontWeight: '700',
//                                         color: '#2d3748',
//                                         paddingTop: window.innerWidth < 768 ? '0.3rem' : '0.5rem'
//                                     }}>
//                                         <span>Grand Total</span>
//                                         <span style={{
//                                             color: '#b15cd6',
//                                             fontSize: window.innerWidth < 480 ? '0.95rem' : (
//                                                 window.innerWidth < 768 ? '1rem' : (
//                                                     window.innerWidth < 1300 ? '0.9rem' : '1.3rem'
//                                                 )
//                                             )
//                                         }}>
//                                             ₹{grandTotal.toFixed(2)}
//                                         </span>
//                                     </div>
//                                 </div>

//                                 <div style={{
//                                     fontSize: window.innerWidth < 768 ? '0.7rem' : '0.8rem',
//                                     color: '#718096',
//                                     textAlign: 'center',
//                                     marginTop: window.innerWidth < 768 ? '0.3rem' : '0.5rem',
//                                     padding: window.innerWidth < 768 ? '0.3rem' : '0.5rem',
//                                     backgroundColor: '#f7fafc',
//                                     borderRadius: '0.25rem',
//                                     border: '1px solid #e2e8f0'
//                                 }}>
//                                     {cartData.orderType === 'DINE_IN' ? 'Dine In Order' : 'Take Away Order'}
//                                 </div>
//                             </div>
//                         </div>

//                         <div style={{
//                             marginTop: '1rem',
//                             padding: '1rem',
//                             border: '1px solid #e2e8f0',
//                             borderRadius: '0.25rem',
//                             backgroundColor: 'white'
//                         }}>
//                             <div style={{
//                                 fontSize: window.innerWidth < 1300 ? '0.9rem' : '1rem',
//                                 fontWeight: '600',
//                                 color: '#2d3748',
//                                 marginBottom: '0.5rem'
//                             }}>
//                                 Select Payment Method
//                             </div>

//                             <div style={{ display: 'flex', gap: '1rem' }}>
//                                 <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//                                     <input
//                                         type="radio"
//                                         name="payment"
//                                         value="Cash"
//                                         checked={selectedPaymentMethod === "Cash"}
//                                         onChange={() => handlePaymentMethodChange("Cash")}
//                                     />
//                                     <span>Cash</span>
//                                 </label>

//                                 <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//                                     <input
//                                         type="radio"
//                                         name="payment"
//                                         value="Online_Payment"
//                                         checked={selectedPaymentMethod === "Online_Payment"}
//                                         onChange={() => handlePaymentMethodChange("Online_Payment")}
//                                     />
//                                     <span>Online</span>
//                                 </label>
//                             </div>
//                         </div>

//                         {selectedPaymentMethod === "Cash" && (
//                             <button
//                                 onClick={() => handlePlaceOrder("Cash")}
//                                 style={{
//                                     width: '100%',
//                                     backgroundColor: 'white',
//                                     color: 'black',
//                                     fontWeight: '700',
//                                     fontSize: '1rem',
//                                     padding: '12px',
//                                     border: 'none',
//                                     borderRadius: '0.5rem',
//                                     marginTop: '1rem',
//                                     cursor: 'pointer',
//                                     transition: 'background-color 0.2s ease'
//                                 }}
//                                 onMouseOver={(e) => e.target.style.backgroundColor = '#f8f9fa'}
//                                 onMouseOut={(e) => e.target.style.backgroundColor = 'white'}
//                             >
//                                 Place Order
//                             </button>
//                         )}

//                         {selectedPaymentMethod === "Online_Payment" && loading && (
//                             <div style={{
//                                 textAlign: 'center',
//                                 padding: '1rem',
//                                 color: '#4a5568',
//                                 fontSize: '0.9rem'
//                             }}>
//                                 Loading payment gateway...
//                             </div>
//                         )}
//                     </>
//                 ) : (
//                     <div className="empty-cart">
//                         Cart is empty
//                     </div>
//                 )}
//             </div>
//             <Modal
//                 isOpen={showRemoveConfirm}
//                 onRequestClose={cancelRemove}
//                 contentLabel="Remove Item Confirmation"
//                 style={{
//                     overlay: {
//                         backgroundColor: "rgba(0, 0, 0, 0.5)",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         zIndex: 9999
//                     },
//                     content: {
//                         position: "relative",
//                         top: "auto",
//                         left: "auto",
//                         right: "auto",
//                         bottom: "auto",
//                         width: "90%",
//                         maxWidth: "400px",
//                         margin: "0 auto",
//                         border: "none",
//                         borderRadius: "10px",
//                         padding: "2rem",
//                         textAlign: "center",
//                         boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)"
//                     }
//                 }}
//             >
//                 <div style={{ textAlign: "center" }}>
//                     <h3 style={{
//                         color: "#2d3748",
//                         marginBottom: "1rem",
//                         fontSize: "1.3rem"
//                     }}>
//                         Remove Item
//                     </h3>
//                     <p style={{
//                         color: "#718096",
//                         marginBottom: "2rem",
//                         fontSize: "1rem",
//                         lineHeight: "1.5"
//                     }}>
//                         Are you sure you want to remove<br />
//                         <strong>"{itemToRemove?.cartItem?.dishName}"</strong><br />
//                         from your cart?
//                     </p>
//                     <div style={{
//                         display: "flex",
//                         gap: "1rem",
//                         justifyContent: "center"
//                     }}>
//                         <button
//                             onClick={cancelRemove}
//                             style={{
//                                 padding: "0.75rem 1.5rem",
//                                 border: "2px solid #e2e8f0",
//                                 background: "white",
//                                 color: "#4a5568",
//                                 borderRadius: "0.5rem",
//                                 cursor: "pointer",
//                                 fontWeight: "600",
//                                 fontSize: "1rem",
//                                 transition: "all 0.2s ease"
//                             }}
//                             onMouseOver={(e) => {
//                                 e.target.style.borderColor = "#b15cd6";
//                                 e.target.style.color = "#b15cd6";
//                             }}
//                             onMouseOut={(e) => {
//                                 e.target.style.borderColor = "#e2e8f0";
//                                 e.target.style.color = "#4a5568";
//                             }}
//                         >
//                             Cancel
//                         </button>
//                         <button
//                             onClick={confirmRemove}
//                             style={{
//                                 padding: "0.75rem 1.5rem",
//                                 border: "none",
//                                 background: "#e53e3e",
//                                 color: "white",
//                                 borderRadius: "0.5rem",
//                                 cursor: "pointer",
//                                 fontWeight: "600",
//                                 fontSize: "1rem",
//                                 transition: "all 0.2s ease"
//                             }}
//                             onMouseOver={(e) => {
//                                 e.target.style.background = "#c53030";
//                             }}
//                             onMouseOut={(e) => {
//                                 e.target.style.background = "#e53e3e";
//                             }}
//                         >
//                             Remove
//                         </button>
//                     </div>
//                 </div>
//             </Modal>

//             {showCashPopup && (
//                 <div style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     width: '100vw',
//                     height: '100vh',
//                     backgroundColor: 'rgba(0,0,0,0.5)',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     zIndex: 10000,
//                     padding: '20px',
//                 }}>
//                     <div style={{
//                         backgroundColor: '#fff',
//                         padding: '24px',
//                         borderRadius: '10px',
//                         width: '90%',
//                         maxWidth: '450px',
//                         boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
//                         fontFamily: 'sans-serif',
//                     }}>
//                         <h3 style={{ marginBottom: '16px', fontSize: '18px' }}>
//                             Enter Cash Payment Details
//                         </h3>



//                         <div style={{
//                             marginBottom: '20px',
//                             backgroundColor: '#f9f9f9',
//                             padding: '16px',
//                             borderRadius: '8px',
//                             border: '1px solid #eee',
//                         }}>
//                             <div style={{
//                                 display: 'grid',
//                                 gridTemplateColumns: screenWidth < 768 ? "1fr" : "repeat(3, 1fr)",
//                                 gap: '10px 16px',
//                             }}>
//                                 {[1, 2, 5, 10, 20, 50, 100, 200, 500].map((denom) => (
//                                     <div key={denom} style={{ display: 'flex', alignItems: 'center', fontWeight: "bold" }}>
//                                         <label style={{ width: '50px', fontSize: '16px' }}>₹{denom}</label>
//                                         <input
//                                             type="number"
//                                             value={notesCount[denom] || ''}
//                                             onChange={(e) => handleNotesChange(denom, e.target.value)}
//                                             placeholder="0"
//                                             style={{
//                                                 width: '60px',
//                                                 padding: '6px',
//                                                 borderRadius: '4px',
//                                                 border: '1px solid #ccc',
//                                                 fontSize: '14px',
//                                             }}
//                                         />
//                                     </div>
//                                 ))}
//                             </div>

//                             <div style={{
//                                 marginTop: '16px',
//                                 padding: '12px',
//                                 backgroundColor: '#fff',
//                                 borderRadius: '6px',
//                                 border: '1px solid #e0e0e0'
//                             }}>
//                                 <div style={{
//                                     display: 'flex',
//                                     justifyContent: 'space-between',
//                                     marginBottom: '6px',
//                                     fontSize: '14px'
//                                 }}>
//                                     <span>Grand Total:</span>
//                                     <strong style={{ color: '#2d3748' }}>₹{grandTotal.toFixed(2)}</strong>
//                                 </div>
//                                 <div style={{
//                                     display: 'flex',
//                                     justifyContent: 'space-between',
//                                     marginBottom: '6px',
//                                     fontSize: '14px'
//                                 }}>
//                                     <span>Denomination Total:</span>
//                                     <strong style={{ color: '#2d3748' }}>₹{denominationTotal.toFixed(2)}</strong>
//                                 </div>

//                                 <div style={{
//                                     display: 'flex',
//                                     justifyContent: 'space-between',
//                                     marginBottom: '6px',
//                                     fontSize: '14px'
//                                 }}>
//                                     {remainingAmount >= 0 ? 'Return Amount:' : 'Remaining Amount:'}
//                                     <strong style={{
//                                         color: remainingAmount >= 0 ? '#4caf50' : '#f44336',
//                                         fontWeight: 'bold'
//                                     }}>
//                                         {remainingAmount >= 0 ? '+' : ''}₹{Math.abs(remainingAmount).toFixed(2)}
//                                     </strong>
//                                 </div>


//                             </div>
//                         </div>



//                         <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
//                             <button
//                                 style={{
//                                     flex: 1,
//                                     padding: '12px',
//                                     backgroundColor: isSubmittingCash ? '#cccccc' : '#4caf50',
//                                     border: 'none',
//                                     borderRadius: '6px',
//                                     color: 'white',
//                                     fontWeight: 'bold',
//                                     fontSize: '16px',
//                                     cursor: isSubmittingCash ? 'not-allowed' : 'pointer',
//                                     transition: 'background-color 0.3s'
//                                 }}
//                                 onClick={handleCashPaymentSubmit}
//                                 disabled={!paidAmount || parseFloat(paidAmount) < grandTotal || isSubmittingCash}
//                             >
//                                 {isSubmittingCash ? 'Processing...' : 'Submit Payment'}
//                             </button>
//                             <button
//                                 style={{
//                                     flex: 1,
//                                     padding: '12px',
//                                     backgroundColor: '#f44336',
//                                     border: 'none',
//                                     borderRadius: '6px',
//                                     color: 'white',
//                                     fontWeight: 'bold',
//                                     fontSize: '16px',
//                                     cursor: 'pointer',
//                                     transition: 'background-color 0.3s'
//                                 }}
//                                 onClick={() => {
//                                     setShowCashPopup(false);
//                                     setSelectedPaymentMethod("");
//                                     setNotesCount({});
//                                     setPaidAmount('');
//                                 }}
//                             >
//                                 Cancel
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             <style>{`
//                 .cart-item-box {
//                     padding: 0.5rem 0.5rem;
//                     border-bottom: 0px solid #e9ecef;
//                 }

//                 .cart-item-row {
//                     display: flex;
//                     justify-content: space-between;
//                     align-items: center;
//                     gap: 1rem;
//                 }

//                 .item-name-container {
//                     flex: 2;
//                     min-width: 0;
//                 }

//                 .item-name {
//                     font-weight: 500;
//                     color: #2d3748;
//                     white-space: nowrap;
//                     overflow: hidden;
//                     text-overflow: ellipsis;
//                     max-width: 100%;
//                 }

//                 .item-controls-container {
//                     flex: 1;
//                     display: flex;
//                     justify-content: space-between;
//                     align-items: center;
//                     min-width: 150px;
//                 }

//                 .quantity-controls {
//                     display: flex;
//                     align-items: center;
//                     gap: 0.5rem;
//                 }

//                 .quantity-btn {
//                     width: 24px;
//                     height: 24px;
//                     border-radius: 4px;
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     cursor: pointer;
//                     transition: all 0.2s ease;
//                 }

//                 .outline-btn {
//                     border: 0px solid #b15cd6;
//                     background: white;
//                     color: #b15cd6;
//                 }

//                 .outline-btn:hover {
//                     background: #b15cd6;
//                     color: white;
//                 }

//                 .quantity-display {
//                     min-width: 20px;
//                     text-align: center;
//                     font-weight: 600;
//                     color: #2d3748;
//                 }

//                 .item-price {
//                     font-weight: 600;
//                     color: #2d3748;
//                     min-width: 0px;
//                     text-align: right;
//                 }

//                 .cart-content-container {
//                     flex: 1;
//                     overflow-y: auto;
//                     padding-right: 4px;
//                 }

//                 .hide-scrollbar::-webkit-scrollbar {
//                     width: 4px;
//                 }

//                 .hide-scrollbar::-webkit-scrollbar-track {
//                     background: #f1f1f1;
//                     border-radius: 4px;
//                 }

//                 .hide-scrollbar::-webkit-scrollbar-thumb {
//                     background: #b15cd6;
//                     border-radius: 4px;
//                 }

//                 .empty-cart {
//                     text-align: center;
//                     padding: 3rem 1rem;
//                     color: #718096;
//                     font-size: 1.1rem;
//                     background: white;
//                     border-radius: 0.5rem;
//                     border: 1px solid #e9ecef;
//                 }

//                 .total-section {
//                     padding: 1rem;
//                     border-top: 0px solid #e9ecef;
//                 }

//                 @media (max-width: 1399px) {
//                 .total-section {
//                     padding: 0.5rem;
//                     border-top: 0px solid #e9ecef;
//                 }
//                     .cart-item-row {
//                         flex-direction: column;
//                         align-items: flex-start;
//                         gap: 0.5rem;
//                     }

//                     .item-name-container {
//                         width: 100%;
//                         margin-bottom: 0rem;
//                     }

//                     .item-name {
//                         font-size: 13px;
//                         width: 100%;
//                     }

//                     .item-controls-container {
//                         width: 100%;
//                         justify-content: space-between;
//                         min-width: auto;
//                     }

//                     .quantity-controls {
//                         margin-left: 0;
//                     }

//                     .quantity-btn {
//                         width: 22px;
//                         height: 22px;
//                     }

//                     .quantity-icon {
//                         width: 9px;
//                         height: 9px;
//                     }

//                     .quantity-display {
//                         font-size: 13px;
//                         min-width: 18px;
//                     }

//                     .item-price {
//                         font-size: 13px;
//                         min-width: 0px;
//                         text-align: right;
//                         margin-left: auto;
//                     }
//                 }

//                 @media (max-width: 768px) {
//                     .cart-item-box {
//                         padding: 0.5rem;
//                     }

//                     .quantity-btn {
//                         width: 20px;
//                         height: 20px;
//                     }

//                     .quantity-icon {
//                         width: 8px;
//                         height: 8px;
//                     }

//                     .quantity-display {
//                         min-width: 16px;
//                         font-size: 12px;
//                     }

//                     .item-price {
//                         min-width: 0px;
//                         font-size: 12px;
//                     }

//                     .item-name {
//                         font-size: 12px;
//                     }
//                 }
//                     @media(max-width:1200px) {
//                     .endalign{
//                     text-align:end;
//                     }
//                     }
//             `}</style>
//             <style>{`
    

//     .cart-item-row {
//         display: flex;
//         justify-content: space-between;
//         align-items: center;
//         gap: 1rem;
//     }

//     .item-name-container {
//         flex: 2;
//         min-width: 0;
//     }

//     .item-name {
//         font-weight: 500;
//         color: #2d3748;
//         white-space: nowrap;
//         overflow: hidden;
//         text-overflow: ellipsis;
//         max-width: 100%;
//         font-size: 0.9rem;
//     }

//     .item-controls-container {
//         flex: 2;
//         display: flex;
//         justify-content: space-between;
//         align-items: center;
//         min-width: 180px;
//     }

//     .quantity-controls {
//         flex: 1;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         gap: 0rem;
//     }

//     .quantity-btn {
//         width: 26px;
//         height: 26px;
//         border-radius: 4px;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         cursor: pointer;
//         transition: all 0.2s ease;
//     }

//     .outline-btn {
//         border: 0px solid #b15cd6;
//         background: white;
//         color: #b15cd6;
//     }

//     .outline-btn:hover {
//         background: #b15cd6;
//         color: white;
//     }

//     .quantity-display {
//         min-width: 25px;
//         text-align: center;
//         font-weight: 600;
//         color: #2d3748;
//         font-size: 0.9rem;
//     }

//     .item-price {
//         flex: 1;
//         font-weight: 600;
//         color: #2d3748;
//         text-align: right;
//         font-size: 0.9rem;
//     }

//     /* Responsive for screens < 1399px */
//     @media (max-width: 1399px) {
        
        
//         .cart-item-row {
//             flex-direction: row;
//             justify-content: space-between;
//             gap: 0.75rem;
//         }

//         .item-name-container {
//             flex: 1;
//             min-width: 0;
//         }

//         .item-name {
//             font-size: 0.85rem;
//             white-space: normal;
//             line-height: 1.3;
//         }

//         .item-controls-container {
//             flex-direction: row;
//             align-items: center;
            
//             min-width: 120px;
//         }

//         .quantity-controls {
//             justify-content: center;
//         }

//         .quantity-btn {
//             width: 24px;
//             height: 24px;
//         }

//         .quantity-icon {
//             width: 10px;
//             height: 10px;
//         }

//         .quantity-display {
//             min-width: 22px;
//             font-size: 0.85rem;
//         }

//         .item-price {
//             text-align: right;
//             font-size: 0.85rem;
//             min-width: 0px;
//         }
//     }

//     /* For very small screens */
//     @media (max-width: 768px) {
//         .cart-item-box {
//             padding: 0.5rem;
//         }

//         .cart-item-row {
//             gap: 0.5rem;
//         }

//         .item-name {
//             font-size: 0.8rem;
//         }

//         .item-controls-container {
//             gap: 0.5rem;
//             min-width: 100px;
//         }

//         .quantity-btn {
//             width: 22px;
//             height: 22px;
//         }

//         .quantity-display {
//             min-width: 20px;
//             font-size: 0.8rem;
//         }

//         .item-price {
//             font-size: 0.8rem;
//             min-width: 0px;
//         }
//     }
// `}</style>
//         </div>
//     );
// };

// export default MenuCartSidebar;







import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Modal from 'react-modal';
import { FaPlus, FaMinus, FaTrash, FaPrint, FaDownload, FaCheck, FaTimes } from "react-icons/fa"; import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import "./MenuCartSidebar.css";

Modal.setAppElement('#root');

const MenuCartSidebar = () => {
    const navigate = useNavigate();
    const [cartData, setCartData] = useState({ cartItems: [] });
    const [quantities, setQuantities] = useState({});
    const [grandTotal, setGrandTotal] = useState(0);
    const [refresh, setRefresh] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [itemToRemove, setItemToRemove] = useState(null);
    const [showRemoveConfirm, setShowRemoveConfirm] = useState(false);
    const [userId, setUserId] = useState(localStorage.getItem("userId") || 3);
    const [loading, setLoading] = useState(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
    const [savedDetails, setSavedDetails] = useState(null);
    const [vendorDetails, setVendorDetails] = useState({
        name: "",
        email: "",
        phone: ""
    });
    const vendorDetailsRef = useRef({
        name: "",
        email: "",
        phone: ""
    });
    const [showCashPopup, setShowCashPopup] = useState(false);
    const [notesCount, setNotesCount] = useState({});
    const [paidAmount, setPaidAmount] = useState('');
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [showReceipt, setShowReceipt] = useState(false);
    const [orderData, setOrderData] = useState({});
    const [bannerData, setBannerData] = useState(null);
    const [isProcessingBack, setIsProcessingBack] = useState(false);
    const [isPrinting, setIsPrinting] = useState(false);
    const [isSubmittingCash, setIsSubmittingCash] = useState(false);
    const printRef = useRef();
    const receiptRef = useRef();
    // Add this with other useState declarations
    const [serviceChargeStatus, setServiceChargeStatus] = useState("NOT_APPLICABLE");
    const [isUpdatingServiceCharge, setIsUpdatingServiceCharge] = useState(false);

    // Add effect for screen resize
    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    // Add this function in your component
    const toggleServiceCharge = async () => {
        const token = localStorage.getItem("authToken");
        const cartId = localStorage.getItem("cartId");

        if (!token || !cartId) {
            alert("Unable to update service charge. Missing required data.");
            return;
        }

        const newStatus = serviceChargeStatus === "APPLICABLE" ? "NOT_APPLICABLE" : "APPLICABLE";

        setIsUpdatingServiceCharge(true);

        try {
            const response = await axios.put(
                `https://backend.maamaas.com/food/api/cart/coupon/${cartId}`,
                {
                    serviceCharge: newStatus
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            if (response.status === 200) {
                setServiceChargeStatus(newStatus);
                // Refresh cart data to update charges
                fetchCartData();
                alert(`Service charge ${newStatus === "APPLICABLE" ? "applied" : "removed"} successfully`);
            }
        } catch (error) {
            console.error("Error updating service charge:", error);
            alert("Failed to update service charge. Please try again.");
        } finally {
            setIsUpdatingServiceCharge(false);
        }
    };

    useEffect(() => {
        // When order type changes to TAKEAWAY, automatically remove service charges
        if (cartData.orderType === 'TAKEAWAY' && serviceChargeStatus === "APPLICABLE") {
            const removeServiceChargesForTakeaway = async () => {
                const token = localStorage.getItem("authToken");
                const cartId = localStorage.getItem("cartId");

                if (!token || !cartId) return;

                setIsUpdatingServiceCharge(true);

                try {
                    await axios.put(
                        `https://backend.maamaas.com/food/api/cart/coupon/${cartId}`,
                        {
                            serviceCharge: "NOT_APPLICABLE"
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-Type": "application/json"
                            }
                        }
                    );

                    setServiceChargeStatus("NOT_APPLICABLE");
                    await fetchCartData(); // Refresh cart to update totals
                    console.log("✅ Service charges removed for Takeaway order");
                } catch (error) {
                    console.error("Failed to remove service charges for Takeaway:", error);
                } finally {
                    setIsUpdatingServiceCharge(false);
                }
            };

            removeServiceChargesForTakeaway();
        }
    }, [cartData.orderType, serviceChargeStatus]);
    // Fetch vendor details
    const fetchVendorDetails = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) return;

        try {
            // ✅ USE THE SAME ENDPOINT AS MANAGEMENT5
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/vendors/${vendorId}`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            if (response.data) {
                const vendorData = response.data;

                // ✅ EXACT SAME LOGIC AS MANAGEMENT5
                const vendorMobile =
                    vendorData?.mobileNumber && vendorData.mobileNumber.toString().trim() !== ""
                        ? vendorData.mobileNumber.toString()
                        : "9999999999";

                const vendorName =
                    vendorData?.ownerName && vendorData.ownerName.trim() !== ""
                        ? vendorData.ownerName
                        : "Vendor";

                const vendorEmail =
                    vendorData?.email && vendorData.email.trim() !== ""
                        ? vendorData.email
                        : "vendor@example.com";

                setVendorDetails({
                    name: vendorName,
                    email: vendorEmail,
                    phone: vendorMobile  // ✅ This will be used in payment
                });

                console.log("✅ Vendor details fetched:", { vendorMobile, vendorName, vendorEmail });
            }
        } catch (error) {
            console.error("❌ Error fetching vendor details:", error);

            // ✅ Use same fallback as Management5
            setVendorDetails({
                name: "Vendor",
                email: "vendor@example.com",
                phone: "9999999999"  // Same fallback number
            });
        }

        console.log("Vendor phone for payment:", vendorDetails.phone);
    };


    useEffect(() => {
        fetchCartData();
        fetchVendorDetails();  // ✅ ADD THIS LINE
        fetchBannerData();
    }, [refresh]);

    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    const fetchOrderDetails = async (orderId) => {
        try {
            const authToken = localStorage.getItem("authToken");
            if (!authToken) {
                console.error("❌ No auth token found in localStorage");
                return;
            }

            const response = await axios.get(
                `https://backend.maamaas.com/food/api/orders/order/${orderId}`,
                {
                    headers: {
                        "Authorization": `Bearer ${authToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200) {
                setOrderData(response.data);
                return response.data;
            }
        } catch (error) {
            console.error("❌ Failed to fetch order details:", error.response?.data || error.message);
        }
    };

    const fetchBannerData = async () => {
        const vendorId = localStorage.getItem("vendorId");
        if (!vendorId) return;

        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.get(
                `https://backend.maamaas.com/food/banner/vendor/${vendorId}`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            setBannerData({
                ...response.data,
                companyName: response.data.companyName || "MAAMAAS HOUSE",
            });
        } catch (err) {
            console.error("Error fetching banner data:", err);
        }
    };
    // const triggerFullRefresh = () => {
    //     // Trigger refresh for all components
    //     setRefresh(prev => prev + 1);

    //     // Dispatch a custom event for other components to listen to
    //     const event = new CustomEvent('fullRefresh');
    //     window.dispatchEvent(event);

    //     // Also force fetch cart data
    //     fetchCartData();
    // };
    useEffect(() => {
        fetchVendorDetails();
    }, []);

    const handlePlaceOrder = async (paymentMethodParam = null) => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");
        const cartId = localStorage.getItem("cartId");

        if (!userId) {
            alert("User ID not found. Please log in again.");
            return;
        }

        const paymentMethod = paymentMethodParam || selectedPaymentMethod;

        if (!paymentMethod) {
            alert("Please select a payment method");
            return;
        }

        try {
            localStorage.removeItem("orderId");

            if (paymentMethod === "Online_Payment") {
                try {
                    const isRazorpayLoaded = await loadRazorpayScript();
                    if (!isRazorpayLoaded) {
                        alert("❌ Razorpay SDK failed to load.");
                        setLoading(false);
                        return;
                    }

                    const amountInPaise = Math.round(grandTotal * 100);
                    const displayAmount = amountInPaise / 100;

                    const orderResponse = await fetch(
                        "https://backend.maamaas.com/food/api/payments/create-order",
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${token}`,
                            },
                            body: JSON.stringify({
                                amount: displayAmount,
                                phoneNumber: vendorDetails.phone,
                                currency: "INR",
                                receipt: `order_${Date.now()}`,
                                notes: {
                                    customer_name: vendorDetails.name,
                                    order_reference: `WEB_ORDER_${Math.floor(Math.random() * 10000)}`,
                                },
                            }),
                        }
                    );

                    if (!orderResponse.ok) throw new Error("❌ Failed to create Razorpay order");
                    const orderData = await orderResponse.json();

                    const options = {
                        key: "rzp_live_RU5whSMu9rPV7s",
                        amount: amountInPaise,
                        currency: "INR",
                        order_id: orderData.orderId,
                        name: "Maamaa's House",
                        description: "Order Payment",
                        // In the Razorpay options:
                        prefill: {
                            name: vendorDetails.name,
                            email: vendorDetails.email,
                            contact: vendorDetails.phone,  // ✅ This now has the vendor's mobile
                        },
                        theme: { color: "#3399cc" },

                        handler: async function (response) {
                            try {
                                const capturePayload = {
                                    paymentId: response.razorpay_payment_id,
                                    amount: amountInPaise / 100,
                                    currency: "INR",
                                    receipt: `receipt_${Date.now()}`,
                                };


                                const captureRes = await fetch(
                                    "https://backend.maamaas.com/food/api/payments/capture",
                                    {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                            Authorization: `Bearer ${token}`,
                                        },
                                        body: JSON.stringify(capturePayload),
                                    }
                                );

                                const captureData = await captureRes.json();

                                if (!captureRes.ok || captureData.status !== "captured") {
                                    alert("❌ Payment capture failed!");
                                    return;
                                }

                                const backendOrderParams = {
                                    vendorId: vendorId,
                                    paymentMethod: "Online_Payment",
                                    razorpayPaymentId: response.razorpay_payment_id,
                                    razorpayOrderId: 1,
                                    phoneNumber: vendorDetails.phone,  // ✅ Use the fetched vendor phone
                                };

                                const responseOrder = await axios.post(
                                    `https://backend.maamaas.com/food/api/orders/orders/vendor/create/${cartId}`,
                                    "",
                                    {
                                        params: backendOrderParams,
                                        headers: { Authorization: `Bearer ${token}` },
                                        validateStatus: false,
                                    }
                                );

                                if (responseOrder.status === 200 || responseOrder.status === 201) {
                                    const orderId = responseOrder.data.orderId;
                                    localStorage.setItem("orderId", orderId);

                                    const orderDetails = await fetchOrderDetails(orderId);
                                    if (orderDetails) {
                                        // Set payment method to Online_Payment for auto-print
                                        orderDetails.paymentMethod = "Online_Payment";
                                        setOrderData(orderDetails);
                                        setShowReceipt(true);
                                        fetchBannerData();

                                        // Clear cart data
                                        setCartData({ cartItems: [] });
                                        setQuantities({});
                                        setGrandTotal(0);
                                        setSelectedPaymentMethod("");

                                        // ✅ AUTO-REFRESH: Trigger full page refresh after 2 seconds
                                        // setTimeout(() => {
                                        //     window.location.reload();
                                        // }, 20000);

                                        // ✅ Trigger cart refresh for other components
                                        // triggerCartRefresh();
                                        // triggerFullRefresh();
                                    }
                                } else {
                                    alert("❌ Order creation failed after payment!");
                                }

                            } catch (err) {
                                alert("❌ Something went wrong after payment.");
                            }
                        },
                    };

                    const paymentObject = new window.Razorpay(options);
                    paymentObject.open();
                    return;
                } catch (err) {
                    alert("❌ Razorpay flow failed.");
                    setLoading(false);
                    return;
                }
            }

            // Cash Payment Flow - Modified to stay in sidebar

            const cashParams = {
                vendorId,
                paymentMethod: "Cash"
            };

            const cashRes = await axios.post(
                `https://backend.maamaas.com/food/api/orders/orders/vendor/create/${cartId}`,
                "",
                {
                    params: cashParams,
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            if (cashRes.data.orderId) {
                const orderId = cashRes.data.orderId;
                localStorage.setItem("orderId", orderId);

                // Don't navigate, just show cash popup
                setShowCashPopup(true);
                setPaidAmount(grandTotal.toFixed(2));

                alert("Order created! Please enter cash payment details.");

            } else {
                alert("⚠️ Cash Order creation failed");
            }

        } catch (error) {
            console.error("🚨 Checkout Error:", error);
            alert("Failed to proceed to checkout.");
        }
    };






    useEffect(() => {
        const handleFullRefresh = () => {
            fetchCartData();
            setRefresh(prev => prev + 1);
        };

        window.addEventListener('fullRefresh', handleFullRefresh);

        return () => {
            window.removeEventListener('fullRefresh', handleFullRefresh);
        };
    }, []);
    // Check for pending receipt on mount
    useEffect(() => {
        const checkPendingReceipt = async () => {
            const showReceiptFlag = localStorage.getItem("showReceipt");
            const receiptOrderId = localStorage.getItem("receiptOrderId");
            const receiptTimestamp = localStorage.getItem("receiptTimestamp");
            const currentTime = Date.now();

            if (showReceiptFlag === "true" && receiptOrderId) {
                // Check if receipt is recent (less than 5 minutes old)
                if (!receiptTimestamp || (currentTime - parseInt(receiptTimestamp)) < 5 * 60 * 1000) {
                    try {
                        const orderDetails = await fetchOrderDetails(receiptOrderId);
                        if (orderDetails) {
                            setOrderData(orderDetails);
                            setShowReceipt(true);
                            await fetchBannerData();
                        }
                    } catch (err) {
                        console.error("Error showing pending receipt:", err);
                    }
                } else {
                    // Clear old receipt data
                    localStorage.removeItem("showReceipt");
                    localStorage.removeItem("receiptOrderId");
                    localStorage.removeItem("receiptOrderData");
                    localStorage.removeItem("receiptTimestamp");
                }
            }
        };

        checkPendingReceipt();
    }, []);

    const handlePaymentMethodChange = async (method) => {
        setSelectedPaymentMethod(method);

        if (method === "Online_Payment") {
            await handlePlaceOrder(method);
        }

        if (method === "Cash") {
            // Show cash popup immediately for cash payment
            setShowCashPopup(true);
            setPaidAmount(grandTotal.toFixed(2));
        }
    };

    const handleNotesChange = (denomination, count) => {
        if (count === '' || /^[0-9\b]+$/.test(count)) {
            setNotesCount((prev) => {
                const newNotesCount = {
                    ...prev,
                    [denomination]: count,
                };

                let totalFromDenominations = 0;
                Object.keys(newNotesCount).forEach(denom => {
                    const noteCount = parseInt(newNotesCount[denom]) || 0;
                    totalFromDenominations += noteCount * parseInt(denom);
                });

                if (totalFromDenominations > 0) {
                    setPaidAmount(totalFromDenominations.toFixed(2));
                }

                return newNotesCount;
            });
        }
    };

    const handleCashPaymentSubmit = async () => {
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");
        const cartId = localStorage.getItem("cartId");

        if (!token || !vendorId || !cartId) {
            alert("Authentication error. Please try again.");
            return;
        }

        const paid = parseFloat(paidAmount);
        if (isNaN(paid) || paid <= 0) {
            alert("Please enter a valid paid amount.");
            return;
        }

        if (paid < grandTotal) {
            alert(`Paid amount (₹${paid.toFixed(2)}) is less than the grand total (₹${grandTotal.toFixed(2)}).`);
            return;
        }

        setIsSubmittingCash(true);

        const returnMoney = parseFloat((paid - grandTotal).toFixed(2));

        // Get current date in YYYY-MM-DD format
        const currentDate = new Date().toISOString().split('T')[0];

        const cashPaymentData = {
            id: 0,
            orderId: 0,
            oneRupee: parseInt(notesCount[1] || 0),
            twoRupee: parseInt(notesCount[2] || 0),
            fiveRupee: parseInt(notesCount[5] || 0),
            tenRupee: parseInt(notesCount[10] || 0),
            twentyRupee: parseInt(notesCount[20] || 0),
            fiftyRupee: parseInt(notesCount[50] || 0),
            hundredRupee: parseInt(notesCount[100] || 0),
            twoHundredRupee: parseInt(notesCount[200] || 0),
            fiveHundredRupee: parseInt(notesCount[500] || 0),
            twoThousandRupee: 0,
            grandTotal: grandTotal,
            paid: paid,
            returnMoney: returnMoney,
            date: currentDate, // Just add this line - date in YYYY-MM-DD format
        };

        try {
            // First create the order
            const orderResponse = await axios.post(
                `https://backend.maamaas.com/food/api/orders/orders/vendor/create/${cartId}`,
                "",
                {
                    params: {
                        vendorId,
                        paymentMethod: "Cash"
                    },
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            if (orderResponse.data.orderId) {
                const orderId = orderResponse.data.orderId;
                cashPaymentData.orderId = orderId;

                // Submit cash payment details
                await axios.post(
                    `https://backend.maamaas.com/food/api/cash-billing/addCash/${orderId}`,
                    cashPaymentData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                // ✅ NEW: Update payment status to PAID
                try {
                    // Assuming the API endpoint is like this (you might need to adjust the endpoint)
                    await axios.put(
                        `https://backend.maamaas.com/food/api/payments/update-status/${orderId}`,
                        { paymentStatus: "PAID" }, // or just "PAID" as string if that's what the API expects
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-Type": "application/json",
                            },
                        }
                    );
                } catch (statusError) {
                    console.error("⚠️ Failed to update payment status:", statusError);
                    // Don't fail the entire process if status update fails
                    // The payment is still successful, just the status might not be updated
                }

                // Fetch order details and show receipt in sidebar
                const orderDetails = await fetchOrderDetails(orderId);
                if (orderDetails) {
                    // Clear cart data locally
                    setCartData({ cartItems: [] });
                    setQuantities({});
                    setGrandTotal(0);
                    setSelectedPaymentMethod("");

                    // Fetch banner data for receipt
                    await fetchBannerData();

                    // Show receipt in sidebar
                    setOrderData(orderDetails);
                    setShowReceipt(true);

                    // Close cash popup
                    setShowCashPopup(false);
                    setNotesCount({});
                    setPaidAmount('');

                    // ✅ AUTO-REFRESH: Trigger full page refresh after 2 seconds
                    // setTimeout(() => {
                    //     window.location.reload();
                    // }, 20000);

                    // ✅ Also trigger cart refresh for other components immediately
                    triggerCartRefresh();
                    // triggerFullRefresh();
                } else {
                    alert("⚠️ Payment submitted but couldn't fetch order details.");
                }
            }
        } catch (error) {
            console.error("Cash payment error:", error);
            alert("Failed to process cash payment.");
        } finally {
            setIsSubmittingCash(false);
        }
    };
    // Auto-print effect for cash receipts
    // Auto-print effect for receipts (both Cash and Online Payment)
    useEffect(() => {
        // Only auto-print when receipt is shown and order data is available
        if (showReceipt && orderData.orderId && !isPrinting) {
            // Check if we've already printed this receipt
            const hasPrintedKey = `hasPrinted_${orderData.orderId}`;
            const hasPrinted = localStorage.getItem(hasPrintedKey);

            // Determine payment method for auto-print
            const isCashPayment = orderData.paymentMethod === "Cash";
            const isOnlinePayment = orderData.paymentMethod === "Online_Payment";

            // Auto-print for both payment methods
            if ((isCashPayment || isOnlinePayment) && !hasPrinted) {
                // Set a flag to prevent re-printing
                localStorage.setItem(hasPrintedKey, 'true');

                // Wait a bit for the DOM to fully render
                // const printTimer = setTimeout(() => {
                //     if (printRef.current) {
                //         handlePrint();
                //     }
                // }, 1000); // Increased delay for better rendering

                // return () => clearTimeout(printTimer);
            } else if (hasPrinted) {
            }
        }
    }, [showReceipt, orderData, isPrinting]);

    const fetchCartData = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const authToken = localStorage.getItem("authToken");

        if (!vendorId || !authToken) return;

        try {
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/cart/vendor/${vendorId}`,
                { headers: { Authorization: `Bearer ${authToken}` } }
            );

            if (response.data) {
                const data = response.data;
                setCartData(data);
                setGrandTotal(data.grandTotal || 0);

                if (data.cartId) {
                    localStorage.setItem("cartId", data.cartId);
                }
                if (data.serviceCharges > 0) {
                    setServiceChargeStatus("APPLICABLE");
                } else {
                    setServiceChargeStatus("NOT_APPLICABLE");
                }

                const updatedQuantities = (data.cartItems || []).reduce((acc, item) => {
                    acc[item.dishId] = item.quantity || 1;
                    return acc;
                }, {});
                setQuantities(updatedQuantities);
            }
        } catch (err) {
            console.error("Error fetching cart data:", err);
        }
    };

    const closeReceipt = () => {
        if (isProcessingBack) return;

        setIsProcessingBack(true);

        // Clear all receipt flags from localStorage
        localStorage.removeItem("showReceipt");
        localStorage.removeItem("receiptOrderId");
        localStorage.removeItem("receiptOrderData");
        localStorage.removeItem("receiptTimestamp");
        localStorage.removeItem("pendingReceiptShow");
        localStorage.removeItem("pendingReceiptOrderId");
        localStorage.removeItem("pendingReceiptPaymentMethod");

        // Clear the printed flag for this order
        if (orderData?.orderId) {
            localStorage.removeItem(`hasPrinted_${orderData.orderId}`);
        }

        // Hide receipt
        setShowReceipt(false);
        setOrderData({});

        // Fetch fresh cart data
        fetchCartData();

        // Trigger cart refresh for other components
        triggerCartRefresh();
        triggerFullRefresh();

        // Reset processing flag after delay
        setTimeout(() => {
            setIsProcessingBack(false);
        }, 500);
    };

    // const handlePrint = () => {
    //     // Check for order data (important for auto-print)
    //     if (!orderData || !orderData.orderId) {
    //         console.error("No order data available for printing");
    //         return;
    //     }

    //     // Store original content (only needed for manual print)
    //     const originalContent = document.body.innerHTML;

    //     const printStyles = `
    // <style>
    // @media print {
    //     body {
    //         width: 80mm !important;
    //         margin: 0 auto !important;
    //         padding: 0 !important;
    //         font-family: "Courier New", monospace !important;
    //         font-size: 10px !important;
    //         line-height: 1.2 !important;
    //         font-weight:900 !important;
    //     }

    //     h1, h2, h3 {
    //         font-weight: bold;
    //         text-align: center;
    //         margin: 0;
    //         padding: 0;
    //     }

    //     .big-title {
    //         font-size: 14px !important;
    //         font-weight: bold;
    //         text-align: center;
    //         margin-bottom: 5px;
    //     }

    //     .center-text {
    //         text-align: center;
    //         font-size: 10px;
    //         font-weight: bold;
    //     }

    //     .line {
    //         border-top: 1px solid black;
    //         margin: 6px 0;
    //     }

    //     .dashed {
    //         border-top: 1px dashed black;
    //         margin: 6px 0;
    //     }

    //     table {
    //         width: 100%;
    //         font-size: 10px;
    //         border-collapse: collapse;
    //     }

    //     th{
    //         padding: 0px 0px;
    //         font-weight: bold;
    //     }
    //     td { 
    //         padding: 2px 0px;
    //         font-weight: bold;
    //     }

    //     .row {
    //         display: flex;
    //         justify-content: space-around;
    //         font-size: 10px;
    //         font-weight: bold;
    //         white-space: nowrap;
    //         width: 100%;

    //     }

    //     .grand-label {
    //         font-size: 16px;
    //         font-weight: bold;
    //     }

    //     .grand-value {
    //         font-size: 16px;
    //         font-weight: bold;
    //     }

    //     .footer {
    //         text-align: center;
    //         margin-top: 10px;
    //         font-size: 10px;
    //     }

    //     .receipt-buttons, button {
    //         display: none !important;
    //     }

    //     @page {
    //         size: 80mm auto;
    //         margin: 0;
    //     }

    //     .page-break {
    //         page-break-after: always;
    //     }
    // }
    // </style>
    // `;

    //     // SIMPLE RECEIPT (Top Image) - HARDCODED "Take A Break"
    //     const receiptOne = `
    //     <div class="big-title">Take A Break</div>
    //     <div class="line"></div>

    //     <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
    //     <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>

    //     <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

    //     <div class="line"></div>

    //     <table>
    //         <thead>
    //             <tr>
    //                 <th style="text-align:center;">Item</th>
    //                 <th style="text-align:center;">Qty</th>
    //             </tr>
    //         </thead>
    //         <tbody>
    //             ${Array.isArray(orderData.order) ? orderData.order.map(item => `
    //                 <tr>
    //                     <td style="text-align:center;">${item.dishName || "Item"}</td>
    //                     <td style="text-align:center;">${item.quantity || 1}</td>
    //                 </tr>
    //             `).join("") : ""}
    //         </tbody>
    //     </table>

    //     <div class="line"></div>
    // `;

    //     // DETAILED RECEIPT (Bottom Image) - HARDCODED "Take A Break"
    //     const receiptTwo = `
    //     <div class="big-title">Take A Break</div>
    //     <div class="center-text">GSTIN: ${orderData?.vendorGstIn || "N/A"}</div>
    //     <div class="line"></div>

    //     <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
    //     <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>
    //     <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

    //     <div class="line"></div>

    //     <table class="items-table">
    //         <thead>
    //             <tr>
    //                 <th style="text-align:center;">Item</th>
    //                 <th style="text-align:center;">Qty</th>
    //                 <th style="text-align:center;">Price</th>
    //                 <th style="text-align:center;">Total</th>
    //             </tr>
    //         </thead>
    //         <tbody>
    //             ${Array.isArray(orderData.order) ? orderData.order.map(item => `
    //                 <tr>
    //                     <td style="text-align:center;">${item.dishName || "Item"}</td>
    //                     <td style="text-align:center;">${item.quantity || 1}</td>
    //                     <td style="text-align:center;">₹${(item.price || 0).toFixed(2)}</td>
    //                     <td style="text-align:center;">₹${((item.price || 0) * (item.quantity || 1)).toFixed(2)}</td>
    //                 </tr>
    //             `).join("") : ""}
    //         </tbody>
    //     </table>

    //     <div class="line"></div>

    //     <div class="row"><span>SubTotal</span><span>₹${(orderData.subTotal || 0).toFixed(2)}</span></div>
    //     <div class="row"><span>Platform</span><span>₹${(orderData.platformCharges || 0).toFixed(2)}</span></div>
    //     <div class="row"><span>Service</span><span>₹${(orderData.serviceCharge || 0).toFixed(2)}</span></div>
    //     <div class="row"><span>CGST</span><span>₹${(orderData.cgst || 0).toFixed(2)}</span></div>
    //     <div class="row"><span>SGST</span><span>₹${(orderData.sgst || 0).toFixed(2)}</span></div>

    //     <div class="line"></div>

    //     <div class="row">
    //         <span class="grand-label">Grand Total</span>
    //         <span class="grand-value">₹${(orderData.grandTotal || 0).toFixed(2)}</span>
    //     </div>

    //     <div class="dashed"></div>
    //     <div class="center-text">FSSAI: ${orderData?.vendorFssai || "23624032003384"}</div>

    //     <div class="footer">
    //         Thank you, visit again<br/>
    //         www.maamaas.com
    //     </div>
    // `;

    //     // FINAL PRINT CONTENT
    //     const finalHTML = `
    //     <!DOCTYPE html>
    //     <html>
    //     <head>
    //         <title>Receipt - ${orderData.orderId || 'Order'}</title>
    //         ${printStyles}
    //     </head>
    //     <body>
    //         ${receiptOne}
    //         <div class="page-break"></div>
    //         ${receiptTwo}
    //     </body>
    //     </html>
    // `;

    //     try {
    //         const printWindow = window.open('', '_blank', 'width=800,height=600');
    //         printWindow.document.open();
    //         printWindow.document.write(finalHTML);
    //         printWindow.document.close();

    //         printWindow.onload = () => {
    //             printWindow.print();

    //             // Listen for afterprint event
    //             printWindow.onafterprint = () => {
    //                 setTimeout(() => {
    //                     printWindow.close();

    //                     // AUTO-REFRESH: Only for manual prints, not auto-prints
    //                     // Check if we're in auto-print mode by seeing if receipt is showing
    //                     if (showReceipt) {
    //                         // This is auto-print - don't refresh, let auto-print handle closing
    //                         console.log("Auto-print completed, not refreshing");
    //                     } else {
    //                         // This is manual print - refresh the page
    //                         window.location.reload();
    //                     }
    //                 }, 500);
    //             };

    //             // Fallback in case afterprint doesn't fire
    //             setTimeout(() => {
    //                 printWindow.close();

    //                 // Same logic: only refresh for manual prints
    //                 if (!showReceipt) {
    //                     window.location.reload();
    //                 }
    //             }, 3000);
    //         };

    //         // Only restore original content for MANUAL prints
    //         // Auto-print doesn't need this since we're not modifying the page
    //         if (!showReceipt) {
    //             document.body.innerHTML = originalContent;
    //         }

    //     } catch (error) {
    //         console.error("Print error:", error);
    //         // Restore page on error
    //         if (!showReceipt) {
    //             document.body.innerHTML = originalContent;
    //         }
    //     }
    // };

    const handlePrint = () => {
        // Check for order data (important for auto-print)
        if (!orderData || !orderData.orderId) {
            console.error("No order data available for printing");
            return;
        }

        // Store original content (only needed for manual print)
        const originalContent = document.body.innerHTML;

        const printStyles = `
    <style>
    @media print {
        body {
            width: 80mm !important;
            margin: 0 auto !important;
            padding: 0 !important;
            font-family: "Courier New", monospace !important;
            font-size: 10px !important;
            line-height: 1.2 !important;
            font-weight:900 !important;
        }

        h1, h2, h3 {
            font-weight: bold;
            text-align: center;
            margin: 0;
            padding: 0;
        }

        .big-title {
            font-size: 14px !important;
            font-weight: bold;
            text-align: center;
            margin-bottom: 5px;
        }

        .center-text {
            text-align: center;
            font-size: 10px;
            font-weight: bold;
        }

        .line {
            border-top: 1px solid black;
            margin: 6px 0;
        }

        .dashed {
            border-top: 1px dashed black;
            margin: 6px 0;
        }

        table {
            width: 100%;
            font-size: 10px;
            border-collapse: collapse;
        }

        th{
            padding: 0px 0px;
            font-weight: bold;
        }
        td { 
            padding: 2px 0px;
            font-weight: bold;
        }

        .row {
            display: flex;
            justify-content: space-around;
            font-size: 10px;
            font-weight: bold;
            white-space: nowrap;
            width: 100%;

        }

        .grand-label {
            font-size: 16px;
            font-weight: bold;
        }

        .grand-value {
            font-size: 16px;
            font-weight: bold;
        }

        .footer {
            text-align: center;
            margin-top: 10px;
            font-size: 10px;
        }

        .receipt-buttons, button {
            display: none !important;
        }

        @page {
            size: 80mm auto;
            margin: 0;
        }

        .page-break {
            page-break-after: always;
        }
    }
    </style>
    `;

        // SIMPLE RECEIPT (Top Image) - HARDCODED "Take A Break"
        const receiptOne = `
        <div class="big-title">Take A Break</div>
        <div class="line"></div>

        <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
        <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>

        <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

        <div class="line"></div>

        <table>
            <thead>
                <tr>
                    <th style="text-align:center;">Item</th>
                    <th style="text-align:center;">Qty</th>
                </tr>
            </thead>
            <tbody>
                ${Array.isArray(orderData.order) ? orderData.order.map(item => `
                    <tr>
                        <td style="text-align:center;">${item.dishName || "Item"}</td>
                        <td style="text-align:center;">${item.quantity || 1}</td>
                    </tr>
                `).join("") : ""}
            </tbody>
        </table>

        <div class="line"></div>
    `;

        // DETAILED RECEIPT (Bottom Image) - HARDCODED "Take A Break"
        const receiptTwo = `
        <div class="big-title">Take A Break</div>
        <div class="center-text">GSTIN: ${orderData?.vendorGstIn || "N/A"}</div>
        <div class="line"></div>

        <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
        <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>
        <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

        <div class="line"></div>

        <table class="items-table">
            <thead>
                <tr>
                    <th style="text-align:center;">Item</th>
                    <th style="text-align:center;">Qty</th>
                    <th style="text-align:center;">Price</th>
                    <th style="text-align:center;">Total</th>
                </tr>
            </thead>
            <tbody>
                ${Array.isArray(orderData.order) ? orderData.order.map(item => `
                    <tr>
                        <td style="text-align:center;">${item.dishName || "Item"}</td>
                        <td style="text-align:center;">${item.quantity || 1}</td>
                        <td style="text-align:center;">₹${(item.price || 0).toFixed(2)}</td>
                        <td style="text-align:center;">₹${((item.price || 0) * (item.quantity || 1)).toFixed(2)}</td>
                    </tr>
                `).join("") : ""}
            </tbody>
        </table>

        <div class="line"></div>

        <div class="row"><span>SubTotal</span><span>₹${(orderData.subTotal || 0).toFixed(2)}</span></div>
        <div class="row"><span>Platform</span><span>₹${(orderData.platformCharges || 0).toFixed(2)}</span></div>
        <div class="row"><span>Service</span><span>₹${(orderData.serviceCharge || 0).toFixed(2)}</span></div>
        <div class="row"><span>CGST</span><span>₹${(orderData.cgst || 0).toFixed(2)}</span></div>
        <div class="row"><span>SGST</span><span>₹${(orderData.sgst || 0).toFixed(2)}</span></div>

        <div class="line"></div>

        <div class="row">
            <span class="grand-label">Grand Total</span>
            <span class="grand-value">₹${(orderData.grandTotal || 0).toFixed(2)}</span>
        </div>

        <div class="dashed"></div>
        <div class="center-text">FSSAI: ${orderData?.vendorFssai || "23624032003384"}</div>

        <div class="footer">
            Thank you, visit again<br/>
            www.maamaas.com
        </div>
    `;

        // FINAL PRINT CONTENT
        const finalHTML = `
        <!DOCTYPE html>
        <html>
        <head>
            <title>Receipt - ${orderData.orderId || 'Order'}</title>
            ${printStyles}
        </head>
        <body>
            ${receiptOne}
            <div class="page-break"></div>
            ${receiptTwo}
        </body>
        </html>
    `;

        try {
            const printWindow = window.open('', '_blank', 'width=800,height=600');
            printWindow.document.open();
            printWindow.document.write(finalHTML);
            printWindow.document.close();

            printWindow.onload = () => {
                printWindow.print();

                // Listen for afterprint event
                printWindow.onafterprint = () => {
                    setTimeout(() => {
                        printWindow.close();

                        // ✅ ADDED: AUTO-REFRESH AND CLEAR CART/RECEIPT
                        // Check if this is an auto-print (receipt just generated after order)
                        const isAutoPrint = showReceipt && orderData.orderId;

                        if (isAutoPrint) {

                            // Clear cart data locally
                            setCartData({ cartItems: [] });
                            setQuantities({});
                            setGrandTotal(0);
                            setSelectedPaymentMethod("");

                            // Hide receipt
                            setShowReceipt(false);
                            setOrderData({});

                            // Clear localStorage flags
                            localStorage.removeItem("showReceipt");
                            localStorage.removeItem("receiptOrderId");
                            localStorage.removeItem("receiptTimestamp");

                            // Trigger cart refresh for other components
                            triggerCartRefresh();
                            triggerFullRefresh();

                            // Optional: Show success message
                            setTimeout(() => {
                                alert("✅ Order completed! Cart has been cleared.");
                            }, 1000);
                        } else {
                            // This is manual print - just close window
                        }
                    }, 500);
                };

                // Fallback in case afterprint doesn't fire
                setTimeout(() => {
                    printWindow.close();

                    // ✅ ADDED: Same auto-refresh logic for fallback
                    const isAutoPrint = showReceipt && orderData.orderId;

                    if (isAutoPrint) {

                        // Clear cart data locally
                        setCartData({ cartItems: [] });
                        setQuantities({});
                        setGrandTotal(0);
                        setSelectedPaymentMethod("");

                        // Hide receipt
                        setShowReceipt(false);
                        setOrderData({});

                        // Clear localStorage flags
                        localStorage.removeItem("showReceipt");
                        localStorage.removeItem("receiptOrderId");
                        localStorage.removeItem("receiptTimestamp");

                        // Trigger cart refresh
                        triggerCartRefresh();
                        triggerFullRefresh();
                    }
                }, 3000);
            };
            setTimeout(() => {
                if (printWindow && !printWindow.closed) {
                    printWindow.close();
                }
            }, 1000);

            // Only restore original content for MANUAL prints
            // Auto-print doesn't need this since we're not modifying the page
            if (!showReceipt) {
                document.body.innerHTML = originalContent;
            }

        } catch (error) {
            console.error("Print error:", error);
            // Restore page on error
            if (!showReceipt) {
                document.body.innerHTML = originalContent;
            }
        }


        // Remove the setTimeout wrapper
    };
    // ADD THIS useEffect right after handlePrint:
    useEffect(() => {
        // Auto-print when receipt is shown with order data
        if (showReceipt && orderData?.orderId) {
            console.log("Auto-printing receipt...");

            // Small delay to ensure everything is loaded
            const timer = setTimeout(() => {
                handlePrint();
            }, 1000);

            return () => clearTimeout(timer);
        }
    }, [showReceipt, orderData?.orderId]); // Add handlePrint to dependency array

    const triggerFullRefresh = () => {
        window.location.reload();
    };

    // const handlePrint = () => {
    //     // Check for order data (important for auto-print)
    //     if (!orderData || !orderData.orderId) {
    //         console.error("No order data available for printing");
    //         return;
    //     }

    //     // Store original content (only needed for manual print)
    //     const originalContent = document.body.innerHTML;

    //     const printStyles = `
    // <style>
    // @media print {
    //     body {
    //         width: 80mm !important;
    //         margin: 0 auto !important;
    //         padding: 0 !important;
    //         font-family: "Courier New", monospace !important;
    //         font-size: 10px !important;
    //         line-height: 1.2 !important;
    //         font-weight:900 !important;
    //     }

    //     h1, h2, h3 {
    //         font-weight: bold;
    //         text-align: center;
    //         margin: 0;
    //         padding: 0;
    //     }

    //     .big-title {
    //         font-size: 14px !important;
    //         font-weight: bold;
    //         text-align: center;
    //         margin-bottom: 5px;
    //     }

    //     .center-text {
    //         text-align: center;
    //         font-size: 10px;
    //         font-weight: bold;
    //     }

    //     .line {
    //         border-top: 1px solid black;
    //         margin: 6px 0;
    //     }

    //     .dashed {
    //         border-top: 1px dashed black;
    //         margin: 6px 0;
    //     }

    //     table {
    //         width: 100%;
    //         font-size: 10px;
    //         border-collapse: collapse;
    //     }

    //     th{
    //         padding: 0px 0px;
    //         font-weight: bold;
    //     }
    //     td { 
    //         padding: 2px 0px;
    //         font-weight: bold;
    //     }

    //     .row {
    //         display: flex;
    //         justify-content: space-around;
    //         font-size: 10px;
    //         font-weight: bold;
    //         white-space: nowrap;
    //         width: 100%;

    //     }

    //     .grand-label {
    //         font-size: 16px;
    //         font-weight: bold;
    //     }

    //     .grand-value {
    //         font-size: 16px;
    //         font-weight: bold;
    //     }

    //     .footer {
    //         text-align: center;
    //         margin-top: 10px;
    //         font-size: 10px;
    //     }

    //     .receipt-buttons, button {
    //         display: none !important;
    //     }

    //     @page {
    //         size: 80mm auto;
    //         margin: 0;
    //     }

    //     .page-break {
    //         page-break-after: always;
    //     }
    // }
    // </style>
    // `;

    //     // SIMPLE RECEIPT (Top Image) - HARDCODED "Take A Break"
    //     const receiptOne = `
    //     <div class="big-title">Take A Break</div>
    //     <div class="line"></div>

    //     <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
    //     <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>

    //     <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

    //     <div class="line"></div>

    //     <table>
    //         <thead>
    //             <tr>
    //                 <th style="text-align:center;">Item</th>
    //                 <th style="text-align:center;">Qty</th>
    //             </tr>
    //         </thead>
    //         <tbody>
    //             ${Array.isArray(orderData.order) ? orderData.order.map(item => `
    //                 <tr>
    //                     <td style="text-align:center;">${item.dishName || "Item"}</td>
    //                     <td style="text-align:center;">${item.quantity || 1}</td>
    //                 </tr>
    //             `).join("") : ""}
    //         </tbody>
    //     </table>

    //     <div class="line"></div>
    // `;

    //     // DETAILED RECEIPT (Bottom Image) - HARDCODED "Take A Break"
    //     const receiptTwo = `
    //     <div class="big-title">Take A Break</div>
    //     <div class="center-text">GSTIN: ${orderData?.vendorGstIn || "N/A"}</div>
    //     <div class="line"></div>

    //     <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
    //     <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>
    //     <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

    //     <div class="line"></div>

    //     <table class="items-table">
    //         <thead>
    //             <tr>
    //                 <th style="text-align:center;">Item</th>
    //                 <th style="text-align:center;">Qty</th>
    //                 <th style="text-align:center;">Price</th>
    //                 <th style="text-align:center;">Total</th>
    //             </tr>
    //         </thead>
    //         <tbody>
    //             ${Array.isArray(orderData.order) ? orderData.order.map(item => `
    //                 <tr>
    //                     <td style="text-align:center;">${item.dishName || "Item"}</td>
    //                     <td style="text-align:center;">${item.quantity || 1}</td>
    //                     <td style="text-align:center;">₹${(item.price || 0).toFixed(2)}</td>
    //                     <td style="text-align:center;">₹${((item.price || 0) * (item.quantity || 1)).toFixed(2)}</td>
    //                 </tr>
    //             `).join("") : ""}
    //         </tbody>
    //     </table>

    //     <div class="line"></div>

    //     <div class="row"><span>SubTotal</span><span>₹${(orderData.subTotal || 0).toFixed(2)}</span></div>
    //     <div class="row"><span>Platform</span><span>₹${(orderData.platformCharges || 0).toFixed(2)}</span></div>
    //     <div class="row"><span>Service</span><span>₹${(orderData.serviceCharge || 0).toFixed(2)}</span></div>
    //     <div class="row"><span>CGST</span><span>₹${(orderData.cgst || 0).toFixed(2)}</span></div>
    //     <div class="row"><span>SGST</span><span>₹${(orderData.sgst || 0).toFixed(2)}</span></div>

    //     <div class="line"></div>

    //     <div class="row">
    //         <span class="grand-label">Grand Total</span>
    //         <span class="grand-value">₹${(orderData.grandTotal || 0).toFixed(2)}</span>
    //     </div>

    //     <div class="dashed"></div>
    //     <div class="center-text">FSSAI: ${orderData?.vendorFssai || "23624032003384"}</div>

    //     <div class="footer">
    //         Thank you, visit again<br/>
    //         www.maamaas.com
    //     </div>
    // `;

    //     // FINAL PRINT CONTENT
    //     const finalHTML = `
    //     <!DOCTYPE html>
    //     <html>
    //     <head>
    //         <title>Receipt - ${orderData.orderId || 'Order'}</title>
    //         ${printStyles}
    //     </head>
    //     <body>
    //         ${receiptOne}
    //         <div class="page-break"></div>
    //         ${receiptTwo}
    //     </body>
    //     </html>
    // `;

    //     try {
    //         const printWindow = window.open('', '_blank', 'width=800,height=600');
    //         printWindow.document.open();
    //         printWindow.document.write(finalHTML);
    //         printWindow.document.close();

    //         printWindow.onload = () => {
    //             printWindow.print();

    //             // Listen for afterprint event
    //             printWindow.onafterprint = () => {
    //                 setTimeout(() => {
    //                     printWindow.close();

    //                     // ✅ ADDED: AUTO-REFRESH AND CLEAR CART/RECEIPT
    //                     // Check if this is an auto-print (receipt just generated after order)
    //                     const isAutoPrint = showReceipt && orderData.orderId;

    //                     if (isAutoPrint) {

    //                         // Clear cart data locally
    //                         setCartData({ cartItems: [] });
    //                         setQuantities({});
    //                         setGrandTotal(0);
    //                         setSelectedPaymentMethod("");

    //                         // Hide receipt
    //                         setShowReceipt(false);
    //                         setOrderData({});

    //                         // Clear localStorage flags
    //                         localStorage.removeItem("showReceipt");
    //                         localStorage.removeItem("receiptOrderId");
    //                         localStorage.removeItem("receiptTimestamp");

    //                         // Trigger cart refresh for other components
    //                         triggerCartRefresh();
    //                         triggerFullRefresh();

    //                         // Optional: Show success message
    //                         setTimeout(() => {
    //                             alert("✅ Order completed! Cart has been cleared.");
    //                         }, 1000);
    //                     } else {
    //                         // This is manual print - just close window
    //                     }
    //                 }, 500);
    //             };

    //             // Fallback in case afterprint doesn't fire
    //             setTimeout(() => {
    //                 printWindow.close();

    //                 // ✅ ADDED: Same auto-refresh logic for fallback
    //                 const isAutoPrint = showReceipt && orderData.orderId;

    //                 if (isAutoPrint) {

    //                     // Clear cart data locally
    //                     setCartData({ cartItems: [] });
    //                     setQuantities({});
    //                     setGrandTotal(0);
    //                     setSelectedPaymentMethod("");

    //                     // Hide receipt
    //                     setShowReceipt(false);
    //                     setOrderData({});

    //                     // Clear localStorage flags
    //                     localStorage.removeItem("showReceipt");
    //                     localStorage.removeItem("receiptOrderId");
    //                     localStorage.removeItem("receiptTimestamp");

    //                     // Trigger cart refresh
    //                     triggerCartRefresh();
    //                     triggerFullRefresh();
    //                 }
    //             }, 3000);
    //         };
    //         setTimeout(() => {
    //             if (printWindow && !printWindow.closed) {
    //                 printWindow.close();
    //             }
    //         }, 1000);

    //         // Only restore original content for MANUAL prints
    //         // Auto-print doesn't need this since we're not modifying the page
    //         if (!showReceipt) {
    //             document.body.innerHTML = originalContent;
    //         }

    //     } catch (error) {
    //         console.error("Print error:", error);
    //         // Restore page on error
    //         if (!showReceipt) {
    //             document.body.innerHTML = originalContent;
    //         }
    //     }

    //     window.location.reload();
    //     // Remove the setTimeout wrapper
    // };

    const handleDownload = async () => {
        const receipt = receiptRef.current;
        if (!receipt) return;

        const buttons = receipt.querySelectorAll(".receipt-buttons");
        const buttonStates = [];
        buttons.forEach(btn => {
            buttonStates.push({
                element: btn,
                originalDisplay: btn.style.display
            });
            btn.style.display = "none";
        });

        await new Promise(resolve => setTimeout(resolve, 100));

        const originalStyle = {
            height: receipt.style.height,
            overflowY: receipt.style.overflowY
        };
        receipt.style.height = "auto";
        receipt.style.overflowY = "visible";

        try {
            const canvas = await html2canvas(receipt, {
                scale: 2,
                useCORS: true,
                logging: false
            });

            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");
            const imgWidth = 210;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            pdf.addImage(imgData, "PNG", 0, 10, imgWidth, imgHeight);
            pdf.save("Payment_Receipt.pdf");

            buttonStates.forEach(state => {
                state.element.style.display = state.originalDisplay;
            });
            receipt.style.height = originalStyle.height;
            receipt.style.overflowY = originalStyle.overflowY;

        } catch (err) {
            console.error("❌ Error generating PDF:", err);
            buttonStates.forEach(state => {
                state.element.style.display = state.originalDisplay;
            });
            receipt.style.height = originalStyle.height;
            receipt.style.overflowY = originalStyle.overflowY;
        }
    };


    const clearCart = async () => {
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");
        const cartId = localStorage.getItem("cartId");

        if (!token || !vendorId || !cartId) {
            alert("Unable to clear cart. Missing required data.");
            return;
        }

        if (cartData.cartItems.length === 0) {
            alert("Cart is already empty!");
            return;
        }

        if (!window.confirm("Are you sure you want to clear all items from your cart?")) {
            return;
        }

        try {
            for (const item of cartData.cartItems) {
                const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartId}?dishId=${item.dishId}&quantity=0`;
                await axios.put(apiUrl, null, {
                    headers: { Authorization: `Bearer ${token}` }
                });
            }

            setCartData({ cartItems: [] });
            setQuantities({});
            setGrandTotal(0);
            setShowReceipt(false);

            alert("Cart cleared successfully!");
            triggerCartRefresh();

        } catch (err) {
            console.error("Error clearing cart:", err);
            alert("Failed to clear cart. Please try again.");
        }
    };

    const triggerCartRefresh = () => {
        const event = new CustomEvent('cartUpdated');
        window.dispatchEvent(event);
    }

    useEffect(() => {
        const handleCartUpdate = () => {
            setRefresh(prev => prev + 1);
        };

        window.addEventListener('cartUpdated', handleCartUpdate);
        return () => {
            window.removeEventListener('cartUpdated', handleCartUpdate);
        };
    }, []);

    useEffect(() => {
        fetchCartData();
    }, [refresh]);



    const increaseQuantity = async (dishId) => {
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");
        if (!token || !vendorId) return alert("Auth token or vendorId missing");

        if (!cartData || !cartData.cartItems) {
            alert("Cart is empty or not loaded yet.");
            return;
        }

        const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
        if (!cartItem) {
            alert("Item not found in cart. Please add it first.");
            return;
        }

        const newQty = (quantities[dishId] || 0) + 1;

        const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartData.cartId}?dishId=${dishId}&quantity=${newQty}`;

        try {
            await axios.put(apiUrl, null, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setQuantities(prev => ({ ...prev, [dishId]: newQty }));
            setCartData(prev => ({
                ...prev,
                cartItems: prev.cartItems.map(item =>
                    item.dishId === dishId ? { ...item, quantity: newQty } : item
                )
            }));
            setIsModalOpen(true);
            triggerCartRefresh();
            setTimeout(() => {
                if (!isHovered) setIsModalOpen(false);
            }, 20000000);
        } catch (err) {
            console.error("API Error:", err.response ? err.response.data : err);
            alert("Unable to update quantity for dishId: " + dishId);
        }
    };

    const decreaseQuantity = async (dishId) => {
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");
        const currentQty = quantities[dishId] || 0;
        if (currentQty === 0) return;

        if (!cartData || !cartData.cartItems) {
            alert("Cart is empty or not loaded yet.");
            return;
        }

        const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
        if (!cartItem) return alert("Item not found");

        const newQty = currentQty - 1;

        if (newQty === 0) {
            setItemToRemove({ dishId, cartItem });
            setShowRemoveConfirm(true);
            return;
        }

        await updateQuantity(dishId, newQty);
    };
    const updateQuantity = async (dishId, newQty) => {
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");

        const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartData.cartId}?dishId=${dishId}&quantity=${newQty}`;

        try {
            await axios.put(apiUrl, null, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setQuantities(prev => ({ ...prev, [dishId]: newQty > 0 ? newQty : 0 }));
            setCartData(prev => ({
                ...prev,
                cartItems: newQty > 0
                    ? prev.cartItems.map(item =>
                        item.dishId === dishId ? { ...item, quantity: newQty } : item
                    )
                    : prev.cartItems.filter(item => item.dishId !== dishId)
            }));
            setIsModalOpen(true);
            triggerCartRefresh();
            setTimeout(() => {
                if (!isHovered) setIsModalOpen(false);
            }, 20000000);
        } catch (err) {
            console.error("API Error:", err.response ? err.response.data : err);
            alert("Unable to update quantity for dishId: " + dishId);
        }
    };

    const confirmRemove = async () => {
        if (itemToRemove) {
            await updateQuantity(itemToRemove.dishId, 0);
            setShowRemoveConfirm(false);
            setItemToRemove(null);
        }
    };

    const cancelRemove = () => {
        setShowRemoveConfirm(false);
        setItemToRemove(null);
    };

    const displayData = cartData.cartItems || [];
    const hasItems = displayData.filter(item => (quantities[item.dishId] ?? item.quantity ?? 1) > 0).length > 0;

    if (!hasItems && !showReceipt) {
        return null;
    }

    const calculateDenominationTotal = () => {
        let total = 0;
        Object.keys(notesCount).forEach(denom => {
            const count = parseInt(notesCount[denom]) || 0;
            total += count * parseInt(denom);
        });
        return total;
    };

    const denominationTotal = calculateDenominationTotal();
    const remainingAmount = denominationTotal - grandTotal;

    return (
        <div style={{
            background: '#b15cd6',
            borderRadius: '0.5rem',
            padding: '1rem',
            height: 'fit-content',
            maxHeight: '85vh',
            display: 'flex',
            flexDirection: 'column',
            marginTop: window.innerHeight <= 700 ? "3rem" : "5rem",
            minHeight: '500px',
            position: 'sticky',
            top: '6rem',
            zIndex: window.innerHeight <= 700 ? 30000 : " ",
        }}>
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: '0.3rem',
                paddingBottom: '0.75rem',
                borderBottom: '0px solid #e9ecef',
                flexShrink: 0,
                position: 'relative',
                height: '40px'
            }}>
                <h4 style={{
                    color: '#f8f9fa',
                    margin: 0,
                    fontSize: '1.3rem',
                    fontWeight: '600',
                    textAlign: 'center'
                }}>
                    {showReceipt ? 'Order Receipt' : 'Cart'}
                </h4>

                {hasItems && !showReceipt && (
                    <button
                        onClick={clearCart}
                        style={{
                            background: '#e53e3e',
                            border: '1px solid #e53e3e',
                            color: 'white',
                            padding: '0.4rem 0.8rem',
                            borderRadius: '0.25rem',
                            fontSize: '0.85rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.3rem',
                            transition: 'all 0.2s ease',
                            position: 'absolute',
                            right: "10px",
                            top: '50%',
                            transform: 'translateY(-75%)'
                        }}
                    >
                        Clear
                    </button>
                )}

                {showReceipt && (
                    <>
                        <button
                            onClick={closeReceipt}
                            disabled={isProcessingBack}
                            style={{
                                background: 'transparent',
                                border: '1px solid #f8f9fa',
                                color: '#f8f9fa',
                                padding: '0.4rem 0.8rem',
                                borderRadius: '0.25rem',
                                fontSize: '0.85rem',
                                fontWeight: '600',
                                cursor: isProcessingBack ? 'not-allowed' : 'pointer',
                                display: window.innerWidth <= 1400 ? "none" : "flex",
                                alignItems: 'center',
                                gap: '0.3rem',
                                transition: 'all 0.2s ease',
                                position: 'absolute',
                                left: "10px",
                                top: '50%',
                                transform: 'translateY(-75%)',
                                opacity: isProcessingBack ? 0.7 : 1
                            }}
                            onMouseOver={(e) => {
                                if (!isProcessingBack) {
                                    e.target.style.backgroundColor = '#f8f9fa';
                                    e.target.style.color = '#b15cd6';
                                }
                            }}
                            onMouseOut={(e) => {
                                if (!isProcessingBack) {
                                    e.target.style.backgroundColor = 'transparent';
                                    e.target.style.color = '#f8f9fa';
                                }
                            }}
                        >
                            {isProcessingBack ? '...' : '← Back'}
                        </button>
                        <button
                            onClick={closeReceipt}
                            disabled={isProcessingBack}
                            style={{
                                background: 'transparent',
                                border: '1px solid #f8f9fa',
                                color: '#f8f9fa',
                                padding: '0.4rem 0.8rem',
                                borderRadius: '0.25rem',
                                fontSize: '0.85rem',
                                fontWeight: '600',
                                cursor: isProcessingBack ? 'not-allowed' : 'pointer',
                                display: window.innerWidth <= 1400 ? "flex" : "none",
                                alignItems: 'center',
                                gap: '0.3rem',
                                transition: 'all 0.2s ease',
                                position: 'absolute',
                                left: "0px",
                                top: '50%',
                                transform: 'translateY(-75%)',
                                opacity: isProcessingBack ? 0.7 : 1
                            }}
                            onMouseOver={(e) => {
                                if (!isProcessingBack) {
                                    e.target.style.backgroundColor = '#f8f9fa';
                                    e.target.style.color = '#b15cd6';
                                }
                            }}
                            onMouseOut={(e) => {
                                if (!isProcessingBack) {
                                    e.target.style.backgroundColor = 'transparent';
                                    e.target.style.color = '#f8f9fa';
                                }
                            }}
                        >
                            {isProcessingBack ? '...' : '←'}
                        </button>
                    </>
                )}
            </div>

            <div className="cart-content-container hide-scrollbar">
                {showReceipt ? (
                    <div ref={receiptRef} style={{
                        backgroundColor: "white",
                        borderRadius: '0.5rem',
                        padding: '1rem',
                        overflowY: 'auto',
                        maxHeight: 'calc(85vh - 100px)',
                        scrollbarWidth: "none",
                    }}>
                        <div ref={printRef}>
                            <div style={{
                                textAlign: 'center',
                                marginBottom: '1rem',
                                paddingBottom: '0.5rem',
                                borderBottom: '2px solid #b15cd6'
                            }}>
                                <h5 style={{
                                    color: '#b15cd6',
                                    margin: '0.5rem 0',
                                    fontSize: window.innerWidth < 1200 ? '1.1rem' : '1.2rem'
                                }}>
                                    ✅ Payment Successful!
                                </h5>
                                <h6 style={{
                                    margin: 0,
                                    color: '#2d3748',
                                    fontSize: '1rem'
                                }}>
                                    {bannerData?.companyName || "MAAMAAS HOUSE"}
                                </h6>
                            </div>

                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '0.5rem',
                                marginBottom: '1rem',
                                fontSize: '0.9rem'
                            }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span style={{ fontWeight: '600', color: '#4a5568' }}>Order ID:</span>
                                    <span className='endalign' style={{ fontWeight: '700', color: '#2d3748' }}>{orderData.orderId}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span style={{ fontWeight: '600', color: '#4a5568' }}>Date:</span>
                                    <span className='endalign' style={{ fontWeight: '700', color: '#2d3748' }}>
                                        {orderData.date ? new Date(orderData.date).toLocaleDateString('en-GB') : new Date().toLocaleDateString('en-GB')}
                                    </span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span style={{ fontWeight: '600', color: '#4a5568' }}>Order Type:</span>
                                    <span className='endalign' style={{ fontWeight: '700', color: '#2d3748' }}>{orderData.orderType}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span style={{ fontWeight: '600', color: '#4a5568' }}>Time:</span>
                                    <span className='endalign' style={{ fontWeight: '700', color: '#2d3748' }}>
                                        {orderData.time ? new Date(`1970-01-01T${orderData.time}`).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }) : "N/A"}
                                    </span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span style={{ fontWeight: '600', color: '#4a5568' }}>Payment Method:</span>
                                    <span style={{ fontWeight: '700', color: '#2d3748', display: window.innerWidth < 1200 ? "flex" : "flex", alignItems: window.innerWidth < 1200 ? "end" : " " }}>{orderData.paymentMethod}</span>
                                </div>
                            </div>

                            <hr style={{ border: '1px dashed #cbd5e0', margin: '1rem 0' }} />

                            {Array.isArray(orderData.order) && orderData.order.length > 0 ? (
                                <>
                                    <table style={{
                                        width: '100%',
                                        borderCollapse: 'collapse',
                                        fontSize: '0.85rem',
                                        marginBottom: '1rem'
                                    }}>
                                        <thead>
                                            <tr style={{ borderBottom: '2px solid #e2e8f0' }}>
                                                <th style={{ padding: '0.5rem', textAlign: 'left', fontWeight: '600', color: '#4a5568' }}>Item</th>
                                                <th style={{ padding: '0.5rem', textAlign: 'center', fontWeight: '600', color: '#4a5568' }}>Qty</th>
                                                <th style={{ padding: '0.5rem', textAlign: 'right', fontWeight: '600', color: '#4a5568' }}>Price</th>
                                                <th style={{ padding: '0.5rem', textAlign: 'right', fontWeight: '600', color: '#4a5568' }}>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {orderData.order.map((item, index) => (
                                                <tr key={index} style={{ borderBottom: '1px solid #e2e8f0' }}>
                                                    <td style={{ padding: '0.5rem', textAlign: 'left' }}>{item.dishName || "N/A"}</td>
                                                    <td style={{ padding: '0.5rem', textAlign: 'center' }}>{item.quantity ?? "N/A"}</td>
                                                    <td style={{ padding: '0.5rem', textAlign: 'right' }}>₹{item.price?.toFixed(2) || "0.00"}</td>
                                                    <td style={{ padding: '0.5rem', textAlign: 'right' }}>
                                                        ₹{item.price && item.quantity ? (item.price * item.quantity).toFixed(2) : "0.00"}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    <div style={{ marginBottom: '1rem', fontSize: '0.9rem' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
                                            <span>Sub Total:</span>
                                            <span>₹{orderData.subTotal?.toFixed(2) || "0.00"}</span>
                                        </div>
                                        {orderData.platformCharges > 0 && (
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
                                                <span>Platform Charges:</span>
                                                <span>₹{orderData.platformCharges?.toFixed(2) || "0.00"}</span>
                                            </div>
                                        )}
                                        {orderData.serviceCharge > 0 && (
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
                                                <span>Service Charges:</span>
                                                <span>₹{orderData.serviceCharge?.toFixed(2) || "0.00"}</span>
                                            </div>
                                        )}
                                        {orderData.cgst > 0 && (
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
                                                <span>CGST:</span>
                                                <span>₹{orderData.cgst?.toFixed(2) || "0.00"}</span>
                                            </div>
                                        )}
                                        {orderData.sgst > 0 && (
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
                                                <span>SGST:</span>
                                                <span>₹{orderData.sgst?.toFixed(2) || "0.00"}</span>
                                            </div>
                                        )}
                                    </div>

                                    <hr style={{ border: '1px dashed #cbd5e0', margin: '1rem 0' }} />

                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '0.75rem',
                                        backgroundColor: '#f7fafc',
                                        borderRadius: '0.25rem',
                                        border: '0px solid #b15cd6',
                                        marginBottom: '1rem'
                                    }}>
                                        <span style={{ fontSize: '1.1rem', fontWeight: '700', color: '#2d3748' }}>Grand Total:</span>
                                        <span style={{ fontSize: '1.3rem', fontWeight: '900', color: '#b15cd6' }}>
                                            ₹{orderData.grandTotal?.toFixed(2) || "0.00"}
                                        </span>
                                    </div>

                                    <div style={{
                                        textAlign: 'center',
                                        padding: '1rem',
                                        borderTop: '2px solid #e2e8f0',
                                        marginTop: '1rem'
                                    }}>
                                        <h6 style={{ color: '#4a5568', marginBottom: '0.5rem' }}>
                                            Thank You! Visit Again
                                        </h6>
                                        <p style={{ color: '#a0aec0', fontSize: '0.8rem', margin: 0 }}>
                                            www.maamaas.com
                                        </p>
                                    </div>
                                </>
                            ) : (
                                <p style={{ textAlign: 'center', color: '#718096' }}>No order data available.</p>
                            )}
                        </div>

                        <div className="receipt-buttons" style={{
                            display: 'flex',
                            gap: window.innerWidth < 1200 ? '0.5rem' : '1rem',
                            justifyContent: 'center',
                            marginTop: '1rem',
                            paddingTop: '1rem',
                            borderTop: '1px solid #e2e8f0'
                        }}>
                            <button
                                onClick={handlePrint}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                    padding: window.innerWidth < 1200 ? '0.3rem 1rem ' : '0.75rem 1.5rem',
                                    backgroundColor: '#b15cd6',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '0.5rem',
                                    cursor: 'pointer',
                                    fontWeight: '600',
                                    fontSize: '0.9rem',
                                    transition: 'all 0.2s ease'
                                }}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#9b46c9'}
                                onMouseOut={(e) => e.target.style.backgroundColor = '#b15cd6'}
                            >
                                <FaPrint /> Print
                            </button>
                            <button
                                onClick={handleDownload}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                    padding: window.innerWidth < 1200 ? '0.5rem 1rem ' : '0.75rem 1.5rem',
                                    backgroundColor: '#4a5568',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '0.5rem',
                                    cursor: 'pointer',
                                    fontWeight: '600',
                                    fontSize: '0.9rem',
                                    transition: 'all 0.2s ease'
                                }}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#2d3748'}
                                onMouseOut={(e) => e.target.style.backgroundColor = '#4a5568'}
                            >
                                <FaDownload /> Download
                            </button>
                        </div>
                    </div>
                ) : hasItems ? (
                    <>
                        <div style={{
                            backgroundColor: "white",
                            border: "1px solid #e9ecef",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.08)",
                        }}>
                            {/* Cart Headers - Only shown on larger screens */}
                            <div className="cart-headers" style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '0.75rem 1rem',
                                borderBottom: '2px solid #b15cd6',
                                backgroundColor: '#f8f9fa',
                                fontWeight: '600',
                                color: '#2d3748',
                                fontSize: '0.9rem'
                            }}>
                                <div style={{ flex: window.innerWidth < 1399 ? "1" : "2", textAlign: 'left' }}>
                                    Items
                                </div>
                                <div style={{ flex: 1, textAlign: 'center' }}>
                                    Quantity
                                </div>
                                <div style={{ flex: 1, textAlign: 'right' }}>
                                    Price
                                </div>
                            </div>

                            {displayData
                                .filter(item => (quantities[item.dishId] ?? item.quantity ?? 1) > 0)
                                .map((item, index) => {
                                    const currentQuantity = quantities[item.dishId] ?? item.quantity ?? 1;

                                    return (
                                        <div key={item.cartItemId || index} className="cart-item-box">
                                            <div className="cart-item-row">
                                                <div className="item-name-container">
                                                    <div className="item-name" title={item.dishName}>
                                                        {item.dishName}
                                                    </div>
                                                </div>
                                                <div className="item-controls-container">
                                                    <div className="quantity-controls">
                                                        <button
                                                            className="quantity-btn outline-btn"
                                                            onClick={() => decreaseQuantity(item.dishId)}
                                                            title="Decrease quantity"
                                                        >
                                                            <FaMinus className="quantity-icon" />
                                                        </button>
                                                        <span className="quantity-display">
                                                            {currentQuantity}
                                                        </span>
                                                        <button
                                                            className="quantity-btn outline-btn"
                                                            onClick={() => increaseQuantity(item.dishId)}
                                                            title="Increase quantity"
                                                        >
                                                            <FaPlus className="quantity-icon" />
                                                        </button>
                                                    </div>
                                                    <div className="item-price">
                                                        ₹{item.totalPrice?.toFixed(2) || '0.00'}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}

                            <div className="total-section">
                                <div style={{
                                    fontSize: window.innerWidth < 1300 ? '0.9rem' : '1rem',
                                    fontWeight: '600',
                                    color: '#2d3748',
                                    marginBottom: window.innerWidth < 768 ? '0.75rem' : '1rem',
                                    textAlign: 'center'
                                }}>
                                    Order Summary
                                </div>

                                {/* Replace this section in your JSX */}
                                <div style={{ marginBottom: window.innerWidth < 1300 ? '0.75rem' : '1rem' }}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginBottom: window.innerWidth < 768 ? '0.4rem' : '0.5rem',
                                        fontSize: window.innerWidth < 1300 ? '0.85rem' : '1rem',
                                        color: '#4a5568'
                                    }}>
                                        <span>Sub Total</span>
                                        <span>₹{cartData.subtotal?.toFixed(2) || '0.00'}</span>
                                    </div>

                                    {cartData.platformCharges > 0 && (
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: window.innerWidth < 768 ? '0.4rem' : '0.5rem',
                                            fontSize: window.innerWidth < 1300 ? '0.85rem' : '1rem',
                                            color: '#4a5568'
                                        }}>
                                            <span style={{ textAlign: "start" }}>Platform Charges</span>
                                            <span>₹{cartData.platformCharges?.toFixed(2) || '0.00'}</span>
                                        </div>
                                    )}

                                    {/* ✅ FIX: Show packing charges ONLY for TAKEAWAY orders */}
                                    {cartData.orderType === 'TAKEAWAY' && cartData.packingTotal > 0 && (
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: window.innerWidth < 768 ? '0.4rem' : '0.5rem',
                                            fontSize: window.innerWidth < 1300 ? '0.85rem' : '1rem',
                                            color: '#4a5568'
                                        }}>
                                            <span>Packing Charges</span>
                                            <span>₹{cartData.packingTotal?.toFixed(2) || '0.00'}</span>
                                        </div>
                                    )}

                                    {/* ✅ FIX: Show service charges ONLY for DINE_IN orders */}
                                    {cartData.orderType === 'DINE_IN' && (
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: window.innerWidth < 480 ? 'flex-start' : 'center',
                                            marginBottom: window.innerWidth < 768 ? '0.4rem' : '0.5rem',
                                            fontSize: window.innerWidth < 1300 ? '0.85rem' : '1rem',
                                            color: '#4a5568',
                                            flexDirection: window.innerWidth < 480 ? 'column' : 'row',
                                            gap: window.innerWidth < 480 ? '0.3rem' : '0'
                                        }}>
                                            <span style={{
                                                flex: window.innerWidth < 480 ? '0 0 100%' : 'none',
                                                marginBottom: window.innerWidth < 480 ? '0.2rem' : '0'
                                            }}>
                                                Service Charges
                                            </span>

                                            <div style={{
                                                display: window.innerWidth < 1300 ? ' ' : 'flex',
                                                alignItems: 'center',
                                                gap: window.innerWidth < 768 ? '0.3rem' : '0.5rem',
                                                flexDirection: window.innerWidth < 480 ? 'row' : 'row',
                                                justifyContent: window.innerWidth < 480 ? 'space-between' : 'flex-end',
                                                width: window.innerWidth < 480 ? '100%' : 'auto'
                                            }}>
                                                <button
                                                    onClick={toggleServiceCharge}
                                                    disabled={isUpdatingServiceCharge || !cartData.cartId}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        gap: window.innerWidth < 768 ? '0.2rem' : '0.3rem',
                                                        padding: window.innerWidth < 1300 ? '0.2rem 0.4rem' : '0.3rem 0.6rem',
                                                        backgroundColor: serviceChargeStatus === "APPLICABLE" ? '#4caf50' : '#e53e3e',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '0.25rem',
                                                        fontSize: window.innerWidth < 768 ? '0.7rem' : '0.8rem',
                                                        fontWeight: '600',
                                                        cursor: (isUpdatingServiceCharge || !cartData.cartId) ? 'not-allowed' : 'pointer',
                                                        transition: 'all 0.2s ease',
                                                        opacity: (isUpdatingServiceCharge || !cartData.cartId) ? 0.7 : 1,
                                                        minWidth: window.innerWidth < 480 ? '60px' : 'auto',
                                                        minHeight: window.innerWidth < 768 ? '28px' : '32px'
                                                    }}
                                                    title={!cartData.cartId ? "Add items to cart first" : ""}
                                                    onMouseOver={(e) => {
                                                        if (!isUpdatingServiceCharge && cartData.cartId) {
                                                            e.target.style.backgroundColor = serviceChargeStatus === "APPLICABLE" ? '#3d8b40' : '#c53030';
                                                        }
                                                    }}
                                                    onMouseOut={(e) => {
                                                        if (!isUpdatingServiceCharge && cartData.cartId) {
                                                            e.target.style.backgroundColor = serviceChargeStatus === "APPLICABLE" ? '#4caf50' : '#e53e3e';
                                                        }
                                                    }}
                                                >
                                                    {isUpdatingServiceCharge ? (
                                                        '...'
                                                    ) : serviceChargeStatus === "APPLICABLE" ? (
                                                        'Remove'
                                                    ) : (
                                                        'Apply'
                                                    )}
                                                </button>

                                                <span style={{
                                                    minWidth: window.innerWidth < 768 ? '50px' : '60px',
                                                    textAlign: 'right',
                                                    fontSize: window.innerWidth < 1300 ? '0.85rem' : '1rem',
                                                    fontWeight: '500'
                                                }}>
                                                    ₹{cartData.serviceCharges?.toFixed(2) || '0.00'}
                                                </span>
                                            </div>
                                        </div>
                                    )}

                                    {cartData.gstTotal > 0 && (
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: window.innerWidth < 768 ? '0.6rem' : '0.75rem',
                                            fontSize: window.innerWidth < 1300 ? '0.85rem' : '1rem',
                                            color: '#4a5568'
                                        }}>
                                            <span>GST</span>
                                            <span>₹{cartData.gstTotal?.toFixed(2) || '0.00'}</span>
                                        </div>
                                    )}

                                    <div style={{
                                        borderTop: '1px solid #e2e8f0',
                                        margin: window.innerWidth < 768 ? '0.5rem 0' : '0.75rem 0'
                                    }}></div>

                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        fontSize: window.innerWidth < 1300 ? '0.90rem' : (window.innerHeight <= 700 ? '1rem' : '1.1rem'),
                                        fontWeight: '700',
                                        color: '#2d3748',
                                        paddingTop: window.innerWidth < 768 ? '0.3rem' : '0.5rem'
                                    }}>
                                        <span>Grand Total</span>
                                        <span style={{
                                            color: '#b15cd6',
                                            fontSize: window.innerWidth < 480 ? '0.95rem' : (
                                                window.innerWidth < 768 ? '1rem' : (
                                                    window.innerWidth < 1300 ? '0.9rem' : '1.3rem'
                                                )
                                            )
                                        }}>
                                            ₹{grandTotal.toFixed(2)}
                                        </span>
                                    </div>
                                </div>

                                <div style={{
                                    fontSize: window.innerWidth < 768 ? '0.7rem' : '0.8rem',
                                    color: '#718096',
                                    textAlign: 'center',
                                    marginTop: window.innerWidth < 768 ? '0.3rem' : '0.5rem',
                                    padding: window.innerWidth < 768 ? '0.3rem' : '0.5rem',
                                    backgroundColor: '#f7fafc',
                                    borderRadius: '0.25rem',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    {cartData.orderType === 'DINE_IN' ? 'Dine In Order' : 'Take Away Order'}
                                </div>
                            </div>
                        </div>

                        <div style={{
                            marginTop: '1rem',
                            padding: '1rem',
                            border: '1px solid #e2e8f0',
                            borderRadius: '0.25rem',
                            backgroundColor: 'white'
                        }}>
                            <div style={{
                                fontSize: window.innerWidth < 1300 ? '0.9rem' : '1rem',
                                fontWeight: '600',
                                color: '#2d3748',
                                marginBottom: '0.5rem'
                            }}>
                                Select Payment Method
                            </div>

                            <div style={{ display: 'flex', gap: '1rem' }}>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                    <input
                                        type="radio"
                                        name="payment"
                                        value="Cash"
                                        checked={selectedPaymentMethod === "Cash"}
                                        onChange={() => handlePaymentMethodChange("Cash")}
                                    />
                                    <span>Cash</span>
                                </label>

                                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                    <input
                                        type="radio"
                                        name="payment"
                                        value="Online_Payment"
                                        checked={selectedPaymentMethod === "Online_Payment"}
                                        onChange={() => handlePaymentMethodChange("Online_Payment")}
                                    />
                                    <span>Online</span>
                                </label>
                            </div>
                        </div>

                        {selectedPaymentMethod === "Cash" && (
                            <button
                                onClick={() => handlePlaceOrder("Cash")}
                                style={{
                                    width: '100%',
                                    backgroundColor: 'white',
                                    color: 'black',
                                    fontWeight: '700',
                                    fontSize: '1rem',
                                    padding: '12px',
                                    border: 'none',
                                    borderRadius: '0.5rem',
                                    marginTop: '1rem',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s ease'
                                }}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                onMouseOut={(e) => e.target.style.backgroundColor = 'white'}
                            >
                                Place Order
                            </button>
                        )}

                        {selectedPaymentMethod === "Online_Payment" && loading && (
                            <div style={{
                                textAlign: 'center',
                                padding: '1rem',
                                color: '#4a5568',
                                fontSize: '0.9rem'
                            }}>
                                Loading payment gateway...
                            </div>
                        )}
                    </>
                ) : (
                    <div className="empty-cart">
                        Cart is empty
                    </div>
                )}
            </div>
            <Modal
                isOpen={showRemoveConfirm}
                onRequestClose={cancelRemove}
                contentLabel="Remove Item Confirmation"
                style={{
                    overlay: {
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999
                    },
                    content: {
                        position: "relative",
                        top: "auto",
                        left: "auto",
                        right: "auto",
                        bottom: "auto",
                        width: "90%",
                        maxWidth: "400px",
                        margin: "0 auto",
                        border: "none",
                        borderRadius: "10px",
                        padding: "2rem",
                        textAlign: "center",
                        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)"
                    }
                }}
            >
                <div style={{ textAlign: "center" }}>
                    <h3 style={{
                        color: "#2d3748",
                        marginBottom: "1rem",
                        fontSize: "1.3rem"
                    }}>
                        Remove Item
                    </h3>
                    <p style={{
                        color: "#718096",
                        marginBottom: "2rem",
                        fontSize: "1rem",
                        lineHeight: "1.5"
                    }}>
                        Are you sure you want to remove<br />
                        <strong>"{itemToRemove?.cartItem?.dishName}"</strong><br />
                        from your cart?
                    </p>
                    <div style={{
                        display: "flex",
                        gap: "1rem",
                        justifyContent: "center"
                    }}>
                        <button
                            onClick={cancelRemove}
                            style={{
                                padding: "0.75rem 1.5rem",
                                border: "2px solid #e2e8f0",
                                background: "white",
                                color: "#4a5568",
                                borderRadius: "0.5rem",
                                cursor: "pointer",
                                fontWeight: "600",
                                fontSize: "1rem",
                                transition: "all 0.2s ease"
                            }}
                            onMouseOver={(e) => {
                                e.target.style.borderColor = "#b15cd6";
                                e.target.style.color = "#b15cd6";
                            }}
                            onMouseOut={(e) => {
                                e.target.style.borderColor = "#e2e8f0";
                                e.target.style.color = "#4a5568";
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={confirmRemove}
                            style={{
                                padding: "0.75rem 1.5rem",
                                border: "none",
                                background: "#e53e3e",
                                color: "white",
                                borderRadius: "0.5rem",
                                cursor: "pointer",
                                fontWeight: "600",
                                fontSize: "1rem",
                                transition: "all 0.2s ease"
                            }}
                            onMouseOver={(e) => {
                                e.target.style.background = "#c53030";
                            }}
                            onMouseOut={(e) => {
                                e.target.style.background = "#e53e3e";
                            }}
                        >
                            Remove
                        </button>
                    </div>
                </div>
            </Modal>

            {showCashPopup && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10000,
                    padding: '20px',
                }}>
                    <div style={{
                        backgroundColor: '#fff',
                        padding: '24px',
                        borderRadius: '10px',
                        width: '90%',
                        maxWidth: '450px',
                        boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
                        fontFamily: 'sans-serif',
                    }}>
                        <h3 style={{ marginBottom: '16px', fontSize: '18px' }}>
                            Enter Cash Payment Details
                        </h3>



                        <div style={{
                            marginBottom: '20px',
                            backgroundColor: '#f9f9f9',
                            padding: '16px',
                            borderRadius: '8px',
                            border: '1px solid #eee',
                        }}>
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: screenWidth < 768 ? "1fr" : "repeat(3, 1fr)",
                                gap: '10px 16px',
                            }}>
                                {[1, 2, 5, 10, 20, 50, 100, 200, 500].map((denom) => (
                                    <div key={denom} style={{ display: 'flex', alignItems: 'center', fontWeight: "bold" }}>
                                        <label style={{ width: '50px', fontSize: '16px' }}>₹{denom}</label>
                                        <input
                                            type="number"
                                            value={notesCount[denom] || ''}
                                            onChange={(e) => handleNotesChange(denom, e.target.value)}
                                            placeholder="0"
                                            style={{
                                                width: '60px',
                                                padding: '6px',
                                                borderRadius: '4px',
                                                border: '1px solid #ccc',
                                                fontSize: '14px',
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>

                            <div style={{
                                marginTop: '16px',
                                padding: '12px',
                                backgroundColor: '#fff',
                                borderRadius: '6px',
                                border: '1px solid #e0e0e0'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginBottom: '6px',
                                    fontSize: '14px'
                                }}>
                                    <span>Grand Total:</span>
                                    <strong style={{ color: '#2d3748' }}>₹{grandTotal.toFixed(2)}</strong>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginBottom: '6px',
                                    fontSize: '14px'
                                }}>
                                    <span>Denomination Total:</span>
                                    <strong style={{ color: '#2d3748' }}>₹{denominationTotal.toFixed(2)}</strong>
                                </div>

                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginBottom: '6px',
                                    fontSize: '14px'
                                }}>
                                    {remainingAmount >= 0 ? 'Return Amount:' : 'Remaining Amount:'}
                                    <strong style={{
                                        color: remainingAmount >= 0 ? '#4caf50' : '#f44336',
                                        fontWeight: 'bold'
                                    }}>
                                        {remainingAmount >= 0 ? '+' : ''}₹{Math.abs(remainingAmount).toFixed(2)}
                                    </strong>
                                </div>


                            </div>
                        </div>



                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
                            <button
                                style={{
                                    flex: 1,
                                    padding: '12px',
                                    backgroundColor: isSubmittingCash ? '#cccccc' : '#4caf50',
                                    border: 'none',
                                    borderRadius: '6px',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    fontSize: '16px',
                                    cursor: isSubmittingCash ? 'not-allowed' : 'pointer',
                                    transition: 'background-color 0.3s'
                                }}
                                onClick={handleCashPaymentSubmit}
                                disabled={!paidAmount || parseFloat(paidAmount) < grandTotal || isSubmittingCash}
                            >
                                {isSubmittingCash ? 'Processing...' : 'Submit Payment'}
                            </button>
                            <button
                                style={{
                                    flex: 1,
                                    padding: '12px',
                                    backgroundColor: '#f44336',
                                    border: 'none',
                                    borderRadius: '6px',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    fontSize: '16px',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s'
                                }}
                                onClick={() => {
                                    setShowCashPopup(false);
                                    setSelectedPaymentMethod("");
                                    setNotesCount({});
                                    setPaidAmount('');
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                .cart-item-box {
                    padding: 0.5rem 0.5rem;
                    border-bottom: 0px solid #e9ecef;
                }

                .cart-item-row {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 1rem;
                }

                .item-name-container {
                    flex: 2;
                    min-width: 0;
                }

                .item-name {
                    font-weight: 500;
                    color: #2d3748;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 100%;
                }

                .item-controls-container {
                    flex: 1;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    min-width: 150px;
                }

                .quantity-controls {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                }

                .quantity-btn {
                    width: 24px;
                    height: 24px;
                    border-radius: 4px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.2s ease;
                }

                .outline-btn {
                    border: 0px solid #b15cd6;
                    background: white;
                    color: #b15cd6;
                }

                .outline-btn:hover {
                    background: #b15cd6;
                    color: white;
                }

                .quantity-display {
                    min-width: 20px;
                    text-align: center;
                    font-weight: 600;
                    color: #2d3748;
                }

                .item-price {
                    font-weight: 600;
                    color: #2d3748;
                    min-width: 0px;
                    text-align: right;
                }

                .cart-content-container {
                    flex: 1;
                    overflow-y: auto;
                    padding-right: 4px;
                }

                .hide-scrollbar::-webkit-scrollbar {
                    width: 4px;
                }

                .hide-scrollbar::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }

                .hide-scrollbar::-webkit-scrollbar-thumb {
                    background: #b15cd6;
                    border-radius: 4px;
                }

                .empty-cart {
                    text-align: center;
                    padding: 3rem 1rem;
                    color: #718096;
                    font-size: 1.1rem;
                    background: white;
                    border-radius: 0.5rem;
                    border: 1px solid #e9ecef;
                }

                .total-section {
                    padding: 1rem;
                    border-top: 0px solid #e9ecef;
                }

                @media (max-width: 1399px) {
                .total-section {
                    padding: 0.5rem;
                    border-top: 0px solid #e9ecef;
                }
                    .cart-item-row {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 0.5rem;
                    }

                    .item-name-container {
                        width: 100%;
                        margin-bottom: 0rem;
                    }

                    .item-name {
                        font-size: 13px;
                        width: 100%;
                    }

                    .item-controls-container {
                        width: 100%;
                        justify-content: space-between;
                        min-width: auto;
                    }

                    .quantity-controls {
                        margin-left: 0;
                    }

                    .quantity-btn {
                        width: 22px;
                        height: 22px;
                    }

                    .quantity-icon {
                        width: 9px;
                        height: 9px;
                    }

                    .quantity-display {
                        font-size: 13px;
                        min-width: 18px;
                    }

                    .item-price {
                        font-size: 13px;
                        min-width: 0px;
                        text-align: right;
                        margin-left: auto;
                    }
                }

                @media (max-width: 768px) {
                    .cart-item-box {
                        padding: 0.5rem;
                    }

                    .quantity-btn {
                        width: 20px;
                        height: 20px;
                    }

                    .quantity-icon {
                        width: 8px;
                        height: 8px;
                    }

                    .quantity-display {
                        min-width: 16px;
                        font-size: 12px;
                    }

                    .item-price {
                        min-width: 0px;
                        font-size: 12px;
                    }

                    .item-name {
                        font-size: 12px;
                    }
                }
                    @media(max-width:1200px) {
                    .endalign{
                    text-align:end;
                    }
                    }
            `}</style>
            <style>{`
    

    .cart-item-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
    }

    .item-name-container {
        flex: 2;
        min-width: 0;
    }

    .item-name {
        font-weight: 500;
        color: #2d3748;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
        font-size: 0.9rem;
    }

    .item-controls-container {
        flex: 2;
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-width: 180px;
    }

    .quantity-controls {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0rem;
    }

    .quantity-btn {
        width: 26px;
        height: 26px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .outline-btn {
        border: 0px solid #b15cd6;
        background: white;
        color: #b15cd6;
    }

    .outline-btn:hover {
        background: #b15cd6;
        color: white;
    }

    .quantity-display {
        min-width: 25px;
        text-align: center;
        font-weight: 600;
        color: #2d3748;
        font-size: 0.9rem;
    }

    .item-price {
        flex: 1;
        font-weight: 600;
        color: #2d3748;
        text-align: right;
        font-size: 0.9rem;
    }

    /* Responsive for screens < 1399px */
    @media (max-width: 1399px) {
        
        
        .cart-item-row {
            flex-direction: row;
            justify-content: space-between;
            gap: 0.75rem;
        }

        .item-name-container {
            flex: 1;
            min-width: 0;
        }

        .item-name {
            font-size: 0.85rem;
            white-space: normal;
            line-height: 1.3;
        }

        .item-controls-container {
            flex-direction: row;
            align-items: center;
            
            min-width: 120px;
        }

        .quantity-controls {
            justify-content: center;
        }

        .quantity-btn {
            width: 24px;
            height: 24px;
        }

        .quantity-icon {
            width: 10px;
            height: 10px;
        }

        .quantity-display {
            min-width: 22px;
            font-size: 0.85rem;
        }

        .item-price {
            text-align: right;
            font-size: 0.85rem;
            min-width: 0px;
        }
    }

    /* For very small screens */
    @media (max-width: 768px) {
        .cart-item-box {
            padding: 0.5rem;
        }

        .cart-item-row {
            gap: 0.5rem;
        }

        .item-name {
            font-size: 0.8rem;
        }

        .item-controls-container {
            gap: 0.5rem;
            min-width: 100px;
        }

        .quantity-btn {
            width: 22px;
            height: 22px;
        }

        .quantity-display {
            min-width: 20px;
            font-size: 0.8rem;
        }

        .item-price {
            font-size: 0.8rem;
            min-width: 0px;
        }
    }
`}</style>
        </div>
    );
};

export default MenuCartSidebar;


